/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v1.0.0`
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddTradeListingCapacityRequestDto,
  AuthBuyerRequestDto,
  AuthSupplierRequestDto,
  BulkActiveDto,
  BulkPriceDto,
  CancelContractRequestDto,
  CancelStorefrontOrderDto,
  CancelStorefrontSubscriptionDto,
  CloseTradeRoomRequestDto,
  CmarketAiBidWorkRequestDto,
  CmarketAwardRequestDto,
  CmarketBidAnnounceDto,
  CmarketBidSyncDto,
  CmarketCardPaymentCallbackDto,
  CmarketCreateMasterItemDto,
  CmarketDirectoryBatchDto,
  CmarketEnsureReagentItemDto,
  CmarketFeeBillPaidDto,
  CmarketKeywordStatsBatchDto,
  CmarketLineResolveDto,
  CmarketMasterItemNamesDto,
  CmarketTaxInvoiceCallbackDto,
  CompleteInspectionDto,
  ContractShipmentBulkRegisterDto,
  CreateExternalQuoteRequestWithAddressDto,
  CreateOfferingRequestDto,
  CreateReviewDto,
  CreateShareLinkDto,
  CreateStorefrontOrderDto,
  CreateStorefrontQuoteDto,
  CreateStorefrontSubscriptionDto,
  CreateSupplierItemEditRequestDto,
  CreateSupplierItemRequestDto,
  CreateTradeListingRequestDto,
  CreateTradeProjectRequestDto,
  CreateTradeProposalRequestDto,
  CreateTradeRfqRequestDto,
  CreateTradeRoomRequestDto,
  CreateTradeRoomV2RequestDto,
  CreateWebhookSubscriptionDto,
  DecideTradeProposalRequestDto,
  DeclineMallUnitDto,
  EditInspectionLineDto,
  EmbedJoinRequestDto,
  EmbedTokenVerifyRequestDto,
  ExpireTradeListingsRequestDto,
  ExtendExternalQuoteRequestDeadlineDto,
  ExternalAccountStatusControllerUpdateStatus200,
  ExternalAdminChatControllerFindMessages200,
  ExternalAdminChatControllerFindMessagesParams,
  ExternalAdminChatControllerFindRooms200,
  ExternalAdminChatControllerFindRoomsParams,
  ExternalAdminParticipationsControllerHide200,
  ExternalAdminParticipationsControllerRemove200,
  ExternalAdminParticipationsControllerUnhide200,
  ExternalAdminQuoteRequestsControllerDeleteOne200,
  ExternalAdminQuoteRequestsControllerFindAll200,
  ExternalAdminQuoteRequestsControllerFindAllParams,
  ExternalAdminQuoteRequestsControllerRestoreOne200,
  ExternalBuyersControllerAuthenticateBuyer201,
  ExternalCategoriesControllerGetCategoryTree200,
  ExternalCategoriesControllerGetCategoryTreeParams,
  ExternalCmarketAiBidControllerWork200,
  ExternalCmarketAwardsControllerReceive200,
  ExternalCmarketBidsControllerAnnounce200,
  ExternalCmarketBidsControllerCreateMasterItem201,
  ExternalCmarketBidsControllerEnsureReagentItem200,
  ExternalCmarketBidsControllerMasterCategories200,
  ExternalCmarketBidsControllerMasterCategoriesParams,
  ExternalCmarketBidsControllerMasterItemNames200,
  ExternalCmarketBidsControllerResolveLines200,
  ExternalCmarketBidsControllerSync200,
  ExternalCmarketContractsControllerListConcluded200,
  ExternalCmarketContractsControllerListConcludedParams,
  ExternalCmarketDirectoryControllerReceive200,
  ExternalCmarketFeeBillsControllerApplyPaid200,
  ExternalCmarketInspectionLinkControllerLink200,
  ExternalCmarketKeywordStatsControllerReceive200,
  ExternalContractsControllerGetContract200,
  ExternalContractsControllerGetContracts200,
  ExternalContractsControllerGetMyContracts200,
  ExternalContractsControllerGetMyContractsParams,
  ExternalContractsControllerGetSettlements200,
  ExternalContractsControllerListShipments200,
  ExternalContractsControllerRegisterShipment201,
  ExternalContractsControllerRegisterShipmentsBulk200,
  ExternalContractsControllerRequestCancellation200,
  ExternalContractsControllerSyncShipment200,
  ExternalContractsControllerUpdateShipment200,
  ExternalEmbedControllerGenerateAlimTalkLinks201,
  ExternalEmbedControllerGetEmbedUrl201,
  ExternalEmbedControllerVerifyEmbedToken200,
  ExternalFilesControllerUploadTemporaryFiles201,
  ExternalFilesControllerUploadTemporaryFilesBody,
  ExternalInsurerBidRecordsControllerIngest200,
  ExternalItemSearchControllerMatch200,
  ExternalItemSearchControllerSearch200,
  ExternalItemSearchControllerSearchParams,
  ExternalItemsControllerCreateEditRequest201,
  ExternalItemsControllerCreateRequest201,
  ExternalItemsControllerGetItems200,
  ExternalItemsControllerGetItemsParams,
  ExternalItemsControllerGetMyEditRequests200,
  ExternalItemsControllerGetMyEditRequestsParams,
  ExternalItemsControllerGetMyRequests200,
  ExternalItemsControllerGetMyRequestsParams,
  ExternalItemsControllerResubmitEditRequest200,
  ExternalItemsControllerResubmitRequest200,
  ExternalItemsControllerUpdateSettings200,
  ExternalItemsControllerUploadEditRequestImage201,
  ExternalItemsControllerUploadEditRequestImageBody,
  ExternalPaymentsControllerConfirmCardPayment201,
  ExternalPriceObservationsControllerReceive200,
  ExternalPriceObservationsControllerUpdateStatus200,
  ExternalPriceRequestDemandControllerPage200,
  ExternalPriceRequestDemandControllerPageParams,
  ExternalQuoteLineMatchRequestDto,
  ExternalQuoteRequestsControllerCreateWithAddress201,
  ExternalQuoteRequestsControllerExtendDeadline200,
  ExternalQuoteRequestsControllerFindAll200,
  ExternalQuoteRequestsControllerFindAllParams,
  ExternalQuoteRequestsControllerFindContractDocuments200,
  ExternalQuoteRequestsControllerFindMine200,
  ExternalQuoteRequestsControllerFindMineParams,
  ExternalQuoteRequestsControllerFindModifications200,
  ExternalQuoteRequestsControllerFindOne200,
  ExternalQuoteRequestsControllerFindResponded200,
  ExternalQuoteRequestsControllerFindRespondedParams,
  ExternalQuoteRequestsControllerUpdateOne200,
  ExternalShareLinksControllerCreate201,
  ExternalShareLinksControllerGet200,
  ExternalShareLinksControllerList200,
  ExternalShareLinksControllerListParams,
  ExternalShareLinksControllerReissue201,
  ExternalShareLinksControllerRevoke200,
  ExternalStockControllerCancelTransaction200,
  ExternalStockControllerCreateTransactions200,
  ExternalStockControllerListTransactions200,
  ExternalStockControllerListTransactionsParams,
  ExternalStockControllerPreviewTransactions200,
  ExternalStockControllerPriceContext200,
  ExternalStorefrontControllerGetCategories200,
  ExternalStorefrontControllerGetItem200,
  ExternalStorefrontControllerGetItemOffers200,
  ExternalStorefrontControllerGetItems200,
  ExternalStorefrontControllerGetItemsParams,
  ExternalStorefrontOrdersControllerApplyRequisition200,
  ExternalStorefrontOrdersControllerCancelOrder200,
  ExternalStorefrontOrdersControllerCompleteInspection200,
  ExternalStorefrontOrdersControllerCreateOrder201,
  ExternalStorefrontOrdersControllerGetInspection200,
  ExternalStorefrontOrdersControllerGetOrder200,
  ExternalStorefrontOrdersControllerGetPointBalance200,
  ExternalStorefrontOrdersControllerListOrders200,
  ExternalStorefrontOrdersControllerListOrdersParams,
  ExternalStorefrontPaymentOptionsControllerGetPaymentOptions200,
  ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  ExternalStorefrontQuotesControllerCreateQuote201,
  ExternalStorefrontQuotesControllerGetQuote200,
  ExternalStorefrontQuotesControllerGetQuoteParams,
  ExternalStorefrontQuotesControllerListQuotes200,
  ExternalStorefrontQuotesControllerListQuotesParams,
  ExternalStorefrontReactionsControllerAddWish200,
  ExternalStorefrontReactionsControllerAlerts200,
  ExternalStorefrontReactionsControllerAlertsParams,
  ExternalStorefrontReactionsControllerListWishes200,
  ExternalStorefrontReactionsControllerListWishesParams,
  ExternalStorefrontReactionsControllerRanking200,
  ExternalStorefrontReactionsControllerRankingParams,
  ExternalStorefrontReactionsControllerRemoveWish200,
  ExternalStorefrontReactionsControllerRemoveWishParams,
  ExternalStorefrontReactionsControllerSignals200,
  ExternalStorefrontReviewsControllerCreate201,
  ExternalStorefrontReviewsControllerHelpful200,
  ExternalStorefrontReviewsControllerList200,
  ExternalStorefrontReviewsControllerListParams,
  ExternalStorefrontReviewsControllerRemove200,
  ExternalStorefrontReviewsControllerReport200,
  ExternalStorefrontSubscriptionsControllerCancel200,
  ExternalStorefrontSubscriptionsControllerGetMine200,
  ExternalStorefrontSubscriptionsControllerGetMineParams,
  ExternalStorefrontSubscriptionsControllerListMine200,
  ExternalStorefrontSubscriptionsControllerListMineParams,
  ExternalStorefrontSubscriptionsControllerListPlans200,
  ExternalStorefrontSubscriptionsControllerPause200,
  ExternalStorefrontSubscriptionsControllerResume200,
  ExternalStorefrontSubscriptionsControllerRetryPayment200,
  ExternalStorefrontSubscriptionsControllerSubscribe201,
  ExternalStorefrontSubscriptionsControllerUpdate200,
  ExternalSupplierMallUnitsControllerAccept200,
  ExternalSupplierMallUnitsControllerDecline200,
  ExternalSupplierMallUnitsControllerGet200,
  ExternalSupplierMallUnitsControllerList200,
  ExternalSupplierMallUnitsControllerListParams,
  ExternalSupplierShipmentsControllerFindMallOrder200,
  ExternalSupplierShipmentsControllerList200,
  ExternalSupplierShipmentsControllerListCouriers200,
  ExternalSupplierShipmentsControllerListMyTargets200,
  ExternalSupplierShipmentsControllerRegister201,
  ExternalSupplierShipmentsControllerRegisterBulk200,
  ExternalSupplierShipmentsControllerUpdateStatus200,
  ExternalSupplierStorefrontsControllerBulkSetActive200,
  ExternalSupplierStorefrontsControllerBulkSetPrices200,
  ExternalSupplierStorefrontsControllerListMine200,
  ExternalSupplierStorefrontsControllerListMyOfferings200,
  ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  ExternalSupplierStorefrontsControllerListMyPrices200,
  ExternalSupplierStorefrontsControllerListMyPricesParams,
  ExternalSupplierStorefrontsControllerListMyRequests200,
  ExternalSupplierStorefrontsControllerListMyRequestsParams,
  ExternalSupplierStorefrontsControllerRequestOffering201,
  ExternalSupplierStorefrontsControllerSetPrice200,
  ExternalSuppliersControllerAuthenticateSupplier201,
  ExternalSuppliersControllerGetSupplierSettings200,
  ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200,
  ExternalTradeControllerCloseRoom200,
  ExternalTradeControllerCreateEmbedUrl200,
  ExternalTradeControllerCreateProject200,
  ExternalTradeControllerCreateRoom200,
  ExternalTradeControllerGetProject200,
  ExternalTradeControllerGlossary200,
  ExternalTradeControllerListProjects200,
  ExternalTradeControllerListProjectsParams,
  ExternalTradeControllerListRoomsOfProject200,
  ExternalTradeControllerListRoomsOfProjectParams,
  ExternalTradeControllerReconcileProjects200,
  ExternalTradeControllerReconcileProjectsParams,
  ExternalTradeControllerReconcileRooms200,
  ExternalTradeControllerReconcileRoomsParams,
  ExternalTradeControllerReconcileTranslations200,
  ExternalTradeControllerReconcileTranslationsParams,
  ExternalTradeControllerReplaceProject200,
  ExternalTradeControllerRetranslate200,
  ExternalTradeControllerUpdateProject200,
  ExternalTradeDomainControllerActiveListings200,
  ExternalTradeDomainControllerActiveListingsParams,
  ExternalTradeDomainControllerAddCapacity200,
  ExternalTradeDomainControllerAdminCompanies200,
  ExternalTradeDomainControllerAdminCompaniesParams,
  ExternalTradeDomainControllerBlockedBetween200,
  ExternalTradeDomainControllerBlockedBetweenParams,
  ExternalTradeDomainControllerCloseListing200,
  ExternalTradeDomainControllerCloseRfq200,
  ExternalTradeDomainControllerCompaniesBatch200,
  ExternalTradeDomainControllerCompaniesBatchParams,
  ExternalTradeDomainControllerCompanyBySlug200,
  ExternalTradeDomainControllerCreateListing200,
  ExternalTradeDomainControllerCreateProposal200,
  ExternalTradeDomainControllerCreateRfq200,
  ExternalTradeDomainControllerDecideProposal200,
  ExternalTradeDomainControllerEmbed200,
  ExternalTradeDomainControllerEndedListings200,
  ExternalTradeDomainControllerEndedListingsParams,
  ExternalTradeDomainControllerExpireDue200,
  ExternalTradeDomainControllerJoinWaitlist200,
  ExternalTradeDomainControllerListProposals200,
  ExternalTradeDomainControllerListProposalsParams,
  ExternalTradeDomainControllerListRfqs200,
  ExternalTradeDomainControllerListRfqsParams,
  ExternalTradeDomainControllerListing200,
  ExternalTradeDomainControllerMyCompany200,
  ExternalTradeDomainControllerMyListings200,
  ExternalTradeDomainControllerMyListingsParams,
  ExternalTradeDomainControllerMyRfqCount200,
  ExternalTradeDomainControllerMyRfqCountParams,
  ExternalTradeDomainControllerMyRfqs200,
  ExternalTradeDomainControllerMyRfqsParams,
  ExternalTradeDomainControllerMyRooms200,
  ExternalTradeDomainControllerMyRoomsParams,
  ExternalTradeDomainControllerMySeat200,
  ExternalTradeDomainControllerMyWaitlist200,
  ExternalTradeDomainControllerOpenPublicRfqCount200,
  ExternalTradeDomainControllerOpenRoom200,
  ExternalTradeDomainControllerOpenSeats200,
  ExternalTradeDomainControllerProposal200,
  ExternalTradeDomainControllerPublishedCompanies200,
  ExternalTradeDomainControllerPublishedCompaniesParams,
  ExternalTradeDomainControllerReceivedProposalCount200,
  ExternalTradeDomainControllerReceivedProposalCountParams,
  ExternalTradeDomainControllerReceivedProposals200,
  ExternalTradeDomainControllerReceivedProposalsParams,
  ExternalTradeDomainControllerRfqDetail200,
  ExternalTradeDomainControllerRfqDetailParams,
  ExternalTradeDomainControllerRoom200,
  ExternalTradeDomainControllerSendMessage200,
  ExternalTradeDomainControllerSetPublication200,
  ExternalTradeDomainControllerSubmitQuote200,
  ExternalTradeDomainControllerTakeSeat200,
  ExternalTradeDomainControllerUnread200,
  ExternalTradeDomainControllerUnreadParams,
  ExternalTradeDomainControllerUpsertMyCompany200,
  ExternalWebhooksControllerCreate201,
  ExternalWebhooksControllerList200,
  ExternalWebhooksControllerListDeliveries200,
  ExternalWebhooksControllerListDeliveriesParams,
  ExternalWebhooksControllerRetry200,
  ExternalWebhooksControllerRotateSecret200,
  ExternalWebhooksControllerSendTest200,
  ExternalWebhooksControllerUpdate200,
  GenerateAlimTalkLinksRequestDto,
  InsurerBidRecordsBatchDto,
  ItemBarcodeControllerList200,
  ItemBarcodeControllerLookup200,
  ItemBarcodeControllerLookupParams,
  ItemBarcodeControllerRegister201,
  ItemSignalsRequestDto,
  JoinTradeWaitlistRequestDto,
  PriceObservationBatchDto,
  PriceObservationStatusDto,
  ReactionOwnerBodyDto,
  RecordItemViewDto,
  RegisterCmarketAwardShipmentDto,
  RegisterContractShipmentDto,
  RegisterItemBarcodeDto,
  RegisterShipmentDto,
  ReplaceTradeProjectRequestDto,
  RequisitionedStorefrontOrderDto,
  ResubmitSupplierItemEditRequestDto,
  ResubmitSupplierItemRequestDto,
  ReviewHelpfulDto,
  ReviewReportDto,
  SendTradeRoomMessageRequestDto,
  SetStorefrontPriceDto,
  SetTradeCompanyPublicationRequestDto,
  ShipmentBulkRegisterDto,
  StockTransactionBatchDto,
  SubmitInspectionDto,
  SubscriptionOwnerDto,
  SupplierCmarketAwardsControllerByRef200,
  SupplierCmarketAwardsControllerByRefParams,
  SupplierCmarketAwardsControllerListMine200,
  SupplierCmarketAwardsControllerRegister201,
  SupplierStorefrontReactionsControllerMine200,
  TradeEmbedRequestDto,
  UpdateBuyerMeDto,
  UpdateContractShipmentDto,
  UpdateExternalAccountStatusDto,
  UpdateExternalQuoteRequestDto,
  UpdateShipmentStatusDto,
  UpdateStorefrontSubscriptionDto,
  UpdateSupplierItemSettingsDto,
  UpdateSupplierMeDto,
  UpdateTradeProjectRequestDto,
  UpdateWebhookSubscriptionDto,
  UploadInspectionPhotoDto,
  UpsertTradeCompanyRequestDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * C-Market 마켓플레이스에서 공급자를 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다.
 * @summary C-Market 공급자 자동 인증 및 세션 생성
 */
export const externalSuppliersControllerAuthenticateSupplier = (
  authSupplierRequestDto: BodyType<AuthSupplierRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSuppliersControllerAuthenticateSupplier201>({
    url: `/external/suppliers/auth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: authSupplierRequestDto,
    signal,
  });
};

export const getExternalSuppliersControllerAuthenticateSupplierMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      TError,
      { data: BodyType<AuthSupplierRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>,
    TError,
    { data: BodyType<AuthSupplierRequestDto> },
    TContext
  > => {
    const mutationKey = ["externalSuppliersControllerAuthenticateSupplier"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      { data: BodyType<AuthSupplierRequestDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalSuppliersControllerAuthenticateSupplier(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSuppliersControllerAuthenticateSupplierMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>
  >;
export type ExternalSuppliersControllerAuthenticateSupplierMutationBody =
  BodyType<AuthSupplierRequestDto>;
export type ExternalSuppliersControllerAuthenticateSupplierMutationError =
  ErrorType<unknown>;

/**
 * @summary C-Market 공급자 자동 인증 및 세션 생성
 */
export const useExternalSuppliersControllerAuthenticateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>
      >,
      TError,
      { data: BodyType<AuthSupplierRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSuppliersControllerAuthenticateSupplier>>,
  TError,
  { data: BodyType<AuthSupplierRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSuppliersControllerAuthenticateSupplierMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 공급자 설정 읽기 — 자동견적·알림톡(판매자 화면 스위치가 늘 최신 값을 그리도록)
 */
export const externalSuppliersControllerGetSupplierSettings = (
  signal?: AbortSignal,
) => {
  return api<ExternalSuppliersControllerGetSupplierSettings200>({
    url: `/external/suppliers/me/settings`,
    method: "GET",
    signal,
  });
};

export const getExternalSuppliersControllerGetSupplierSettingsQueryKey = () => {
  return [`/external/suppliers/me/settings`] as const;
};

export const getExternalSuppliersControllerGetSupplierSettingsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSuppliersControllerGetSupplierSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierSettings>>
  > = ({ signal }) => externalSuppliersControllerGetSupplierSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSuppliersControllerGetSupplierSettingsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSuppliersControllerGetSupplierSettings>>
  >;
export type ExternalSuppliersControllerGetSupplierSettingsQueryError =
  ErrorType<unknown>;

export function useExternalSuppliersControllerGetSupplierSettings<
  TData = Awaited<
    ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSuppliersControllerGetSupplierSettings<
  TData = Awaited<
    ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSuppliersControllerGetSupplierSettings<
  TData = Awaited<
    ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 설정 읽기 — 자동견적·알림톡(판매자 화면 스위치가 늘 최신 값을 그리도록)
 */

export function useExternalSuppliersControllerGetSupplierSettings<
  TData = Awaited<
    ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSuppliersControllerGetSupplierSettings>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSuppliersControllerGetSupplierSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 공급자 설정 변경
 */
export const externalSuppliersControllerUpdateSupplierMe = (
  updateSupplierMeDto: BodyType<UpdateSupplierMeDto>,
) => {
  return api<void>({
    url: `/external/suppliers/me`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateSupplierMeDto,
  });
};

export const getExternalSuppliersControllerUpdateSupplierMeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
    TError,
    { data: BodyType<UpdateSupplierMeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
  TError,
  { data: BodyType<UpdateSupplierMeDto> },
  TContext
> => {
  const mutationKey = ["externalSuppliersControllerUpdateSupplierMe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
    { data: BodyType<UpdateSupplierMeDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalSuppliersControllerUpdateSupplierMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSuppliersControllerUpdateSupplierMeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>
  >;
export type ExternalSuppliersControllerUpdateSupplierMeMutationBody =
  BodyType<UpdateSupplierMeDto>;
export type ExternalSuppliersControllerUpdateSupplierMeMutationError =
  ErrorType<unknown>;

/**
 * @summary 공급자 설정 변경
 */
export const useExternalSuppliersControllerUpdateSupplierMe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
      TError,
      { data: BodyType<UpdateSupplierMeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSuppliersControllerUpdateSupplierMe>>,
  TError,
  { data: BodyType<UpdateSupplierMeDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSuppliersControllerUpdateSupplierMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 외부 파트너 시스템에서 발주기관(구매사)을 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다. 외부 파트너 검증을 신뢰하므로 별도 NICE 인증 없이 즉시 견적요청 등 NICE-게이트 API를 사용할 수 있습니다.
 * @summary 발주기관(구매사) 자동 인증 및 세션 생성
 */
export const externalBuyersControllerAuthenticateBuyer = (
  authBuyerRequestDto: BodyType<AuthBuyerRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalBuyersControllerAuthenticateBuyer201>({
    url: `/external/buyers/auth`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: authBuyerRequestDto,
    signal,
  });
};

export const getExternalBuyersControllerAuthenticateBuyerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
    TError,
    { data: BodyType<AuthBuyerRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
  TError,
  { data: BodyType<AuthBuyerRequestDto> },
  TContext
> => {
  const mutationKey = ["externalBuyersControllerAuthenticateBuyer"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
    { data: BodyType<AuthBuyerRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalBuyersControllerAuthenticateBuyer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalBuyersControllerAuthenticateBuyerMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>
  >;
export type ExternalBuyersControllerAuthenticateBuyerMutationBody =
  BodyType<AuthBuyerRequestDto>;
export type ExternalBuyersControllerAuthenticateBuyerMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관(구매사) 자동 인증 및 세션 생성
 */
export const useExternalBuyersControllerAuthenticateBuyer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
      TError,
      { data: BodyType<AuthBuyerRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalBuyersControllerAuthenticateBuyer>>,
  TError,
  { data: BodyType<AuthBuyerRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalBuyersControllerAuthenticateBuyerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 구매사 설정 변경
 */
export const externalBuyersControllerUpdateBuyerMe = (
  updateBuyerMeDto: BodyType<UpdateBuyerMeDto>,
) => {
  return api<void>({
    url: `/external/buyers/me`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateBuyerMeDto,
  });
};

export const getExternalBuyersControllerUpdateBuyerMeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
    TError,
    { data: BodyType<UpdateBuyerMeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
  TError,
  { data: BodyType<UpdateBuyerMeDto> },
  TContext
> => {
  const mutationKey = ["externalBuyersControllerUpdateBuyerMe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
    { data: BodyType<UpdateBuyerMeDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalBuyersControllerUpdateBuyerMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalBuyersControllerUpdateBuyerMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>
>;
export type ExternalBuyersControllerUpdateBuyerMeMutationBody =
  BodyType<UpdateBuyerMeDto>;
export type ExternalBuyersControllerUpdateBuyerMeMutationError =
  ErrorType<unknown>;

/**
 * @summary 구매사 설정 변경
 */
export const useExternalBuyersControllerUpdateBuyerMe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
      TError,
      { data: BodyType<UpdateBuyerMeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalBuyersControllerUpdateBuyerMe>>,
  TError,
  { data: BodyType<UpdateBuyerMeDto> },
  TContext
> => {
  const mutationOptions =
    getExternalBuyersControllerUpdateBuyerMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Embed Token(OTT)을 검증하고 세션으로 교환합니다. 공급사/발주기관 둘 다 지원.
 * @summary Embed 토큰 검증 및 세션 교환
 */
export const externalEmbedControllerVerifyEmbedToken = (
  embedTokenVerifyRequestDto: BodyType<EmbedTokenVerifyRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerVerifyEmbedToken200>({
    url: `/external/embed/verify`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: embedTokenVerifyRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerVerifyEmbedTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
    TError,
    { data: BodyType<EmbedTokenVerifyRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
  TError,
  { data: BodyType<EmbedTokenVerifyRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerVerifyEmbedToken"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
    { data: BodyType<EmbedTokenVerifyRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerVerifyEmbedToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerVerifyEmbedTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>
>;
export type ExternalEmbedControllerVerifyEmbedTokenMutationBody =
  BodyType<EmbedTokenVerifyRequestDto>;
export type ExternalEmbedControllerVerifyEmbedTokenMutationError =
  ErrorType<unknown>;

/**
 * @summary Embed 토큰 검증 및 세션 교환
 */
export const useExternalEmbedControllerVerifyEmbedToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
      TError,
      { data: BodyType<EmbedTokenVerifyRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerVerifyEmbedToken>>,
  TError,
  { data: BodyType<EmbedTokenVerifyRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerVerifyEmbedTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알림톡 링크 생성 (테스트용)
 */
export const externalEmbedControllerGenerateAlimTalkLinks = (
  generateAlimTalkLinksRequestDto: BodyType<GenerateAlimTalkLinksRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerGenerateAlimTalkLinks201>({
    url: `/external/alimtalk/links`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateAlimTalkLinksRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerGenerateAlimTalkLinksMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
    TError,
    { data: BodyType<GenerateAlimTalkLinksRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
  TError,
  { data: BodyType<GenerateAlimTalkLinksRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerGenerateAlimTalkLinks"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
    { data: BodyType<GenerateAlimTalkLinksRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerGenerateAlimTalkLinks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerGenerateAlimTalkLinksMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>
  >;
export type ExternalEmbedControllerGenerateAlimTalkLinksMutationBody =
  BodyType<GenerateAlimTalkLinksRequestDto>;
export type ExternalEmbedControllerGenerateAlimTalkLinksMutationError =
  ErrorType<unknown>;

/**
 * @summary 알림톡 링크 생성 (테스트용)
 */
export const useExternalEmbedControllerGenerateAlimTalkLinks = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
      TError,
      { data: BodyType<GenerateAlimTalkLinksRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerGenerateAlimTalkLinks>>,
  TError,
  { data: BodyType<GenerateAlimTalkLinksRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerGenerateAlimTalkLinksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 인증된 사용자의 역할(공급사 또는 발주기관)에 따라 적절한 Embed URL을 생성합니다.
 * @summary Embed URL 생성 (공급사 / 발주기관 공통)
 */
export const externalEmbedControllerGetEmbedUrl = (
  embedJoinRequestDto: BodyType<EmbedJoinRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalEmbedControllerGetEmbedUrl201>({
    url: `/external/embed/join`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: embedJoinRequestDto,
    signal,
  });
};

export const getExternalEmbedControllerGetEmbedUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
    TError,
    { data: BodyType<EmbedJoinRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
  TError,
  { data: BodyType<EmbedJoinRequestDto> },
  TContext
> => {
  const mutationKey = ["externalEmbedControllerGetEmbedUrl"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
    { data: BodyType<EmbedJoinRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalEmbedControllerGetEmbedUrl(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalEmbedControllerGetEmbedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>
>;
export type ExternalEmbedControllerGetEmbedUrlMutationBody =
  BodyType<EmbedJoinRequestDto>;
export type ExternalEmbedControllerGetEmbedUrlMutationError =
  ErrorType<unknown>;

/**
 * @summary Embed URL 생성 (공급사 / 발주기관 공통)
 */
export const useExternalEmbedControllerGetEmbedUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
      TError,
      { data: BodyType<EmbedJoinRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalEmbedControllerGetEmbedUrl>>,
  TError,
  { data: BodyType<EmbedJoinRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalEmbedControllerGetEmbedUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 카테고리 계층 구조를 트리 형태로 조회합니다.
 * @summary 카테고리 트리 조회 (공급자용)
 */
export const externalCategoriesControllerGetCategoryTree = (
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  signal?: AbortSignal,
) => {
  return api<ExternalCategoriesControllerGetCategoryTree200>({
    url: `/external/categories/tree`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalCategoriesControllerGetCategoryTreeQueryKey = (
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
) => {
  return [`/external/categories/tree`, ...(params ? [params] : [])] as const;
};

export const getExternalCategoriesControllerGetCategoryTreeQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalCategoriesControllerGetCategoryTreeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>
  > = ({ signal }) =>
    externalCategoriesControllerGetCategoryTree(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalCategoriesControllerGetCategoryTreeQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>
  >;
export type ExternalCategoriesControllerGetCategoryTreeQueryError =
  ErrorType<unknown>;

export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalCategoriesControllerGetCategoryTreeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCategoriesControllerGetCategoryTree>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 카테고리 트리 조회 (공급자용)
 */

export function useExternalCategoriesControllerGetCategoryTree<
  TData = Awaited<
    ReturnType<typeof externalCategoriesControllerGetCategoryTree>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCategoriesControllerGetCategoryTreeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalCategoriesControllerGetCategoryTree>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalCategoriesControllerGetCategoryTreeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 공급자 대시보드에서 사용하는 물품 목록 조회 API입니다.
 * @summary 📦 카테고리별 물품 조회 (공급자용)
 */
export const externalItemsControllerGetItems = (
  params?: ExternalItemsControllerGetItemsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerGetItems200>({
    url: `/external/items`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemsControllerGetItemsQueryKey = (
  params?: ExternalItemsControllerGetItemsParams,
) => {
  return [`/external/items`, ...(params ? [params] : [])] as const;
};

export const getExternalItemsControllerGetItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemsControllerGetItemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemsControllerGetItems>>
  > = ({ signal }) => externalItemsControllerGetItems(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemsControllerGetItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerGetItems>>
>;
export type ExternalItemsControllerGetItemsQueryError = ErrorType<unknown>;

export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalItemsControllerGetItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 📦 카테고리별 물품 조회 (공급자용)
 */

export function useExternalItemsControllerGetItems<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemsControllerGetItemsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 물품에 대한 나의 공급가 및 판매 상태를 업데이트합니다.
 * @summary ⚙️ 물품별 공급자 설정 업데이트
 */
export const externalItemsControllerUpdateSettings = (
  id: string,
  updateSupplierItemSettingsDto: BodyType<UpdateSupplierItemSettingsDto>,
) => {
  return api<ExternalItemsControllerUpdateSettings200>({
    url: `/external/items/${id}/settings`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateSupplierItemSettingsDto,
  });
};

export const getExternalItemsControllerUpdateSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerUpdateSettings"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
    { id: string; data: BodyType<UpdateSupplierItemSettingsDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalItemsControllerUpdateSettings(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerUpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>
>;
export type ExternalItemsControllerUpdateSettingsMutationBody =
  BodyType<UpdateSupplierItemSettingsDto>;
export type ExternalItemsControllerUpdateSettingsMutationError =
  ErrorType<unknown>;

/**
 * @summary ⚙️ 물품별 공급자 설정 업데이트
 */
export const useExternalItemsControllerUpdateSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
      TError,
      { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerUpdateSettings>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierItemSettingsDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerUpdateSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 관리자가 보완을 요청한(needs_info) 내 요청을 고쳐 다시 대기(pending)로 올립니다. 넘긴 필드만 바뀝니다.
 * @summary 보완 요청 받은 물품 등록 요청 다시 제출
 */
export const externalItemsControllerResubmitRequest = (
  id: string,
  resubmitSupplierItemRequestDto: BodyType<ResubmitSupplierItemRequestDto>,
) => {
  return api<ExternalItemsControllerResubmitRequest200>({
    url: `/external/items/requests/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: resubmitSupplierItemRequestDto,
  });
};

export const getExternalItemsControllerResubmitRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>,
    TError,
    { id: string; data: BodyType<ResubmitSupplierItemRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>,
  TError,
  { id: string; data: BodyType<ResubmitSupplierItemRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerResubmitRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>,
    { id: string; data: BodyType<ResubmitSupplierItemRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalItemsControllerResubmitRequest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerResubmitRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>
>;
export type ExternalItemsControllerResubmitRequestMutationBody =
  BodyType<ResubmitSupplierItemRequestDto>;
export type ExternalItemsControllerResubmitRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 보완 요청 받은 물품 등록 요청 다시 제출
 */
export const useExternalItemsControllerResubmitRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>,
      TError,
      { id: string; data: BodyType<ResubmitSupplierItemRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerResubmitRequest>>,
  TError,
  { id: string; data: BodyType<ResubmitSupplierItemRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerResubmitRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공급자가 새로운 물품 등록을 요청합니다.
 * @summary 물품 등록 요청 제출 (C-Market 전용)
 */
export const externalItemsControllerCreateRequest = (
  createSupplierItemRequestDto: BodyType<CreateSupplierItemRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerCreateRequest201>({
    url: `/external/items/requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSupplierItemRequestDto,
    signal,
  });
};

export const getExternalItemsControllerCreateRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
    TError,
    { data: BodyType<CreateSupplierItemRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
  TError,
  { data: BodyType<CreateSupplierItemRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerCreateRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
    { data: BodyType<CreateSupplierItemRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalItemsControllerCreateRequest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerCreateRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>
>;
export type ExternalItemsControllerCreateRequestMutationBody =
  BodyType<CreateSupplierItemRequestDto>;
export type ExternalItemsControllerCreateRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 물품 등록 요청 제출 (C-Market 전용)
 */
export const useExternalItemsControllerCreateRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
      TError,
      { data: BodyType<CreateSupplierItemRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerCreateRequest>>,
  TError,
  { data: BodyType<CreateSupplierItemRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerCreateRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공급자가 직접 등록 요청한 품목들의 상태를 조회합니다.
 * @summary 내가 요청한 품목 등록 내역 조회
 */
export const externalItemsControllerGetMyRequests = (
  params?: ExternalItemsControllerGetMyRequestsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerGetMyRequests200>({
    url: `/external/items/requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemsControllerGetMyRequestsQueryKey = (
  params?: ExternalItemsControllerGetMyRequestsParams,
) => {
  return [`/external/items/requests`, ...(params ? [params] : [])] as const;
};

export const getExternalItemsControllerGetMyRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemsControllerGetMyRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
  > = ({ signal }) => externalItemsControllerGetMyRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemsControllerGetMyRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
>;
export type ExternalItemsControllerGetMyRequestsQueryError = ErrorType<unknown>;

export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalItemsControllerGetMyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 요청한 품목 등록 내역 조회
 */

export function useExternalItemsControllerGetMyRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemsControllerGetMyRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 사진을 public assets 버킷에 올리고 공개 URL 을 돌려준다. 돌려받은 imageUrl 을 수정 제안(POST external/items/:id/edit-requests)의 changes.imageUrl 에 그대로 넣는다. 올리기만 해서는 마스터가 바뀌지 않는다 — 승인이 있어야 공표된다.
 * @summary 수정 제안용 물품 사진 업로드
 */
export const externalItemsControllerUploadEditRequestImage = (
  externalItemsControllerUploadEditRequestImageBody: BodyType<ExternalItemsControllerUploadEditRequestImageBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    externalItemsControllerUploadEditRequestImageBody.file,
  );

  return api<ExternalItemsControllerUploadEditRequestImage201>({
    url: `/external/items/edit-requests/image`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getExternalItemsControllerUploadEditRequestImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>,
    TError,
    { data: BodyType<ExternalItemsControllerUploadEditRequestImageBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>,
  TError,
  { data: BodyType<ExternalItemsControllerUploadEditRequestImageBody> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerUploadEditRequestImage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>,
    { data: BodyType<ExternalItemsControllerUploadEditRequestImageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return externalItemsControllerUploadEditRequestImage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerUploadEditRequestImageMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>
  >;
export type ExternalItemsControllerUploadEditRequestImageMutationBody =
  BodyType<ExternalItemsControllerUploadEditRequestImageBody>;
export type ExternalItemsControllerUploadEditRequestImageMutationError =
  ErrorType<unknown>;

/**
 * @summary 수정 제안용 물품 사진 업로드
 */
export const useExternalItemsControllerUploadEditRequestImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>,
      TError,
      { data: BodyType<ExternalItemsControllerUploadEditRequestImageBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerUploadEditRequestImage>>,
  TError,
  { data: BodyType<ExternalItemsControllerUploadEditRequestImageBody> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerUploadEditRequestImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 상태(대기·승인·반려·보완 요청)와 이전/이후 값을 함께 돌려준다. 보완 요청은 PATCH edit-requests/:id 로 고쳐 다시 낸다.
 * @summary 내가 낸 물품 정보 수정 요청 내역
 */
export const externalItemsControllerGetMyEditRequests = (
  params?: ExternalItemsControllerGetMyEditRequestsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerGetMyEditRequests200>({
    url: `/external/items/edit-requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemsControllerGetMyEditRequestsQueryKey = (
  params?: ExternalItemsControllerGetMyEditRequestsParams,
) => {
  return [
    `/external/items/edit-requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalItemsControllerGetMyEditRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyEditRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemsControllerGetMyEditRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>
  > = ({ signal }) => externalItemsControllerGetMyEditRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemsControllerGetMyEditRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>
>;
export type ExternalItemsControllerGetMyEditRequestsQueryError =
  ErrorType<unknown>;

export function useExternalItemsControllerGetMyEditRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalItemsControllerGetMyEditRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyEditRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyEditRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
          TError,
          Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemsControllerGetMyEditRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyEditRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 낸 물품 정보 수정 요청 내역
 */

export function useExternalItemsControllerGetMyEditRequests<
  TData = Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalItemsControllerGetMyEditRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemsControllerGetMyEditRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemsControllerGetMyEditRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 관리자가 보완을 요청한(needs_info) 내 제안을 고쳐 다시 대기로 올린다. 보낸 칸만 덮는다.
 * @summary 보완 요청 받은 수정 요청 다시 제출
 */
export const externalItemsControllerResubmitEditRequest = (
  id: string,
  resubmitSupplierItemEditRequestDto: BodyType<ResubmitSupplierItemEditRequestDto>,
) => {
  return api<ExternalItemsControllerResubmitEditRequest200>({
    url: `/external/items/edit-requests/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: resubmitSupplierItemEditRequestDto,
  });
};

export const getExternalItemsControllerResubmitEditRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>,
    TError,
    { id: string; data: BodyType<ResubmitSupplierItemEditRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>,
  TError,
  { id: string; data: BodyType<ResubmitSupplierItemEditRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerResubmitEditRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>,
    { id: string; data: BodyType<ResubmitSupplierItemEditRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalItemsControllerResubmitEditRequest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerResubmitEditRequestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>
  >;
export type ExternalItemsControllerResubmitEditRequestMutationBody =
  BodyType<ResubmitSupplierItemEditRequestDto>;
export type ExternalItemsControllerResubmitEditRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 보완 요청 받은 수정 요청 다시 제출
 */
export const useExternalItemsControllerResubmitEditRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>,
      TError,
      { id: string; data: BodyType<ResubmitSupplierItemEditRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerResubmitEditRequest>>,
  TError,
  { id: string; data: BodyType<ResubmitSupplierItemEditRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerResubmitEditRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 아직 검토 전인 내 제안을 철회한다. 승인·반려된 것은 기록으로 남아 지울 수 없다.
 * @summary 대기 중인 수정 요청 취소
 */
export const externalItemsControllerWithdrawEditRequest = (id: string) => {
  return api<void>({
    url: `/external/items/edit-requests/${id}`,
    method: "DELETE",
  });
};

export const getExternalItemsControllerWithdrawEditRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalItemsControllerWithdrawEditRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalItemsControllerWithdrawEditRequest(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerWithdrawEditRequestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>
  >;

export type ExternalItemsControllerWithdrawEditRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 대기 중인 수정 요청 취소
 */
export const useExternalItemsControllerWithdrawEditRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerWithdrawEditRequest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerWithdrawEditRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 보낸 칸만 «고치겠다» 로 읽는다. 제출 순간의 마스터 값이 «이전» 으로 함께 저장돼 관리자가 이전/이후를 보고 승인한다. 같은 물품에 대기 중인 내 제안이 있으면 그 제안에 합쳐진다.
 * @summary 물품 정보 수정 요청 제출 (사진·규격 등)
 */
export const externalItemsControllerCreateEditRequest = (
  id: string,
  createSupplierItemEditRequestDto: BodyType<CreateSupplierItemEditRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalItemsControllerCreateEditRequest201>({
    url: `/external/items/${id}/edit-requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSupplierItemEditRequestDto,
    signal,
  });
};

export const getExternalItemsControllerCreateEditRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>,
    TError,
    { id: string; data: BodyType<CreateSupplierItemEditRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>,
  TError,
  { id: string; data: BodyType<CreateSupplierItemEditRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemsControllerCreateEditRequest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>,
    { id: string; data: BodyType<CreateSupplierItemEditRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalItemsControllerCreateEditRequest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemsControllerCreateEditRequestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>
  >;
export type ExternalItemsControllerCreateEditRequestMutationBody =
  BodyType<CreateSupplierItemEditRequestDto>;
export type ExternalItemsControllerCreateEditRequestMutationError =
  ErrorType<unknown>;

/**
 * @summary 물품 정보 수정 요청 제출 (사진·규격 등)
 */
export const useExternalItemsControllerCreateEditRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>,
      TError,
      { id: string; data: BodyType<CreateSupplierItemEditRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemsControllerCreateEditRequest>>,
  TError,
  { id: string; data: BodyType<CreateSupplierItemEditRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemsControllerCreateEditRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 최대 200행. 전부 성공하거나 전부 실패한다(applied 는 0 또는 전체). 행별 결과에 사용자 문장과 입고 마진 미리보기가 실린다. 매입가가 바뀌어도 공급가는 자동으로 바뀌지 않는다.
 * @summary 📦 재고 입고·출고·조정 일괄 등록
 */
export const externalStockControllerCreateTransactions = (
  stockTransactionBatchDto: BodyType<StockTransactionBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStockControllerCreateTransactions200>({
    url: `/external/stock/transactions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: stockTransactionBatchDto,
    signal,
  });
};

export const getExternalStockControllerCreateTransactionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>,
    TError,
    { data: BodyType<StockTransactionBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>,
  TError,
  { data: BodyType<StockTransactionBatchDto> },
  TContext
> => {
  const mutationKey = ["externalStockControllerCreateTransactions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>,
    { data: BodyType<StockTransactionBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalStockControllerCreateTransactions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStockControllerCreateTransactionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>
  >;
export type ExternalStockControllerCreateTransactionsMutationBody =
  BodyType<StockTransactionBatchDto>;
export type ExternalStockControllerCreateTransactionsMutationError =
  ErrorType<unknown>;

/**
 * @summary 📦 재고 입고·출고·조정 일괄 등록
 */
export const useExternalStockControllerCreateTransactions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>,
      TError,
      { data: BodyType<StockTransactionBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStockControllerCreateTransactions>>,
  TError,
  { data: BodyType<StockTransactionBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStockControllerCreateTransactionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 재고 원장 이력 (최근순, 커서 페이지네이션)
 */
export const externalStockControllerListTransactions = (
  params?: ExternalStockControllerListTransactionsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStockControllerListTransactions200>({
    url: `/external/stock/transactions`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStockControllerListTransactionsQueryKey = (
  params?: ExternalStockControllerListTransactionsParams,
) => {
  return [`/external/stock/transactions`, ...(params ? [params] : [])] as const;
};

export const getExternalStockControllerListTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalStockControllerListTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStockControllerListTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStockControllerListTransactions>>
  > = ({ signal }) => externalStockControllerListTransactions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStockControllerListTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStockControllerListTransactions>>
>;
export type ExternalStockControllerListTransactionsQueryError =
  ErrorType<unknown>;

export function useExternalStockControllerListTransactions<
  TData = Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalStockControllerListTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
          TError,
          Awaited<ReturnType<typeof externalStockControllerListTransactions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStockControllerListTransactions<
  TData = Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalStockControllerListTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
          TError,
          Awaited<ReturnType<typeof externalStockControllerListTransactions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStockControllerListTransactions<
  TData = Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalStockControllerListTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 재고 원장 이력 (최근순, 커서 페이지네이션)
 */

export function useExternalStockControllerListTransactions<
  TData = Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalStockControllerListTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerListTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStockControllerListTransactionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 재고 등록 미리보기 — 저장 없이 검증과 마진만
 */
export const externalStockControllerPreviewTransactions = (
  stockTransactionBatchDto: BodyType<StockTransactionBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStockControllerPreviewTransactions200>({
    url: `/external/stock/transactions/preview`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: stockTransactionBatchDto,
    signal,
  });
};

export const getExternalStockControllerPreviewTransactionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>,
    TError,
    { data: BodyType<StockTransactionBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>,
  TError,
  { data: BodyType<StockTransactionBatchDto> },
  TContext
> => {
  const mutationKey = ["externalStockControllerPreviewTransactions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>,
    { data: BodyType<StockTransactionBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalStockControllerPreviewTransactions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStockControllerPreviewTransactionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>
  >;
export type ExternalStockControllerPreviewTransactionsMutationBody =
  BodyType<StockTransactionBatchDto>;
export type ExternalStockControllerPreviewTransactionsMutationError =
  ErrorType<unknown>;

/**
 * @summary 재고 등록 미리보기 — 저장 없이 검증과 마진만
 */
export const useExternalStockControllerPreviewTransactions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>,
      TError,
      { data: BodyType<StockTransactionBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStockControllerPreviewTransactions>>,
  TError,
  { data: BodyType<StockTransactionBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStockControllerPreviewTransactionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 행을 고치지 않고 반대 부호의 CANCEL 행을 만든다. 이미 취소된 행은 409, 취소 행 자체는 400.
 * @summary 재고 원장 행 취소
 */
export const externalStockControllerCancelTransaction = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStockControllerCancelTransaction200>({
    url: `/external/stock/transactions/${id}/cancel`,
    method: "POST",
    signal,
  });
};

export const getExternalStockControllerCancelTransactionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalStockControllerCancelTransaction"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalStockControllerCancelTransaction(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStockControllerCancelTransactionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>
  >;

export type ExternalStockControllerCancelTransactionMutationError =
  ErrorType<unknown>;

/**
 * @summary 재고 원장 행 취소
 */
export const useExternalStockControllerCancelTransaction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStockControllerCancelTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalStockControllerCancelTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 타사 상호는 싣지 않는다. 네이버 시세·가격밴드는 이 응답에 없다(별도 호출).
 * @summary 단가 비교선 — 나의 공급가 · 최종 매입원가 · 마진 · 타사 최저 실거래(숫자만)
 */
export const externalStockControllerPriceContext = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStockControllerPriceContext200>({
    url: `/external/stock/items/${id}/price-context`,
    method: "GET",
    signal,
  });
};

export const getExternalStockControllerPriceContextQueryKey = (id?: string) => {
  return [`/external/stock/items/${id}/price-context`] as const;
};

export const getExternalStockControllerPriceContextQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStockControllerPriceContextQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStockControllerPriceContext>>
  > = ({ signal }) => externalStockControllerPriceContext(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStockControllerPriceContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStockControllerPriceContext>>
>;
export type ExternalStockControllerPriceContextQueryError = ErrorType<unknown>;

export function useExternalStockControllerPriceContext<
  TData = Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
          TError,
          Awaited<ReturnType<typeof externalStockControllerPriceContext>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStockControllerPriceContext<
  TData = Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
          TError,
          Awaited<ReturnType<typeof externalStockControllerPriceContext>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStockControllerPriceContext<
  TData = Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 단가 비교선 — 나의 공급가 · 최종 매입원가 · 마진 · 타사 최저 실거래(숫자만)
 */

export function useExternalStockControllerPriceContext<
  TData = Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStockControllerPriceContext>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStockControllerPriceContextQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 줄(이름·규격·브랜드·단위)을 받아 카탈로그 후보와 확신도·띠(auto/suggest/new/skip)를 돌려준다. 저장하지 않는다.
 * @summary 🧩 견적 줄 매칭 후보 (파트너 API 키)
 */
export const externalItemSearchControllerMatch = (
  externalQuoteLineMatchRequestDto: BodyType<ExternalQuoteLineMatchRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalItemSearchControllerMatch200>({
    url: `/external/items/match`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: externalQuoteLineMatchRequestDto,
    signal,
  });
};

export const getExternalItemSearchControllerMatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalItemSearchControllerMatch>>,
    TError,
    { data: BodyType<ExternalQuoteLineMatchRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalItemSearchControllerMatch>>,
  TError,
  { data: BodyType<ExternalQuoteLineMatchRequestDto> },
  TContext
> => {
  const mutationKey = ["externalItemSearchControllerMatch"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalItemSearchControllerMatch>>,
    { data: BodyType<ExternalQuoteLineMatchRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalItemSearchControllerMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalItemSearchControllerMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalItemSearchControllerMatch>>
>;
export type ExternalItemSearchControllerMatchMutationBody =
  BodyType<ExternalQuoteLineMatchRequestDto>;
export type ExternalItemSearchControllerMatchMutationError = ErrorType<unknown>;

/**
 * @summary 🧩 견적 줄 매칭 후보 (파트너 API 키)
 */
export const useExternalItemSearchControllerMatch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalItemSearchControllerMatch>>,
      TError,
      { data: BodyType<ExternalQuoteLineMatchRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalItemSearchControllerMatch>>,
  TError,
  { data: BodyType<ExternalQuoteLineMatchRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalItemSearchControllerMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 정부 조달 데이터(items_v2_base) 기반 읽기 전용 품목 검색. 파트너 API 키(X-API-Key)로 인증한다(buyer/supplier 세션 토큰도 과도기 동안 함께 허용). 발주기관 공고등록·시약등록 및 공급사 견적 작성에서 공통으로 사용.
 * @summary 🔍 품목 자동완성 검색 (파트너 API 키)
 */
export const externalItemSearchControllerSearch = (
  params: ExternalItemSearchControllerSearchParams,
  signal?: AbortSignal,
) => {
  return api<ExternalItemSearchControllerSearch200>({
    url: `/external/items/search`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalItemSearchControllerSearchQueryKey = (
  params?: ExternalItemSearchControllerSearchParams,
) => {
  return [`/external/items/search`, ...(params ? [params] : [])] as const;
};

export const getExternalItemSearchControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalItemSearchControllerSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
  > = ({ signal }) => externalItemSearchControllerSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalItemSearchControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
>;
export type ExternalItemSearchControllerSearchQueryError = ErrorType<unknown>;

export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof externalItemSearchControllerSearch>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔍 품목 자동완성 검색 (파트너 API 키)
 */

export function useExternalItemSearchControllerSearch<
  TData = Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
  TError = ErrorType<unknown>,
>(
  params: ExternalItemSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalItemSearchControllerSearch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalItemSearchControllerSearchQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 세모 마스터가 해당 쇼핑몰에 승인한 상품과 판매가를 반환한다. 판매가는 마스터가 정한 규칙(공급사 단가 그대로 / 마진율 / 고정가)이 적용된 값이며, 공급사 정보는 포함되지 않는다.
 * @summary 🛒 쇼핑몰 상품 피드 (파트너 API 키)
 */
export const externalStorefrontControllerGetItems = (
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItems200>({
    url: `/external/storefronts/${slug}/items`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontControllerGetItemsQueryKey = (
  slug?: string,
  params?: ExternalStorefrontControllerGetItemsParams,
) => {
  return [
    `/external/storefronts/${slug}/items`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontControllerGetItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemsQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
  > = ({ signal }) =>
    externalStorefrontControllerGetItems(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
>;
export type ExternalStorefrontControllerGetItemsQueryError = ErrorType<unknown>;

export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: undefined | ExternalStorefrontControllerGetItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 상품 피드 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItems<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontControllerGetItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemsQueryOptions(
    slug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 노출 중인 상품의 대분류·소분류와 건수. 쇼핑몰이 칩을 그리려고 상품 목록을 통째로 받지 않아도 되게 한다 — 2만 건짜리 몰에서는 그 방식이 성립하지 않는다.
 * @summary 🛒 쇼핑몰 카테고리 인덱스 (파트너 API 키)
 */
export const externalStorefrontControllerGetCategories = (
  slug: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetCategories200>({
    url: `/external/storefronts/${slug}/categories`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetCategoriesQueryKey = (
  slug?: string,
) => {
  return [`/external/storefronts/${slug}/categories`] as const;
};

export const getExternalStorefrontControllerGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetCategoriesQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
  > = ({ signal }) => externalStorefrontControllerGetCategories(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
>;
export type ExternalStorefrontControllerGetCategoriesQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 카테고리 인덱스 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetCategories<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetCategories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetCategoriesQueryOptions(
    slug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 상세 화면용. 목록을 통째로 받아 그 안에서 찾지 않아도 되게 한다 — 승인 품목이 2만 건이 되면 상세 한 장에 목록 100쪽이 딸려온다.
 * @summary 🛒 쇼핑몰 상품 단건 (파트너 API 키)
 */
export const externalStorefrontControllerGetItem = (
  slug: string,
  itemId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItem200>({
    url: `/external/storefronts/${slug}/items/${itemId}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetItemQueryKey = (
  slug?: string,
  itemId?: string,
) => {
  return [`/external/storefronts/${slug}/items/${itemId}`] as const;
};

export const getExternalStorefrontControllerGetItemQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemQueryKey(slug, itemId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
  > = ({ signal }) => externalStorefrontControllerGetItem(slug, itemId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
>;
export type ExternalStorefrontControllerGetItemQueryError = ErrorType<unknown>;

export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 상품 단건 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItem<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemQueryOptions(
    slug,
    itemId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 같은 품목을 여러 공급사가 낼 수 있다. 목록의 price 는 이 리스트의 최저가와 같다. X-API-Key 로 호출하면 공급사 실명(supplierId·supplierName)이 실리고, 세션 토큰으로 호출하면 null 이다. 신뢰도·리드타임 등은 원천이 있을 때만 값이 있다.
 * @summary 🛒 품목별 공급사 단가 리스트 (파트너 API 키)
 */
export const externalStorefrontControllerGetItemOffers = (
  slug: string,
  itemId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontControllerGetItemOffers200>({
    url: `/external/storefronts/${slug}/items/${itemId}/offers`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontControllerGetItemOffersQueryKey = (
  slug?: string,
  itemId?: string,
) => {
  return [`/external/storefronts/${slug}/items/${itemId}/offers`] as const;
};

export const getExternalStorefrontControllerGetItemOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontControllerGetItemOffersQueryKey(slug, itemId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
  > = ({ signal }) =>
    externalStorefrontControllerGetItemOffers(slug, itemId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontControllerGetItemOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
>;
export type ExternalStorefrontControllerGetItemOffersQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 품목별 공급사 단가 리스트 (파트너 API 키)
 */

export function useExternalStorefrontControllerGetItemOffers<
  TData = Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontControllerGetItemOffers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontControllerGetItemOffersQueryOptions(
    slug,
    itemId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 포인트 결제 몰(POINT_POSTPAID)에서 그 담당자가 지금 쓸 수 있는 포인트와 원장 이력. 원장 정본은 세모 DB(로트별 사용기한·FEFO)다 — 후불 몰이면 409 다.
 * @summary 🛒 쇼핑몰 포인트 — 잔액·만기 임박·이력 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetPointBalance = (
  slug: string,
  memberNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetPointBalance200>({
    url: `/external/storefronts/${slug}/points/${memberNo}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetPointBalanceQueryKey = (
  slug?: string,
  memberNo?: string,
) => {
  return [`/external/storefronts/${slug}/points/${memberNo}`] as const;
};

export const getExternalStorefrontOrdersControllerGetPointBalanceQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
    >,
    TError = ErrorType<unknown>,
  >(
    slug: string,
    memberNo: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalStorefrontOrdersControllerGetPointBalanceQueryKey(
        slug,
        memberNo,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
      >
    > = ({ signal }) =>
      externalStorefrontOrdersControllerGetPointBalance(slug, memberNo, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!(slug && memberNo),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalStorefrontOrdersControllerGetPointBalanceQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
    >
  >;
export type ExternalStorefrontOrdersControllerGetPointBalanceQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 포인트 — 잔액·만기 임박·이력 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerGetPointBalance<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  memberNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetPointBalance>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetPointBalanceQueryOptions(
      slug,
      memberNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 장바구니 한 건을 주문으로 남기고 **구매번호**를 채번한다. 단가는 요청 본문에서 받지 않는다 — 서버가 카탈로그에서 다시 확정하므로 화면 금액이 조작돼도 주문 금액은 바뀌지 않는다. `clientOrderKey` 를 같이 보내면 재시도해도 주문이 한 건만 생긴다.
 * @summary 🛒 쇼핑몰 주문 등록 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCreateOrder = (
  slug: string,
  createStorefrontOrderDto: BodyType<CreateStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCreateOrder201>({
    url: `/external/storefronts/${slug}/orders`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCreateOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
    TError,
    { slug: string; data: BodyType<CreateStorefrontOrderDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontOrderDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontOrdersControllerCreateOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
    { slug: string; data: BodyType<CreateStorefrontOrderDto> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return externalStorefrontOrdersControllerCreateOrder(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontOrdersControllerCreateOrderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>
  >;
export type ExternalStorefrontOrdersControllerCreateOrderMutationBody =
  BodyType<CreateStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerCreateOrderMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 쇼핑몰 주문 등록 (파트너 API 키)
 */
export const useExternalStorefrontOrdersControllerCreateOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
      TError,
      { slug: string; data: BodyType<CreateStorefrontOrderDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCreateOrder>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontOrderDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCreateOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `employeeNo` 를 주면 그 담당자의 주문만, 안 주면 그 몰의 전체 주문을 최신순으로 돌려준다.
 * @summary 🛒 쇼핑몰 주문 내역 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerListOrders = (
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerListOrders200>({
    url: `/external/storefronts/${slug}/orders`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerListOrdersQueryKey = (
  slug?: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
) => {
  return [
    `/external/storefronts/${slug}/orders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontOrdersControllerListOrdersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerListOrdersQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerListOrders(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerListOrdersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerListOrders>>
  >;
export type ExternalStorefrontOrdersControllerListOrdersQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: undefined | ExternalStorefrontOrdersControllerListOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerListOrders>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 주문 내역 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerListOrders<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerListOrders>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontOrdersControllerListOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerListOrders>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerListOrdersQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 🛒 쇼핑몰 주문 1건 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetOrder = (
  slug: string,
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetOrder200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetOrderQueryKey = (
  slug?: string,
  orderNo?: string,
) => {
  return [`/external/storefronts/${slug}/orders/${orderNo}`] as const;
};

export const getExternalStorefrontOrdersControllerGetOrderQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerGetOrderQueryKey(slug, orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerGetOrder(slug, orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && orderNo),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerGetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
>;
export type ExternalStorefrontOrdersControllerGetOrderQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 쇼핑몰 주문 1건 (파트너 API 키)
 */

export function useExternalStorefrontOrdersControllerGetOrder<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetOrder>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetOrderQueryOptions(
      slug,
      orderNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * KCL ERP 가 채번한 구매요구번호를 받아 주문에 반영한다. **이 시점에 거래가 성립한다.** 같은 회신이 두 번 와도 조용히 통과한다 — 씨마켓 통지와 우리 되읽기 스윕이 같은 값을 들고 올 수 있고, 여기서 4xx 를 내면 씨마켓이 그것을 재시도 금지로 분류해 통지가 사라진다.
 * @summary 🛒 구매요구번호 회신 수신 (씨마켓이 호출)
 */
export const externalStorefrontOrdersControllerApplyRequisition = (
  slug: string,
  orderNo: string,
  requisitionedStorefrontOrderDto: BodyType<RequisitionedStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerApplyRequisition200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/requisitioned`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requisitionedStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerApplyRequisitionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
    >,
    TError,
    {
      slug: string;
      orderNo: string;
      data: BodyType<RequisitionedStorefrontOrderDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalStorefrontOrdersControllerApplyRequisition"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      }
    > = (props) => {
      const { slug, orderNo, data } = props ?? {};

      return externalStorefrontOrdersControllerApplyRequisition(
        slug,
        orderNo,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontOrdersControllerApplyRequisitionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
    >
  >;
export type ExternalStorefrontOrdersControllerApplyRequisitionMutationBody =
  BodyType<RequisitionedStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerApplyRequisitionMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 구매요구번호 회신 수신 (씨마켓이 호출)
 */
export const useExternalStorefrontOrdersControllerApplyRequisition = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
      >,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<RequisitionedStorefrontOrderDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerApplyRequisition>
  >,
  TError,
  {
    slug: string;
    orderNo: string;
    data: BodyType<RequisitionedStorefrontOrderDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerApplyRequisitionMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 검수 세션과 진행 상태. 대조할 품목(CAS·용량)이 없는 주문은 세션 자체가 없어 null 이다.
 * @summary 🔬 수령검수 상태
 */
export const externalStorefrontOrdersControllerGetInspection = (
  slug: string,
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerGetInspection200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/inspection`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontOrdersControllerGetInspectionQueryKey = (
  slug?: string,
  orderNo?: string,
) => {
  return [
    `/external/storefronts/${slug}/orders/${orderNo}/inspection`,
  ] as const;
};

export const getExternalStorefrontOrdersControllerGetInspectionQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontOrdersControllerGetInspectionQueryKey(slug, orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>
  > = ({ signal }) =>
    externalStorefrontOrdersControllerGetInspection(slug, orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && orderNo),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontOrdersControllerGetInspectionQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerGetInspection>>
  >;
export type ExternalStorefrontOrdersControllerGetInspectionQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔬 수령검수 상태
 */

export function useExternalStorefrontOrdersControllerGetInspection<
  TData = Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontOrdersControllerGetInspection>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontOrdersControllerGetInspectionQueryOptions(
      slug,
      orderNo,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 검수가 끝났음을 받아 **계산서 보류를 푼다.** 불일치가 남아 있어도 완료로 처리한다 — 게이트가 보는 것은 「대조가 전부 일치했는가」가 아니라 「검수를 마쳤는가」다. 같은 회신이 두 번 와도 조용히 통과한다.
 * @summary 🔬 수령검수 완료 수신 (검수 서버가 호출)
 */
export const externalStorefrontOrdersControllerCompleteInspection = (
  slug: string,
  orderNo: string,
  completeInspectionDto: BodyType<CompleteInspectionDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCompleteInspection200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/inspection/complete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeInspectionDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCompleteInspectionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      TError,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
    >,
    TError,
    { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
    TContext
  > => {
    const mutationKey = [
      "externalStorefrontOrdersControllerCompleteInspection",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> }
    > = (props) => {
      const { slug, orderNo, data } = props ?? {};

      return externalStorefrontOrdersControllerCompleteInspection(
        slug,
        orderNo,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontOrdersControllerCompleteInspectionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
    >
  >;
export type ExternalStorefrontOrdersControllerCompleteInspectionMutationBody =
  BodyType<CompleteInspectionDto>;
export type ExternalStorefrontOrdersControllerCompleteInspectionMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔬 수령검수 완료 수신 (검수 서버가 호출)
 */
export const useExternalStorefrontOrdersControllerCompleteInspection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
      >,
      TError,
      { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontOrdersControllerCompleteInspection>
  >,
  TError,
  { slug: string; orderNo: string; data: BodyType<CompleteInspectionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCompleteInspectionMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * ERP 로 나가기 전(PLACED)에만 취소된다. 전송된 뒤에는 구매요구가 KCL 안에서 돌고 있어 몰이 지울 수 없다 — 그때는 계약 취소 경로다.
 * @summary 🛒 쇼핑몰 주문 취소 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCancelOrder = (
  slug: string,
  orderNo: string,
  cancelStorefrontOrderDto: BodyType<CancelStorefrontOrderDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontOrdersControllerCancelOrder200>({
    url: `/external/storefronts/${slug}/orders/${orderNo}/cancel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelStorefrontOrderDto,
    signal,
  });
};

export const getExternalStorefrontOrdersControllerCancelOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
    TError,
    { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
  TError,
  { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontOrdersControllerCancelOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
    { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> }
  > = (props) => {
    const { slug, orderNo, data } = props ?? {};

    return externalStorefrontOrdersControllerCancelOrder(slug, orderNo, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontOrdersControllerCancelOrderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>
  >;
export type ExternalStorefrontOrdersControllerCancelOrderMutationBody =
  BodyType<CancelStorefrontOrderDto>;
export type ExternalStorefrontOrdersControllerCancelOrderMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 쇼핑몰 주문 취소 (파트너 API 키)
 */
export const useExternalStorefrontOrdersControllerCancelOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
      TError,
      {
        slug: string;
        orderNo: string;
        data: BodyType<CancelStorefrontOrderDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontOrdersControllerCancelOrder>>,
  TError,
  { slug: string; orderNo: string; data: BodyType<CancelStorefrontOrderDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontOrdersControllerCancelOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓몰(주문자별 계정 몰)의 주문자(`ownerKey` = 씨마켓 로그인 sub)가 안전결제에 쓸 수 있는 씨마켓 저장카드 목록과 포인트 잔액. 카드는 빌키가 살아 있는 것만 온다. 씨마켓 연동이 설정되지 않은 환경은 503, 씨마켓몰이 아니면 409.
 * @summary 💳 쇼핑몰 결제수단 — 저장카드·포인트 잔액 (파트너 API 키)
 */
export const externalStorefrontPaymentOptionsControllerGetPaymentOptions = (
  slug: string,
  params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontPaymentOptionsControllerGetPaymentOptions200>({
    url: `/external/storefronts/${slug}/payment-options`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryKey =
  (
    slug?: string,
    params?: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  ) => {
    return [
      `/external/storefronts/${slug}/payment-options`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
      >
    >,
    TError = ErrorType<unknown>,
  >(
    slug: string,
    params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryKey(
        slug,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
        >
      >
    > = ({ signal }) =>
      externalStorefrontPaymentOptionsControllerGetPaymentOptions(
        slug,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!slug,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
      >
    >
  >;
export type ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontPaymentOptionsControllerGetPaymentOptions<
  TData = Awaited<
    ReturnType<
      typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
    >
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontPaymentOptionsControllerGetPaymentOptions<
  TData = Awaited<
    ReturnType<
      typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
    >
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontPaymentOptionsControllerGetPaymentOptions<
  TData = Awaited<
    ReturnType<
      typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
    >
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 💳 쇼핑몰 결제수단 — 저장카드·포인트 잔액 (파트너 API 키)
 */

export function useExternalStorefrontPaymentOptionsControllerGetPaymentOptions<
  TData = Awaited<
    ReturnType<
      typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
    >
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontPaymentOptionsControllerGetPaymentOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalStorefrontPaymentOptionsControllerGetPaymentOptions
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontPaymentOptionsControllerGetPaymentOptionsQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 장바구니(CART) 또는 정기구독 설계(SUBSCRIPTION)로 견적서를 발급한다. **견적번호·유효기간(발급 + 7일)은 세모가 정한다.** 단가는 요청 본문에서 받지 않는다 — 몰에 승인된 오퍼로 다시 확정하고, 금액(공급가액·배송비·부가세·총액)도 세모가 계산한다. 팔 수 없는 품목·오퍼가 섞여 있으면 409.
 * @summary 🧾 쇼핑몰 견적서 발급 (파트너 API 키)
 */
export const externalStorefrontQuotesControllerCreateQuote = (
  slug: string,
  createStorefrontQuoteDto: BodyType<CreateStorefrontQuoteDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontQuotesControllerCreateQuote201>({
    url: `/external/storefronts/${slug}/quotes`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStorefrontQuoteDto,
    signal,
  });
};

export const getExternalStorefrontQuotesControllerCreateQuoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>,
    TError,
    { slug: string; data: BodyType<CreateStorefrontQuoteDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontQuoteDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontQuotesControllerCreateQuote"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>,
    { slug: string; data: BodyType<CreateStorefrontQuoteDto> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return externalStorefrontQuotesControllerCreateQuote(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontQuotesControllerCreateQuoteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>
  >;
export type ExternalStorefrontQuotesControllerCreateQuoteMutationBody =
  BodyType<CreateStorefrontQuoteDto>;
export type ExternalStorefrontQuotesControllerCreateQuoteMutationError =
  ErrorType<unknown>;

/**
 * @summary 🧾 쇼핑몰 견적서 발급 (파트너 API 키)
 */
export const useExternalStorefrontQuotesControllerCreateQuote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>,
      TError,
      { slug: string; data: BodyType<CreateStorefrontQuoteDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontQuotesControllerCreateQuote>>,
  TError,
  { slug: string; data: BodyType<CreateStorefrontQuoteDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontQuotesControllerCreateQuoteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `ownerKey` 의 견적서를 최신순으로 돌려준다. `ownerKey` 는 필수다 — 몰 전체 견적서를 한 번에 여는 경로는 두지 않는다.
 * @summary 🧾 내 견적서 목록 (파트너 API 키)
 */
export const externalStorefrontQuotesControllerListQuotes = (
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontQuotesControllerListQuotes200>({
    url: `/external/storefronts/${slug}/quotes`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontQuotesControllerListQuotesQueryKey = (
  slug?: string,
  params?: ExternalStorefrontQuotesControllerListQuotesParams,
) => {
  return [
    `/external/storefronts/${slug}/quotes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontQuotesControllerListQuotesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontQuotesControllerListQuotesQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerListQuotes>>
  > = ({ signal }) =>
    externalStorefrontQuotesControllerListQuotes(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerListQuotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontQuotesControllerListQuotesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerListQuotes>>
  >;
export type ExternalStorefrontQuotesControllerListQuotesQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontQuotesControllerListQuotes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontQuotesControllerListQuotes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontQuotesControllerListQuotes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🧾 내 견적서 목록 (파트너 API 키)
 */

export function useExternalStorefrontQuotesControllerListQuotes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontQuotesControllerListQuotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontQuotesControllerListQuotes>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontQuotesControllerListQuotesQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 번호와 `ownerKey` 가 모두 맞아야 돌려준다. 남의 견적서는 «없는 견적서»(404)다. 주문 전 «내 견적서인가·유효기간 안인가» 확인에 쓴다.
 * @summary 🧾 견적서 1건 (파트너 API 키)
 */
export const externalStorefrontQuotesControllerGetQuote = (
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontQuotesControllerGetQuote200>({
    url: `/external/storefronts/${slug}/quotes/${quoteNo}`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontQuotesControllerGetQuoteQueryKey = (
  slug?: string,
  quoteNo?: string,
  params?: ExternalStorefrontQuotesControllerGetQuoteParams,
) => {
  return [
    `/external/storefronts/${slug}/quotes/${quoteNo}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontQuotesControllerGetQuoteQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontQuotesControllerGetQuoteQueryKey(
      slug,
      quoteNo,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>
  > = ({ signal }) =>
    externalStorefrontQuotesControllerGetQuote(slug, quoteNo, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && quoteNo),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontQuotesControllerGetQuoteQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>
>;
export type ExternalStorefrontQuotesControllerGetQuoteQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontQuotesControllerGetQuote<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontQuotesControllerGetQuote<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
          >,
          TError,
          Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontQuotesControllerGetQuote<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🧾 견적서 1건 (파트너 API 키)
 */

export function useExternalStorefrontQuotesControllerGetQuote<
  TData = Awaited<
    ReturnType<typeof externalStorefrontQuotesControllerGetQuote>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  quoteNo: string,
  params: ExternalStorefrontQuotesControllerGetQuoteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontQuotesControllerGetQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontQuotesControllerGetQuoteQueryOptions(
      slug,
      quoteNo,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 몰에 등록된 활성 구독 상품과 **지금 단가**(인원당 품목·기본료 오퍼). 몰은 이 값으로 월 예상액을 그린다(주기 금액 × 배수). 상품이 없으면 빈 목록 — 몰은 자체 예상 산식(미리보기)으로 돌아간다.
 * @summary 🔁 정기구독 상품 목록 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerListPlans = (
  slug: string,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerListPlans200>({
    url: `/external/storefronts/${slug}/subscription-plans`,
    method: "GET",
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerListPlansQueryKey = (
  slug?: string,
) => {
  return [`/external/storefronts/${slug}/subscription-plans`] as const;
};

export const getExternalStorefrontSubscriptionsControllerListPlansQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
    >,
    TError = ErrorType<unknown>,
  >(
    slug: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontSubscriptionsControllerListPlans
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalStorefrontSubscriptionsControllerListPlansQueryKey(slug);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
      >
    > = ({ signal }) =>
      externalStorefrontSubscriptionsControllerListPlans(slug, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!slug,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalStorefrontSubscriptionsControllerListPlansQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
    >
  >;
export type ExternalStorefrontSubscriptionsControllerListPlansQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontSubscriptionsControllerListPlans<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontSubscriptionsControllerListPlans
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalStorefrontSubscriptionsControllerListPlans
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerListPlans<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalStorefrontSubscriptionsControllerListPlans
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalStorefrontSubscriptionsControllerListPlans
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerListPlans<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔁 정기구독 상품 목록 (파트너 API 키)
 */

export function useExternalStorefrontSubscriptionsControllerListPlans<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListPlans>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontSubscriptionsControllerListPlansQueryOptions(
      slug,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 구독을 만들고 **첫 주기를 지금 주문·결제한다**(안전결제 · 씨마켓 포인트). 응답의 `firstCycle.status` 가 ORDERED 면 주문번호가 있고, FAILED 면 사유(잔액 부족 402 등)와 함께 구독은 PAYMENT_FAILED 로 남아 매일 09:00 KST 에 다시 시도한다(3회째 실패면 PAUSED). PROCESSING 이면 결제 결과를 아직 모르는 것이라 실패로 세지 않고 같은 주문 키로 다시 확인한다(다시 신청하지 말 것). 이후 주기는 스윕이 같은 경로로 주문한다. 씨마켓몰(주문자별 계정 몰)이 아니면 409, 상품의 품목이 지금 팔리지 않으면 409. `idempotencyKey` 를 보내면 같은 키의 재요청은 새 구독·새 결제 없이 처음 신청을 돌려준다. 같은 상품의 살아 있는(해지 아닌) 구독이 이미 있으면 409(`error.details.existingSubscriptionId`) — 결제 실패 구독은 새로 신청하지 말고 retry-payment, 정지 구독은 resume 으로 잇는다.
 * @summary 🔁 정기구독 신청 — 첫 주기 즉시 포인트 결제 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerSubscribe = (
  slug: string,
  createStorefrontSubscriptionDto: BodyType<CreateStorefrontSubscriptionDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerSubscribe201>({
    url: `/external/storefronts/${slug}/subscriptions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStorefrontSubscriptionDto,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerSubscribeMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
      >,
      TError,
      { slug: string; data: BodyType<CreateStorefrontSubscriptionDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
    >,
    TError,
    { slug: string; data: BodyType<CreateStorefrontSubscriptionDto> },
    TContext
  > => {
    const mutationKey = ["externalStorefrontSubscriptionsControllerSubscribe"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
      >,
      { slug: string; data: BodyType<CreateStorefrontSubscriptionDto> }
    > = (props) => {
      const { slug, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerSubscribe(slug, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerSubscribeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
    >
  >;
export type ExternalStorefrontSubscriptionsControllerSubscribeMutationBody =
  BodyType<CreateStorefrontSubscriptionDto>;
export type ExternalStorefrontSubscriptionsControllerSubscribeMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 정기구독 신청 — 첫 주기 즉시 포인트 결제 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerSubscribe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
      >,
      TError,
      { slug: string; data: BodyType<CreateStorefrontSubscriptionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerSubscribe>
  >,
  TError,
  { slug: string; data: BodyType<CreateStorefrontSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerSubscribeMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * `ownerKey` 의 구독을 최신순으로. `ownerKey` 는 필수다 — 몰 전체 구독을 여는 경로는 두지 않는다.
 * @summary 🔁 내 구독 목록 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerListMine = (
  slug: string,
  params: ExternalStorefrontSubscriptionsControllerListMineParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerListMine200>({
    url: `/external/storefronts/${slug}/subscriptions`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerListMineQueryKey = (
  slug?: string,
  params?: ExternalStorefrontSubscriptionsControllerListMineParams,
) => {
  return [
    `/external/storefronts/${slug}/subscriptions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontSubscriptionsControllerListMineQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
    >,
    TError = ErrorType<unknown>,
  >(
    slug: string,
    params: ExternalStorefrontSubscriptionsControllerListMineParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalStorefrontSubscriptionsControllerListMineQueryKey(
        slug,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
      >
    > = ({ signal }) =>
      externalStorefrontSubscriptionsControllerListMine(slug, params, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!slug,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalStorefrontSubscriptionsControllerListMineQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
    >
  >;
export type ExternalStorefrontSubscriptionsControllerListMineQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontSubscriptionsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontSubscriptionsControllerListMineParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontSubscriptionsControllerListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontSubscriptionsControllerListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔁 내 구독 목록 (파트너 API 키)
 */

export function useExternalStorefrontSubscriptionsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontSubscriptionsControllerListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontSubscriptionsControllerListMineQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * id 와 `ownerKey` 가 모두 맞아야 돌려준다. 남의 구독은 «없는 구독»(404)다.
 * @summary 🔁 구독 1건 + 주기별 결제 기록 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerGetMine = (
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerGetMine200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerGetMineQueryKey = (
  slug?: string,
  id?: string,
  params?: ExternalStorefrontSubscriptionsControllerGetMineParams,
) => {
  return [
    `/external/storefronts/${slug}/subscriptions/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontSubscriptionsControllerGetMineQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontSubscriptionsControllerGetMineQueryKey(
      slug,
      id,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>>
  > = ({ signal }) =>
    externalStorefrontSubscriptionsControllerGetMine(slug, id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontSubscriptionsControllerGetMineQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>>
  >;
export type ExternalStorefrontSubscriptionsControllerGetMineQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontSubscriptionsControllerGetMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerGetMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontSubscriptionsControllerGetMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🔁 구독 1건 + 주기별 결제 기록 (파트너 API 키)
 */

export function useExternalStorefrontSubscriptionsControllerGetMine<
  TData = Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  id: string,
  params: ExternalStorefrontSubscriptionsControllerGetMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontSubscriptionsControllerGetMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontSubscriptionsControllerGetMineQueryOptions(
      slug,
      id,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 다음 주기 주문부터 적용된다. 이미 잡힌 다음 결제일은 옮기지 않는다. 해지된 구독은 409.
 * @summary 🔁 구독 인원·주기 변경 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerUpdate = (
  slug: string,
  id: string,
  updateStorefrontSubscriptionDto: BodyType<UpdateStorefrontSubscriptionDto>,
) => {
  return api<ExternalStorefrontSubscriptionsControllerUpdate200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateStorefrontSubscriptionDto,
  });
};

export const getExternalStorefrontSubscriptionsControllerUpdateMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>
      >,
      TError,
      {
        slug: string;
        id: string;
        data: BodyType<UpdateStorefrontSubscriptionDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>>,
    TError,
    {
      slug: string;
      id: string;
      data: BodyType<UpdateStorefrontSubscriptionDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalStorefrontSubscriptionsControllerUpdate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>
      >,
      {
        slug: string;
        id: string;
        data: BodyType<UpdateStorefrontSubscriptionDto>;
      }
    > = (props) => {
      const { slug, id, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerUpdate(slug, id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>>
  >;
export type ExternalStorefrontSubscriptionsControllerUpdateMutationBody =
  BodyType<UpdateStorefrontSubscriptionDto>;
export type ExternalStorefrontSubscriptionsControllerUpdateMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 구독 인원·주기 변경 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>
      >,
      TError,
      {
        slug: string;
        id: string;
        data: BodyType<UpdateStorefrontSubscriptionDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerUpdate>>,
  TError,
  { slug: string; id: string; data: BodyType<UpdateStorefrontSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 결제가 실패(또는 결과 확인 중)로 남은 **지금 주기**를 바로 다시 결제한다 — 포인트를 충전한 손님이 내일 09:00 스윕을 기다리거나 새로 신청하지 않아도 된다. 재시도 규칙은 스윕과 같다: 같은 주문 키의 주문부터 확인해 결제됐으면 이어받고(두 번 결제하지 않음), 확정 실패였으면 다음 키(-r2, -r3)로 주문하며 3회째 실패면 PAUSED. 결과는 `payment` 에 있고 실패여도 200 이다. 다시 시도할 주기가 없거나(결제 완료·다음 결제일 전) 정지·해지된 구독이면 409(정지는 resume). 다른 요청이 결제 중이면 `payment.status` = PROCESSING.
 * @summary 🔁 구독 결제 다시 시도 — 실패한 주기를 지금 결제 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerRetryPayment = (
  slug: string,
  id: string,
  subscriptionOwnerDto: BodyType<SubscriptionOwnerDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerRetryPayment200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}/retry-payment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: subscriptionOwnerDto,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerRetryPaymentMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
    >,
    TError,
    { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
    TContext
  > => {
    const mutationKey = [
      "externalStorefrontSubscriptionsControllerRetryPayment",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
      >,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> }
    > = (props) => {
      const { slug, id, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerRetryPayment(
        slug,
        id,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerRetryPaymentMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
    >
  >;
export type ExternalStorefrontSubscriptionsControllerRetryPaymentMutationBody =
  BodyType<SubscriptionOwnerDto>;
export type ExternalStorefrontSubscriptionsControllerRetryPaymentMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 구독 결제 다시 시도 — 실패한 주기를 지금 결제 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerRetryPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalStorefrontSubscriptionsControllerRetryPayment>
  >,
  TError,
  { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerRetryPaymentMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * ACTIVE·PAYMENT_FAILED → PAUSED. 정지 중에는 스윕이 결제하지 않는다. 누른 순간 이미 결제 중이던 주기는 끝까지 가서 주문으로 적히고(구독은 PAUSED 그대로) 다음 주기부터 멈춘다. 그사이 상태가 바뀌었으면 409.
 * @summary 🔁 구독 일시정지 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerPause = (
  slug: string,
  id: string,
  subscriptionOwnerDto: BodyType<SubscriptionOwnerDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerPause200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}/pause`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: subscriptionOwnerDto,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerPauseMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerPause>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerPause>>,
    TError,
    { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
    TContext
  > => {
    const mutationKey = ["externalStorefrontSubscriptionsControllerPause"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerPause>
      >,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> }
    > = (props) => {
      const { slug, id, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerPause(slug, id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerPauseMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerPause>>
  >;
export type ExternalStorefrontSubscriptionsControllerPauseMutationBody =
  BodyType<SubscriptionOwnerDto>;
export type ExternalStorefrontSubscriptionsControllerPauseMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 구독 일시정지 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerPause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerPause>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerPause>>,
  TError,
  { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * PAUSED → ACTIVE. 정지 중 지나간 결제일은 따라잡지 않는다 — 지났으면 결제일을 다음 스윕(09:00 KST)이 도는 날짜로 당겨 그 스윕이 한 번 결제하고, 결제 기준일(닻)도 그 날짜로 옮겨 다음 결제는 꼭 한 주기 뒤다. 아직 안 온 결제일은 그대로 둔다. 실패로 남은 주기는 접는다(SKIPPED). 정지 직전에 시작한 결제가 아직 처리 중이면 409 — 잠시 뒤 다시 누른다.
 * @summary 🔁 구독 재개 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerResume = (
  slug: string,
  id: string,
  subscriptionOwnerDto: BodyType<SubscriptionOwnerDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerResume200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}/resume`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: subscriptionOwnerDto,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerResumeMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerResume>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerResume>>,
    TError,
    { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
    TContext
  > => {
    const mutationKey = ["externalStorefrontSubscriptionsControllerResume"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerResume>
      >,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> }
    > = (props) => {
      const { slug, id, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerResume(slug, id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerResumeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerResume>>
  >;
export type ExternalStorefrontSubscriptionsControllerResumeMutationBody =
  BodyType<SubscriptionOwnerDto>;
export type ExternalStorefrontSubscriptionsControllerResumeMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 구독 재개 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerResume = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerResume>
      >,
      TError,
      { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerResume>>,
  TError,
  { slug: string; id: string; data: BodyType<SubscriptionOwnerDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 어느 상태에서든 CANCELED. 이미 선 주문은 그대로다(주문 취소는 주문 API 로). 누른 순간 결제 중이던 주기는 끝까지 가서 주문으로 적힌다(더 결제하지 않는다). 재시도는 멱등.
 * @summary 🔁 구독 해지 (파트너 API 키)
 */
export const externalStorefrontSubscriptionsControllerCancel = (
  slug: string,
  id: string,
  cancelStorefrontSubscriptionDto: BodyType<CancelStorefrontSubscriptionDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontSubscriptionsControllerCancel200>({
    url: `/external/storefronts/${slug}/subscriptions/${id}/cancel`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelStorefrontSubscriptionDto,
    signal,
  });
};

export const getExternalStorefrontSubscriptionsControllerCancelMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>
      >,
      TError,
      {
        slug: string;
        id: string;
        data: BodyType<CancelStorefrontSubscriptionDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>>,
    TError,
    {
      slug: string;
      id: string;
      data: BodyType<CancelStorefrontSubscriptionDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalStorefrontSubscriptionsControllerCancel"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>
      >,
      {
        slug: string;
        id: string;
        data: BodyType<CancelStorefrontSubscriptionDto>;
      }
    > = (props) => {
      const { slug, id, data } = props ?? {};

      return externalStorefrontSubscriptionsControllerCancel(slug, id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontSubscriptionsControllerCancelMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>>
  >;
export type ExternalStorefrontSubscriptionsControllerCancelMutationBody =
  BodyType<CancelStorefrontSubscriptionDto>;
export type ExternalStorefrontSubscriptionsControllerCancelMutationError =
  ErrorType<unknown>;

/**
 * @summary 🔁 구독 해지 (파트너 API 키)
 */
export const useExternalStorefrontSubscriptionsControllerCancel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>
      >,
      TError,
      {
        slug: string;
        id: string;
        data: BodyType<CancelStorefrontSubscriptionDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontSubscriptionsControllerCancel>>,
  TError,
  { slug: string; id: string; data: BodyType<CancelStorefrontSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontSubscriptionsControllerCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 송장 등록 화면의 선택지. 코드를 자유 문자열로 두지 않는 이유는 나중에 조회 API 를 붙일 때 값들을 사람이 손으로 정리해야 하기 때문이다.
 * @summary 🚚 택배사 목록 (공급사)
 */
export const externalSupplierShipmentsControllerListCouriers = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerListCouriers200>({
    url: `/external/storefronts/couriers`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListCouriersQueryKey =
  () => {
    return [`/external/storefronts/couriers`] as const;
  };

export const getExternalSupplierShipmentsControllerListCouriersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListCouriersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>
  > = ({ signal }) => externalSupplierShipmentsControllerListCouriers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListCouriersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListCouriers>>
  >;
export type ExternalSupplierShipmentsControllerListCouriersQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 택배사 목록 (공급사)
 */

export function useExternalSupplierShipmentsControllerListCouriers<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListCouriers>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerListCouriersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 계약이 선 뒤부터 배송이 끝나기 전까지의 주문. **남은 수량이 있는 줄만** 온다 — 다 보낸 주문은 목록에서 빠지므로 열어 보고 아무것도 없음을 확인할 필요가 없다.
 * @summary 🚚 내가 보낼 몰 주문 (공급사)
 */
export const externalSupplierShipmentsControllerListMyTargets = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerListMyTargets200>({
    url: `/external/storefronts/my-shipments`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListMyTargetsQueryKey =
  () => {
    return [`/external/storefronts/my-shipments`] as const;
  };

export const getExternalSupplierShipmentsControllerListMyTargetsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListMyTargetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>>
  > = ({ signal }) => externalSupplierShipmentsControllerListMyTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListMyTargetsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>>
  >;
export type ExternalSupplierShipmentsControllerListMyTargetsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 내가 보낼 몰 주문 (공급사)
 */

export function useExternalSupplierShipmentsControllerListMyTargets<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerListMyTargets>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerListMyTargetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 🚚 주문의 배송 목록 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerList = (
  orderNo: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerList200>({
    url: `/external/storefronts/orders/${orderNo}/shipments`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerListQueryKey = (
  orderNo?: string,
) => {
  return [`/external/storefronts/orders/${orderNo}/shipments`] as const;
};

export const getExternalSupplierShipmentsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerListQueryKey(orderNo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
  > = ({ signal }) => externalSupplierShipmentsControllerList(orderNo, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orderNo,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
>;
export type ExternalSupplierShipmentsControllerListQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 주문의 배송 목록 (공급사 · 발주기관)
 */

export function useExternalSupplierShipmentsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
  TError = ErrorType<unknown>,
>(
  orderNo: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierShipmentsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalSupplierShipmentsControllerListQueryOptions(
    orderNo,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 내 몫 품목에 송장을 건다. 주문 수량보다 많이 보낼 수 없고, 송장번호를 적었으면 택배사도 골라야 한다. 마지막 품목까지 도착하면 주문이 배송완료로 바뀐다.
 * @summary 🚚 송장 등록 (공급사)
 */
export const externalSupplierShipmentsControllerRegister = (
  orderNo: string,
  registerShipmentDto: BodyType<RegisterShipmentDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerRegister201>({
    url: `/external/storefronts/orders/${orderNo}/shipments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerShipmentDto,
    signal,
  });
};

export const getExternalSupplierShipmentsControllerRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
    TError,
    { orderNo: string; data: BodyType<RegisterShipmentDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
  TError,
  { orderNo: string; data: BodyType<RegisterShipmentDto> },
  TContext
> => {
  const mutationKey = ["externalSupplierShipmentsControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
    { orderNo: string; data: BodyType<RegisterShipmentDto> }
  > = (props) => {
    const { orderNo, data } = props ?? {};

    return externalSupplierShipmentsControllerRegister(orderNo, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierShipmentsControllerRegisterMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>
  >;
export type ExternalSupplierShipmentsControllerRegisterMutationBody =
  BodyType<RegisterShipmentDto>;
export type ExternalSupplierShipmentsControllerRegisterMutationError =
  ErrorType<unknown>;

/**
 * @summary 🚚 송장 등록 (공급사)
 */
export const useExternalSupplierShipmentsControllerRegister = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
      TError,
      { orderNo: string; data: BodyType<RegisterShipmentDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegister>>,
  TError,
  { orderNo: string; data: BodyType<RegisterShipmentDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierShipmentsControllerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 그 견적 공고를 낳은 KCL-MRO 몰 주문과 그 주문의 송장을 돌려줍니다. 몰에서 올라온 공고가 아니면 404 입니다.

볼 수 있는 사람은 배송 목록과 같습니다 — 발주기관은 자기 몰 주문, 공급사는 자기 계약이 걸린 주문.
 * @summary 🚚 견적 공고의 몰 주문·배송 현황 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerFindMallOrder = (
  quoteRequestId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerFindMallOrder200>({
    url: `/external/storefronts/quote-requests/${quoteRequestId}/mall-order`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierShipmentsControllerFindMallOrderQueryKey = (
  quoteRequestId?: string,
) => {
  return [
    `/external/storefronts/quote-requests/${quoteRequestId}/mall-order`,
  ] as const;
};

export const getExternalSupplierShipmentsControllerFindMallOrderQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierShipmentsControllerFindMallOrderQueryKey(quoteRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>>
  > = ({ signal }) =>
    externalSupplierShipmentsControllerFindMallOrder(quoteRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!quoteRequestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierShipmentsControllerFindMallOrderQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>>
  >;
export type ExternalSupplierShipmentsControllerFindMallOrderQueryError =
  ErrorType<unknown>;

export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🚚 견적 공고의 몰 주문·배송 현황 (공급사 · 발주기관)
 */

export function useExternalSupplierShipmentsControllerFindMallOrder<
  TData = Awaited<
    ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
  >,
  TError = ErrorType<unknown>,
>(
  quoteRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierShipmentsControllerFindMallOrder>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierShipmentsControllerFindMallOrderQueryOptions(
      quoteRequestId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 엑셀에서 읽은 줄(주문번호 · 택배사 · 송장번호)로 «그 주문에서 내가 보낼 남은 품목 전부» 를 한 송장으로 한꺼번에 등록한다. 줄마다 따로 처리되어 한 줄이 실패해도 나머지는 등록되고, 결과는 받은 순서대로 줄마다 돌려준다(전부 200 — 줄의 성패는 본문의 ok). 같은 파일을 다시 올려도 이미 보낸 주문은 실패로 나올 뿐 중복 등록되지 않는다. 나눠 보내려면 주문별 등록을 쓴다.
 * @summary 🚚 송장 엑셀 일괄 등록 (공급사)
 */
export const externalSupplierShipmentsControllerRegisterBulk = (
  shipmentBulkRegisterDto: BodyType<ShipmentBulkRegisterDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierShipmentsControllerRegisterBulk200>({
    url: `/external/storefronts/my-shipments/bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: shipmentBulkRegisterDto,
    signal,
  });
};

export const getExternalSupplierShipmentsControllerRegisterBulkMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>
      >,
      TError,
      { data: BodyType<ShipmentBulkRegisterDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>>,
    TError,
    { data: BodyType<ShipmentBulkRegisterDto> },
    TContext
  > => {
    const mutationKey = ["externalSupplierShipmentsControllerRegisterBulk"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>
      >,
      { data: BodyType<ShipmentBulkRegisterDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalSupplierShipmentsControllerRegisterBulk(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierShipmentsControllerRegisterBulkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>>
  >;
export type ExternalSupplierShipmentsControllerRegisterBulkMutationBody =
  BodyType<ShipmentBulkRegisterDto>;
export type ExternalSupplierShipmentsControllerRegisterBulkMutationError =
  ErrorType<unknown>;

/**
 * @summary 🚚 송장 엑셀 일괄 등록 (공급사)
 */
export const useExternalSupplierShipmentsControllerRegisterBulk = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>
      >,
      TError,
      { data: BodyType<ShipmentBulkRegisterDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerRegisterBulk>>,
  TError,
  { data: BodyType<ShipmentBulkRegisterDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierShipmentsControllerRegisterBulkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 출고 → 배송중 → 배송완료. 잘못 등록한 송장은 `CANCELED` 로 무른다 — SHIPPING_REASON_RULES 가 켜진 뒤에는 `reason`(취소 사유)이 필요하다(없으면 400 `SHIPMENT_REASON_REQUIRED`).
 * @summary 🚚 배송 상태 변경 (공급사)
 */
export const externalSupplierShipmentsControllerUpdateStatus = (
  orderNo: string,
  shipmentId: string,
  updateShipmentStatusDto: BodyType<UpdateShipmentStatusDto>,
) => {
  return api<ExternalSupplierShipmentsControllerUpdateStatus200>({
    url: `/external/storefronts/orders/${orderNo}/shipments/${shipmentId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateShipmentStatusDto,
  });
};

export const getExternalSupplierShipmentsControllerUpdateStatusMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      TError,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>,
    TError,
    {
      orderNo: string;
      shipmentId: string;
      data: BodyType<UpdateShipmentStatusDto>;
    },
    TContext
  > => {
    const mutationKey = ["externalSupplierShipmentsControllerUpdateStatus"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      }
    > = (props) => {
      const { orderNo, shipmentId, data } = props ?? {};

      return externalSupplierShipmentsControllerUpdateStatus(
        orderNo,
        shipmentId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierShipmentsControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>
  >;
export type ExternalSupplierShipmentsControllerUpdateStatusMutationBody =
  BodyType<UpdateShipmentStatusDto>;
export type ExternalSupplierShipmentsControllerUpdateStatusMutationError =
  ErrorType<unknown>;

/**
 * @summary 🚚 배송 상태 변경 (공급사)
 */
export const useExternalSupplierShipmentsControllerUpdateStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>
      >,
      TError,
      {
        orderNo: string;
        shipmentId: string;
        data: BodyType<UpdateShipmentStatusDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierShipmentsControllerUpdateStatus>>,
  TError,
  {
    orderNo: string;
    shipmentId: string;
    data: BodyType<UpdateShipmentStatusDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierShipmentsControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 나에게 배정된 씨마켓몰 주문. `status=PENDING` 이 «수락 대기» 다. 구매대행(CMARKET_AGENCY) 주문은 거래 상대가 씨마켓이고 배송지는 주문 기업이다.
 * @summary 🛒 내 씨마켓몰 주문 단위 (공급사)
 */
export const externalSupplierMallUnitsControllerList = (
  params?: ExternalSupplierMallUnitsControllerListParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierMallUnitsControllerList200>({
    url: `/external/storefronts/my-mall-units`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierMallUnitsControllerListQueryKey = (
  params?: ExternalSupplierMallUnitsControllerListParams,
) => {
  return [
    `/external/storefronts/my-mall-units`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierMallUnitsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalSupplierMallUnitsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierMallUnitsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>
  > = ({ signal }) => externalSupplierMallUnitsControllerList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierMallUnitsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>
>;
export type ExternalSupplierMallUnitsControllerListQueryError =
  ErrorType<unknown>;

export function useExternalSupplierMallUnitsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalSupplierMallUnitsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierMallUnitsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalSupplierMallUnitsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierMallUnitsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalSupplierMallUnitsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 내 씨마켓몰 주문 단위 (공급사)
 */

export function useExternalSupplierMallUnitsControllerList<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalSupplierMallUnitsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalSupplierMallUnitsControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 🛒 씨마켓몰 주문 단위 1건 (공급사)
 */
export const externalSupplierMallUnitsControllerGet = (
  unitId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierMallUnitsControllerGet200>({
    url: `/external/storefronts/my-mall-units/${unitId}`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierMallUnitsControllerGetQueryKey = (
  unitId?: string,
) => {
  return [`/external/storefronts/my-mall-units/${unitId}`] as const;
};

export const getExternalSupplierMallUnitsControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
  TError = ErrorType<unknown>,
>(
  unitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierMallUnitsControllerGetQueryKey(unitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>
  > = ({ signal }) => externalSupplierMallUnitsControllerGet(unitId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!unitId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierMallUnitsControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>
>;
export type ExternalSupplierMallUnitsControllerGetQueryError =
  ErrorType<unknown>;

export function useExternalSupplierMallUnitsControllerGet<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
  TError = ErrorType<unknown>,
>(
  unitId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierMallUnitsControllerGet<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
  TError = ErrorType<unknown>,
>(
  unitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierMallUnitsControllerGet<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
  TError = ErrorType<unknown>,
>(
  unitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 씨마켓몰 주문 단위 1건 (공급사)
 */

export function useExternalSupplierMallUnitsControllerGet<
  TData = Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
  TError = ErrorType<unknown>,
>(
  unitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalSupplierMallUnitsControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalSupplierMallUnitsControllerGetQueryOptions(
    unitId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 내 단위를 수락한다. 그 주문의 공급사가 전원 수락하면 주문이 CONTRACTED 로 넘어가고 송장을 걸 수 있다. 이미 처리됐거나 주문이 취소됐으면 409.
 * @summary 🛒 씨마켓몰 주문 수락 (공급사)
 */
export const externalSupplierMallUnitsControllerAccept = (
  unitId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierMallUnitsControllerAccept200>({
    url: `/external/storefronts/my-mall-units/${unitId}/accept`,
    method: "POST",
    signal,
  });
};

export const getExternalSupplierMallUnitsControllerAcceptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>,
    TError,
    { unitId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>,
  TError,
  { unitId: string },
  TContext
> => {
  const mutationKey = ["externalSupplierMallUnitsControllerAccept"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>,
    { unitId: string }
  > = (props) => {
    const { unitId } = props ?? {};

    return externalSupplierMallUnitsControllerAccept(unitId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierMallUnitsControllerAcceptMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>
  >;

export type ExternalSupplierMallUnitsControllerAcceptMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 씨마켓몰 주문 수락 (공급사)
 */
export const useExternalSupplierMallUnitsControllerAccept = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>,
      TError,
      { unitId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerAccept>>,
  TError,
  { unitId: string },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierMallUnitsControllerAcceptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 내 단위를 거절한다. **주문 전체가 취소된다**(다른 공급사 몫 포함) — 사유는 손님과 씨마켓이 본다.
 * @summary 🛒 씨마켓몰 주문 거절 (공급사)
 */
export const externalSupplierMallUnitsControllerDecline = (
  unitId: string,
  declineMallUnitDto: BodyType<DeclineMallUnitDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierMallUnitsControllerDecline200>({
    url: `/external/storefronts/my-mall-units/${unitId}/decline`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: declineMallUnitDto,
    signal,
  });
};

export const getExternalSupplierMallUnitsControllerDeclineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>,
    TError,
    { unitId: string; data: BodyType<DeclineMallUnitDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>,
  TError,
  { unitId: string; data: BodyType<DeclineMallUnitDto> },
  TContext
> => {
  const mutationKey = ["externalSupplierMallUnitsControllerDecline"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>,
    { unitId: string; data: BodyType<DeclineMallUnitDto> }
  > = (props) => {
    const { unitId, data } = props ?? {};

    return externalSupplierMallUnitsControllerDecline(unitId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierMallUnitsControllerDeclineMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>
  >;
export type ExternalSupplierMallUnitsControllerDeclineMutationBody =
  BodyType<DeclineMallUnitDto>;
export type ExternalSupplierMallUnitsControllerDeclineMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 씨마켓몰 주문 거절 (공급사)
 */
export const useExternalSupplierMallUnitsControllerDecline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>,
      TError,
      { unitId: string; data: BodyType<DeclineMallUnitDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierMallUnitsControllerDecline>>,
  TError,
  { unitId: string; data: BodyType<DeclineMallUnitDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierMallUnitsControllerDeclineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 물품관리 표에 생길 단가 열 목록. 마스터가 허용해야 생긴다.
 * @summary 내가 열려 있는 쇼핑몰 (공급사)
 */
export const externalSupplierStorefrontsControllerListMine = (
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMine200>({
    url: `/external/storefronts/mine`,
    method: "GET",
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMineQueryKey = () => {
  return [`/external/storefronts/mine`] as const;
};

export const getExternalSupplierStorefrontsControllerListMineQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalSupplierStorefrontsControllerListMineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>
  > = ({ signal }) => externalSupplierStorefrontsControllerListMine(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalSupplierStorefrontsControllerListMineQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerListMine>>
  >;
export type ExternalSupplierStorefrontsControllerListMineQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMine>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 열려 있는 쇼핑몰 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMine<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMine>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMine>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 물품관리 표 한 페이지분의 품목 id 를 넘기면 그 칸 값들을 준다.
 * @summary 품목별 내 쇼핑몰 단가 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyPrices = (
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyPrices200>({
    url: `/external/storefronts/mine/prices`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyPricesQueryKey = (
  params?: ExternalSupplierStorefrontsControllerListMyPricesParams,
) => {
  return [
    `/external/storefronts/mine/prices`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyPricesQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
    >,
    TError = ErrorType<unknown>,
  >(
    params: ExternalSupplierStorefrontsControllerListMyPricesParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyPricesQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyPrices(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyPricesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyPricesQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 품목별 내 쇼핑몰 단가 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyPrices<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalSupplierStorefrontsControllerListMyPricesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyPrices>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyPricesQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 마스터가 허용한 조합에만 넣을 수 있다. 값을 넣는 순간 그 쇼핑몰에 노출된다.
 * @summary 쇼핑몰 단가 입력 (공급사)
 */
export const externalSupplierStorefrontsControllerSetPrice = (
  storefrontId: string,
  itemId: string,
  setStorefrontPriceDto: BodyType<SetStorefrontPriceDto>,
) => {
  return api<ExternalSupplierStorefrontsControllerSetPrice200>({
    url: `/external/storefronts/${storefrontId}/items/${itemId}/price`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: setStorefrontPriceDto,
  });
};

export const getExternalSupplierStorefrontsControllerSetPriceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
    TError,
    {
      storefrontId: string;
      itemId: string;
      data: BodyType<SetStorefrontPriceDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
  TError,
  {
    storefrontId: string;
    itemId: string;
    data: BodyType<SetStorefrontPriceDto>;
  },
  TContext
> => {
  const mutationKey = ["externalSupplierStorefrontsControllerSetPrice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
    {
      storefrontId: string;
      itemId: string;
      data: BodyType<SetStorefrontPriceDto>;
    }
  > = (props) => {
    const { storefrontId, itemId, data } = props ?? {};

    return externalSupplierStorefrontsControllerSetPrice(
      storefrontId,
      itemId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalSupplierStorefrontsControllerSetPriceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>
  >;
export type ExternalSupplierStorefrontsControllerSetPriceMutationBody =
  BodyType<SetStorefrontPriceDto>;
export type ExternalSupplierStorefrontsControllerSetPriceMutationError =
  ErrorType<unknown>;

/**
 * @summary 쇼핑몰 단가 입력 (공급사)
 */
export const useExternalSupplierStorefrontsControllerSetPrice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
      TError,
      {
        storefrontId: string;
        itemId: string;
        data: BodyType<SetStorefrontPriceDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalSupplierStorefrontsControllerSetPrice>>,
  TError,
  {
    storefrontId: string;
    itemId: string;
    data: BodyType<SetStorefrontPriceDto>;
  },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerSetPriceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이 몰에 허용된 내 품목만 나온다. state 로 «노출 중 / 단가 미입력 / 노출 중지» 를 가른다.
 * @summary 내 몰 상품 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyOfferings = (
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyOfferings200>({
    url: `/external/storefronts/mine/${storefrontId}/offerings`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyOfferingsQueryKey = (
  storefrontId?: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
) => {
  return [
    `/external/storefronts/mine/${storefrontId}/offerings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyOfferingsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
    >,
    TError = ErrorType<unknown>,
  >(
    storefrontId: string,
    params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyOfferingsQueryKey(
        storefrontId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyOfferings(
        storefrontId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!storefrontId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyOfferingsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyOfferingsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params:
    | undefined
    | ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyOfferings
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 몰 상품 목록 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyOfferings<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyOfferings>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyOfferingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalSupplierStorefrontsControllerListMyOfferings
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyOfferingsQueryOptions(
      storefrontId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * copy_base 는 내 단가를 그대로 복사하고, link 는 앞으로도 내 단가를 따라가게 한다. 기본은 미리보기(dryRun)이고, 이미 값이 있는 줄은 덮지 않는다.
 * @summary 몰 단가 일괄 설정 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetPrices = (
  storefrontId: string,
  bulkPriceDto: BodyType<BulkPriceDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerBulkSetPrices200>({
    url: `/external/storefronts/mine/${storefrontId}/prices/bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkPriceDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerBulkSetPricesMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkPriceDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
    >,
    TError,
    { storefrontId: string; data: BodyType<BulkPriceDto> },
    TContext
  > => {
    const mutationKey = ["externalSupplierStorefrontsControllerBulkSetPrices"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      { storefrontId: string; data: BodyType<BulkPriceDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerBulkSetPrices(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
    >
  >;
export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationBody =
  BodyType<BulkPriceDto>;
export type ExternalSupplierStorefrontsControllerBulkSetPricesMutationError =
  ErrorType<unknown>;

/**
 * @summary 몰 단가 일괄 설정 (공급사)
 */
export const useExternalSupplierStorefrontsControllerBulkSetPrices = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkPriceDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerBulkSetPrices>
  >,
  TError,
  { storefrontId: string; data: BodyType<BulkPriceDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerBulkSetPricesMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 품절·단종을 한 번에 내린다. 승인은 남으므로 다시 켤 수 있다.
 * @summary 내 몰 상품 노출 일괄 중지/재개 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetActive = (
  storefrontId: string,
  bulkActiveDto: BodyType<BulkActiveDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerBulkSetActive200>({
    url: `/external/storefronts/mine/${storefrontId}/offerings/bulk-active`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkActiveDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerBulkSetActiveMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkActiveDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
    >,
    TError,
    { storefrontId: string; data: BodyType<BulkActiveDto> },
    TContext
  > => {
    const mutationKey = ["externalSupplierStorefrontsControllerBulkSetActive"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      { storefrontId: string; data: BodyType<BulkActiveDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerBulkSetActive(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
    >
  >;
export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationBody =
  BodyType<BulkActiveDto>;
export type ExternalSupplierStorefrontsControllerBulkSetActiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 내 몰 상품 노출 일괄 중지/재개 (공급사)
 */
export const useExternalSupplierStorefrontsControllerBulkSetActive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
      >,
      TError,
      { storefrontId: string; data: BodyType<BulkActiveDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerBulkSetActive>
  >,
  TError,
  { storefrontId: string; data: BodyType<BulkActiveDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerBulkSetActiveMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 허용되지 않은 품목에 단가를 넣으려 할 때 뜨는 안내의 «요청» 버튼이 이걸 부른다.
 * @summary 이 몰에 품목 승인 요청 (공급사)
 */
export const externalSupplierStorefrontsControllerRequestOffering = (
  storefrontId: string,
  createOfferingRequestDto: BodyType<CreateOfferingRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerRequestOffering201>({
    url: `/external/storefronts/mine/${storefrontId}/requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createOfferingRequestDto,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerRequestOfferingMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      TError,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
    >,
    TError,
    { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
    TContext
  > => {
    const mutationKey = [
      "externalSupplierStorefrontsControllerRequestOffering",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> }
    > = (props) => {
      const { storefrontId, data } = props ?? {};

      return externalSupplierStorefrontsControllerRequestOffering(
        storefrontId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalSupplierStorefrontsControllerRequestOfferingMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
    >
  >;
export type ExternalSupplierStorefrontsControllerRequestOfferingMutationBody =
  BodyType<CreateOfferingRequestDto>;
export type ExternalSupplierStorefrontsControllerRequestOfferingMutationError =
  ErrorType<unknown>;

/**
 * @summary 이 몰에 품목 승인 요청 (공급사)
 */
export const useExternalSupplierStorefrontsControllerRequestOffering = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
      >,
      TError,
      { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerRequestOffering>
  >,
  TError,
  { storefrontId: string; data: BodyType<CreateOfferingRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalSupplierStorefrontsControllerRequestOfferingMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 승인 요청 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyRequests = (
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalSupplierStorefrontsControllerListMyRequests200>({
    url: `/external/storefronts/mine/${storefrontId}/requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalSupplierStorefrontsControllerListMyRequestsQueryKey = (
  storefrontId?: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
) => {
  return [
    `/external/storefronts/mine/${storefrontId}/requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalSupplierStorefrontsControllerListMyRequestsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
    >,
    TError = ErrorType<unknown>,
  >(
    storefrontId: string,
    params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalSupplierStorefrontsControllerListMyRequestsQueryKey(
        storefrontId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
      >
    > = ({ signal }) =>
      externalSupplierStorefrontsControllerListMyRequests(
        storefrontId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!storefrontId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalSupplierStorefrontsControllerListMyRequestsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
    >
  >;
export type ExternalSupplierStorefrontsControllerListMyRequestsQueryError =
  ErrorType<unknown>;

export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params: undefined | ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalSupplierStorefrontsControllerListMyRequests
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 승인 요청 목록 (공급사)
 */

export function useExternalSupplierStorefrontsControllerListMyRequests<
  TData = Awaited<
    ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
  >,
  TError = ErrorType<unknown>,
>(
  storefrontId: string,
  params?: ExternalSupplierStorefrontsControllerListMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalSupplierStorefrontsControllerListMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalSupplierStorefrontsControllerListMyRequestsQueryOptions(
      storefrontId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 외부 임베드 세션에서 견적요청/견적응답 첨부파일을 SEMO 스토리지에 직접 업로드합니다. 최대 10개, 파일당 20MB.
 * @summary 🔼 외부 임시 파일 업로드 (C-Market 발주기관/공급사 공용, 24시간 자동 삭제)
 */
export const externalFilesControllerUploadTemporaryFiles = (
  externalFilesControllerUploadTemporaryFilesBody: BodyType<ExternalFilesControllerUploadTemporaryFilesBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  externalFilesControllerUploadTemporaryFilesBody.files.forEach((value) =>
    formData.append(`files`, value),
  );

  return api<ExternalFilesControllerUploadTemporaryFiles201>({
    url: `/external/files/upload-temporary`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getExternalFilesControllerUploadTemporaryFilesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
    TError,
    { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationKey = ["externalFilesControllerUploadTemporaryFiles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
    { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return externalFilesControllerUploadTemporaryFiles(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalFilesControllerUploadTemporaryFilesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>
  >;
export type ExternalFilesControllerUploadTemporaryFilesMutationBody =
  BodyType<ExternalFilesControllerUploadTemporaryFilesBody>;
export type ExternalFilesControllerUploadTemporaryFilesMutationError =
  ErrorType<void>;

/**
 * @summary 🔼 외부 임시 파일 업로드 (C-Market 발주기관/공급사 공용, 24시간 자동 삭제)
 */
export const useExternalFilesControllerUploadTemporaryFiles = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
      TError,
      { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalFilesControllerUploadTemporaryFiles>>,
  TError,
  { data: BodyType<ExternalFilesControllerUploadTemporaryFilesBody> },
  TContext
> => {
  const mutationOptions =
    getExternalFilesControllerUploadTemporaryFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 외부 발주기관이 주소를 미리 저장하지 않고도 공고를 등록할 수 있도록 주소와 공고를 한 번에 받습니다. 내부적으로 주소를 upsert 한 뒤 그 ID 로 공고를 생성합니다.
 * @summary 발주기관 공고 등록 — 주소 인라인 입력
 */
export const externalQuoteRequestsControllerCreateWithAddress = (
  createExternalQuoteRequestWithAddressDto: BodyType<CreateExternalQuoteRequestWithAddressDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerCreateWithAddress201>({
    url: `/external/quote-requests/with-address`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createExternalQuoteRequestWithAddressDto,
    signal,
  });
};

export const getExternalQuoteRequestsControllerCreateWithAddressMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      TError,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
    >,
    TError,
    { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
    TContext
  > => {
    const mutationKey = ["externalQuoteRequestsControllerCreateWithAddress"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalQuoteRequestsControllerCreateWithAddress(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalQuoteRequestsControllerCreateWithAddressMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>>
  >;
export type ExternalQuoteRequestsControllerCreateWithAddressMutationBody =
  BodyType<CreateExternalQuoteRequestWithAddressDto>;
export type ExternalQuoteRequestsControllerCreateWithAddressMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 등록 — 주소 인라인 입력
 */
export const useExternalQuoteRequestsControllerCreateWithAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>
      >,
      TError,
      { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerCreateWithAddress>>,
  TError,
  { data: BodyType<CreateExternalQuoteRequestWithAddressDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerCreateWithAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 전체 견적 요청 목록 조회 (공급사 · 발주기관)
 */
export const externalQuoteRequestsControllerFindAll = (
  params?: ExternalQuoteRequestsControllerFindAllParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindAll200>({
    url: `/external/quote-requests/all`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindAllQueryKey = (
  params?: ExternalQuoteRequestsControllerFindAllParams,
) => {
  return [`/external/quote-requests/all`, ...(params ? [params] : [])] as const;
};

export const getExternalQuoteRequestsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindAllQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
  > = ({ signal }) => externalQuoteRequestsControllerFindAll(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
>;
export type ExternalQuoteRequestsControllerFindAllQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 전체 견적 요청 목록 조회 (공급사 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindAll<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindAllQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 나의 공고 목록 조회 (발주기관 전용)
 */
export const externalQuoteRequestsControllerFindMine = (
  params?: ExternalQuoteRequestsControllerFindMineParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindMine200>({
    url: `/external/quote-requests/mine`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindMineQueryKey = (
  params?: ExternalQuoteRequestsControllerFindMineParams,
) => {
  return [
    `/external/quote-requests/mine`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalQuoteRequestsControllerFindMineQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindMineQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
  > = ({ signal }) => externalQuoteRequestsControllerFindMine(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
>;
export type ExternalQuoteRequestsControllerFindMineQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindMineParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 나의 공고 목록 조회 (발주기관 전용)
 */

export function useExternalQuoteRequestsControllerFindMine<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindMineQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 응답한 견적 요청 목록 조회 (공급자 전용)
 */
export const externalQuoteRequestsControllerFindResponded = (
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindResponded200>({
    url: `/external/quote-requests/responded`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindRespondedQueryKey = (
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
) => {
  return [
    `/external/quote-requests/responded`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalQuoteRequestsControllerFindRespondedQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindRespondedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>
  > = ({ signal }) =>
    externalQuoteRequestsControllerFindResponded(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindRespondedQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindResponded>>
  >;
export type ExternalQuoteRequestsControllerFindRespondedQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalQuoteRequestsControllerFindRespondedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindResponded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 응답한 견적 요청 목록 조회 (공급자 전용)
 */

export function useExternalQuoteRequestsControllerFindResponded<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindResponded>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalQuoteRequestsControllerFindRespondedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindResponded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindRespondedQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적 요청 상세 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindOne200>({
    url: `/external/quote-requests/${id}`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindOneQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}`] as const;
};

export const getExternalQuoteRequestsControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindOneQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
  > = ({ signal }) => externalQuoteRequestsControllerFindOne(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
>;
export type ExternalQuoteRequestsControllerFindOneQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청 상세 조회 (공급자 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindOne<
  TData = Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalQuoteRequestsControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalQuoteRequestsControllerFindOneQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 본인이 등록한 진행중 공고를 수정합니다. 응답(자동견적 포함)이 하나라도 있거나, 마감됐거나, 진행중이 아니면 409 로 거절합니다. 보내지 않은 필드는 그대로 유지됩니다(PATCH 시맨틱).

**attachments** — 보낸 배열로 목록을 통째로 교체합니다(부분 추가/삭제가 아닙니다). 키를 생략하면 기존 첨부가 유지되고, `[]` 또는 `null` 이면 전체 삭제됩니다. 저장되는 필드는 등록과 같은 `fileName`/`url`/`fileSize`/`contentType` 이며 `filePath` 는 보관하지 않습니다.

**projectName** — 물품(product) 카테고리에서 `items` 를 보내면서 `projectName` 을 생략하면 제목을 품목 기준으로 다시 만듭니다(1건이면 품목명, 2건 이상이면 `첫 품목명 외 N개`). `projectName` 을 명시하면 그 값이 우선합니다. `items` 를 보내지 않으면 제목은 건드리지 않습니다.
 * @summary 발주기관 공고 수정 — 참여 업체가 없을 때만
 */
export const externalQuoteRequestsControllerUpdateOne = (
  id: string,
  updateExternalQuoteRequestDto: BodyType<UpdateExternalQuoteRequestDto>,
) => {
  return api<ExternalQuoteRequestsControllerUpdateOne200>({
    url: `/external/quote-requests/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateExternalQuoteRequestDto,
  });
};

export const getExternalQuoteRequestsControllerUpdateOneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
    TError,
    { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
  TError,
  { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
  TContext
> => {
  const mutationKey = ["externalQuoteRequestsControllerUpdateOne"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
    { id: string; data: BodyType<UpdateExternalQuoteRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalQuoteRequestsControllerUpdateOne(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalQuoteRequestsControllerUpdateOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>
  >;
export type ExternalQuoteRequestsControllerUpdateOneMutationBody =
  BodyType<UpdateExternalQuoteRequestDto>;
export type ExternalQuoteRequestsControllerUpdateOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 수정 — 참여 업체가 없을 때만
 */
export const useExternalQuoteRequestsControllerUpdateOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
      TError,
      { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerUpdateOne>>,
  TError,
  { id: string; data: BodyType<UpdateExternalQuoteRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerUpdateOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 해당 견적요청이 언제 무엇이 바뀌었는지를 최신순으로 돌려줍니다. 씨마켓 경유 수정뿐 아니라 **세모에서 직접 수정한 건도 포함**됩니다.

수정이 없으면 빈 배열입니다(404 아님). 등록·마감은 이 목록에 포함되지 않습니다 — 수정만 담습니다.

`summary` 는 조회 시점에 `changes` 로부터 만들어집니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다. 없는 공고면 404 입니다(빈 배열이 아닙니다).
 * @summary 견적 요청 수정 이력 조회 (최신순)
 */
export const externalQuoteRequestsControllerFindModifications = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindModifications200>({
    url: `/external/quote-requests/${id}/modifications`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindModificationsQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}/modifications`] as const;
};

export const getExternalQuoteRequestsControllerFindModificationsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalQuoteRequestsControllerFindModificationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindModifications>>
  > = ({ signal }) =>
    externalQuoteRequestsControllerFindModifications(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindModifications>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalQuoteRequestsControllerFindModificationsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerFindModifications>>
  >;
export type ExternalQuoteRequestsControllerFindModificationsQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalQuoteRequestsControllerFindModifications>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청 수정 이력 조회 (최신순)
 */

export function useExternalQuoteRequestsControllerFindModifications<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindModifications>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalQuoteRequestsControllerFindModifications>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindModificationsQueryOptions(
      id,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 해당 견적요청으로 체결된 계약의 계약서류를 계약별로 묶어 돌려줍니다. 발주기관은 전체 계약을, 공급사는 자기 계약만 봅니다.

계약이 아직 없으면 빈 배열입니다(404 아님). 취소된 계약은 제외됩니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다.
 * @summary 견적 요청의 계약서류 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindContractDocuments = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalQuoteRequestsControllerFindContractDocuments200>({
    url: `/external/quote-requests/${id}/contract-documents`,
    method: "GET",
    signal,
  });
};

export const getExternalQuoteRequestsControllerFindContractDocumentsQueryKey = (
  id?: string,
) => {
  return [`/external/quote-requests/${id}/contract-documents`] as const;
};

export const getExternalQuoteRequestsControllerFindContractDocumentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
    >,
    TError = ErrorType<unknown>,
  >(
    id: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalQuoteRequestsControllerFindContractDocumentsQueryKey(id);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
      >
    > = ({ signal }) =>
      externalQuoteRequestsControllerFindContractDocuments(id, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalQuoteRequestsControllerFindContractDocumentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
    >
  >;
export type ExternalQuoteRequestsControllerFindContractDocumentsQueryError =
  ErrorType<unknown>;

export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalQuoteRequestsControllerFindContractDocuments
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 요청의 계약서류 조회 (공급자 · 발주기관)
 */

export function useExternalQuoteRequestsControllerFindContractDocuments<
  TData = Awaited<
    ReturnType<typeof externalQuoteRequestsControllerFindContractDocuments>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof externalQuoteRequestsControllerFindContractDocuments
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalQuoteRequestsControllerFindContractDocumentsQueryOptions(
      id,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 본인이 등록한 공고의 마감일시를 바꿉니다(뒤로 미루거나 앞당길 수 있음). 공고 수정과 달리 응답이 있어도 연장할 수 있습니다(연장은 이미 받은 견적을 무효화하지 않습니다). 마감일이 지나 대기(ON_HOLD)로 내려간 공고는 연장과 함께 진행중으로 되돌아갑니다. 새 마감일시가 과거이거나 30일을 넘겨 미루면 400, 이미 마감(CLOSED)된 공고는 409 입니다.
 * @summary 발주기관 공고 마감일 변경(연장·앞당기기) — 참여 업체가 있어도 가능
 */
export const externalQuoteRequestsControllerExtendDeadline = (
  id: string,
  extendExternalQuoteRequestDeadlineDto: BodyType<ExtendExternalQuoteRequestDeadlineDto>,
) => {
  return api<ExternalQuoteRequestsControllerExtendDeadline200>({
    url: `/external/quote-requests/${id}/deadline`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: extendExternalQuoteRequestDeadlineDto,
  });
};

export const getExternalQuoteRequestsControllerExtendDeadlineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
    TError,
    { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
  TError,
  { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
  TContext
> => {
  const mutationKey = ["externalQuoteRequestsControllerExtendDeadline"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
    { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalQuoteRequestsControllerExtendDeadline(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalQuoteRequestsControllerExtendDeadlineMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>
  >;
export type ExternalQuoteRequestsControllerExtendDeadlineMutationBody =
  BodyType<ExtendExternalQuoteRequestDeadlineDto>;
export type ExternalQuoteRequestsControllerExtendDeadlineMutationError =
  ErrorType<unknown>;

/**
 * @summary 발주기관 공고 마감일 변경(연장·앞당기기) — 참여 업체가 있어도 가능
 */
export const useExternalQuoteRequestsControllerExtendDeadline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
      TError,
      { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalQuoteRequestsControllerExtendDeadline>>,
  TError,
  { id: string; data: BodyType<ExtendExternalQuoteRequestDeadlineDto> },
  TContext
> => {
  const mutationOptions =
    getExternalQuoteRequestsControllerExtendDeadlineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 엑셀에서 읽은 줄(계약번호 · 택배사 · 송장번호)로 «그 계약에서 내가 보낼 남은 품목 전부» 를 한 송장으로 한꺼번에 등록한다. 줄마다 따로 처리되어 한 줄이 실패해도 나머지는 등록되고, 결과는 받은 순서대로 줄마다 돌려준다(전부 200 — 줄의 성패는 본문의 ok). 같은 파일을 다시 올려도 이미 다 보낸 계약은 실패(NOTHING_LEFT)로 나올 뿐 중복 등록되지 않는다. 나눠 보내려면 계약별 등록을 쓴다.
 * @summary 계약 송장 엑셀 일괄 등록 (공급사)
 */
export const externalContractsControllerRegisterShipmentsBulk = (
  contractShipmentBulkRegisterDto: BodyType<ContractShipmentBulkRegisterDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerRegisterShipmentsBulk200>({
    url: `/external/contracts/shipments/bulk`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: contractShipmentBulkRegisterDto,
    signal,
  });
};

export const getExternalContractsControllerRegisterShipmentsBulkMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>
      >,
      TError,
      { data: BodyType<ContractShipmentBulkRegisterDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>
    >,
    TError,
    { data: BodyType<ContractShipmentBulkRegisterDto> },
    TContext
  > => {
    const mutationKey = ["externalContractsControllerRegisterShipmentsBulk"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>
      >,
      { data: BodyType<ContractShipmentBulkRegisterDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalContractsControllerRegisterShipmentsBulk(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalContractsControllerRegisterShipmentsBulkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>>
  >;
export type ExternalContractsControllerRegisterShipmentsBulkMutationBody =
  BodyType<ContractShipmentBulkRegisterDto>;
export type ExternalContractsControllerRegisterShipmentsBulkMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 송장 엑셀 일괄 등록 (공급사)
 */
export const useExternalContractsControllerRegisterShipmentsBulk = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>
      >,
      TError,
      { data: BodyType<ContractShipmentBulkRegisterDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerRegisterShipmentsBulk>>,
  TError,
  { data: BodyType<ContractShipmentBulkRegisterDto> },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerRegisterShipmentsBulkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 계약의 송장 목록과 품목별 누적 발송 진행도. 취소된 송장은 목록엔 남고 누적에서 빠진다.
 * @summary 계약 발송 내역 (공급사·발주기관)
 */
export const externalContractsControllerListShipments = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerListShipments200>({
    url: `/external/contracts/${id}/shipments`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerListShipmentsQueryKey = (
  id?: string,
) => {
  return [`/external/contracts/${id}/shipments`] as const;
};

export const getExternalContractsControllerListShipmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerListShipmentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerListShipments>>
  > = ({ signal }) => externalContractsControllerListShipments(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerListShipmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerListShipments>>
>;
export type ExternalContractsControllerListShipmentsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerListShipments<
  TData = Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerListShipments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerListShipments<
  TData = Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerListShipments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerListShipments<
  TData = Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 계약 발송 내역 (공급사·발주기관)
 */

export function useExternalContractsControllerListShipments<
  TData = Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerListShipments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalContractsControllerListShipmentsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 송장 1장 + 실은 품목(계약 품목 순번·수량). 부분 발송 허용, 품목별 누적이 계약 수량을 넘으면 409. 등록되면 채팅방에 시스템 메시지, 발주기관 인앱 알림, 카탈로그 품목은 재고 원장 자동 출고(재고 행이 있을 때만).
 * @summary 계약 물건 발송 등록 (공급사)
 */
export const externalContractsControllerRegisterShipment = (
  id: string,
  registerContractShipmentDto: BodyType<RegisterContractShipmentDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerRegisterShipment201>({
    url: `/external/contracts/${id}/shipments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerContractShipmentDto,
    signal,
  });
};

export const getExternalContractsControllerRegisterShipmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>,
    TError,
    { id: string; data: BodyType<RegisterContractShipmentDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>,
  TError,
  { id: string; data: BodyType<RegisterContractShipmentDto> },
  TContext
> => {
  const mutationKey = ["externalContractsControllerRegisterShipment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>,
    { id: string; data: BodyType<RegisterContractShipmentDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalContractsControllerRegisterShipment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalContractsControllerRegisterShipmentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>
  >;
export type ExternalContractsControllerRegisterShipmentMutationBody =
  BodyType<RegisterContractShipmentDto>;
export type ExternalContractsControllerRegisterShipmentMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 물건 발송 등록 (공급사)
 */
export const useExternalContractsControllerRegisterShipment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>,
      TError,
      { id: string; data: BodyType<RegisterContractShipmentDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerRegisterShipment>>,
  TError,
  { id: string; data: BodyType<RegisterContractShipmentDto> },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerRegisterShipmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 자동 조회가 꺼져 있으면(키 없음) 그대로 돌려준다. 한도 초과·장애도 실패 사유만 남기고 200.
 * @summary 택배 조회 갱신 (스마트택배)
 */
export const externalContractsControllerSyncShipment = (
  id: string,
  shipmentId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerSyncShipment200>({
    url: `/external/contracts/${id}/shipments/${shipmentId}/sync`,
    method: "POST",
    signal,
  });
};

export const getExternalContractsControllerSyncShipmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>,
    TError,
    { id: string; shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>,
  TError,
  { id: string; shipmentId: string },
  TContext
> => {
  const mutationKey = ["externalContractsControllerSyncShipment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>,
    { id: string; shipmentId: string }
  > = (props) => {
    const { id, shipmentId } = props ?? {};

    return externalContractsControllerSyncShipment(id, shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalContractsControllerSyncShipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>
>;

export type ExternalContractsControllerSyncShipmentMutationError =
  ErrorType<unknown>;

/**
 * @summary 택배 조회 갱신 (스마트택배)
 */
export const useExternalContractsControllerSyncShipment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>,
      TError,
      { id: string; shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerSyncShipment>>,
  TError,
  { id: string; shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerSyncShipmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 택배사·송장번호·메모 수정, 또는 DELIVERED(배송 완료)/CANCELED(송장 취소) 전이.
 * @summary 계약 송장 수정 (공급사)
 */
export const externalContractsControllerUpdateShipment = (
  id: string,
  shipmentId: string,
  updateContractShipmentDto: BodyType<UpdateContractShipmentDto>,
) => {
  return api<ExternalContractsControllerUpdateShipment200>({
    url: `/external/contracts/${id}/shipments/${shipmentId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateContractShipmentDto,
  });
};

export const getExternalContractsControllerUpdateShipmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>,
    TError,
    {
      id: string;
      shipmentId: string;
      data: BodyType<UpdateContractShipmentDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>,
  TError,
  { id: string; shipmentId: string; data: BodyType<UpdateContractShipmentDto> },
  TContext
> => {
  const mutationKey = ["externalContractsControllerUpdateShipment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>,
    {
      id: string;
      shipmentId: string;
      data: BodyType<UpdateContractShipmentDto>;
    }
  > = (props) => {
    const { id, shipmentId, data } = props ?? {};

    return externalContractsControllerUpdateShipment(id, shipmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalContractsControllerUpdateShipmentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>
  >;
export type ExternalContractsControllerUpdateShipmentMutationBody =
  BodyType<UpdateContractShipmentDto>;
export type ExternalContractsControllerUpdateShipmentMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 송장 수정 (공급사)
 */
export const useExternalContractsControllerUpdateShipment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>,
      TError,
      {
        id: string;
        shipmentId: string;
        data: BodyType<UpdateContractShipmentDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerUpdateShipment>>,
  TError,
  { id: string; shipmentId: string; data: BodyType<UpdateContractShipmentDto> },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerUpdateShipmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 현재 로그인된 공급자의 모든 계약 내역을 조회합니다.
 * @summary 공급자 계약 리스트 조회 (C-Market)
 */
export const externalContractsControllerGetContracts = (
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetContracts200>({
    url: `/external/contracts`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetContractsQueryKey = () => {
  return [`/external/contracts`] as const;
};

export const getExternalContractsControllerGetContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetContractsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
  > = ({ signal }) => externalContractsControllerGetContracts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
>;
export type ExternalContractsControllerGetContractsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 계약 리스트 조회 (C-Market)
 */

export function useExternalContractsControllerGetContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalContractsControllerGetContractsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 현재 로그인된 발주기관이 체결한 계약을 SEMO 나의 계약과 동일한 기준으로 조회합니다.
 * @summary 발주기관 나의 계약 목록 조회 (C-Market)
 */
export const externalContractsControllerGetMyContracts = (
  params?: ExternalContractsControllerGetMyContractsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetMyContracts200>({
    url: `/external/contracts/mine`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalContractsControllerGetMyContractsQueryKey = (
  params?: ExternalContractsControllerGetMyContractsParams,
) => {
  return [`/external/contracts/mine`, ...(params ? [params] : [])] as const;
};

export const getExternalContractsControllerGetMyContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetMyContractsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
  > = ({ signal }) => externalContractsControllerGetMyContracts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetMyContractsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
>;
export type ExternalContractsControllerGetMyContractsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalContractsControllerGetMyContractsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 발주기관 나의 계약 목록 조회 (C-Market)
 */

export function useExternalContractsControllerGetMyContracts<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalContractsControllerGetMyContractsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetMyContracts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalContractsControllerGetMyContractsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 현재 로그인된 공급자의 정산 내역을 조회합니다.
 * @summary 공급자 정산 내역 조회 (C-Market)
 */
export const externalContractsControllerGetSettlements = (
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetSettlements200>({
    url: `/external/contracts/settlements`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetSettlementsQueryKey = () => {
  return [`/external/contracts/settlements`] as const;
};

export const getExternalContractsControllerGetSettlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetSettlementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
  > = ({ signal }) => externalContractsControllerGetSettlements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetSettlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
>;
export type ExternalContractsControllerGetSettlementsQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 정산 내역 조회 (C-Market)
 */

export function useExternalContractsControllerGetSettlements<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetSettlements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalContractsControllerGetSettlementsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 계약의 상세 정보를 조회합니다.
 * @summary 공급자 계약 상세 조회 (C-Market)
 */
export const externalContractsControllerGetContract = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerGetContract200>({
    url: `/external/contracts/${id}`,
    method: "GET",
    signal,
  });
};

export const getExternalContractsControllerGetContractQueryKey = (
  id?: string,
) => {
  return [`/external/contracts/${id}`] as const;
};

export const getExternalContractsControllerGetContractQueryOptions = <
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalContractsControllerGetContractQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalContractsControllerGetContract>>
  > = ({ signal }) => externalContractsControllerGetContract(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalContractsControllerGetContractQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalContractsControllerGetContract>>
>;
export type ExternalContractsControllerGetContractQueryError =
  ErrorType<unknown>;

export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
          TError,
          Awaited<ReturnType<typeof externalContractsControllerGetContract>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공급자 계약 상세 조회 (C-Market)
 */

export function useExternalContractsControllerGetContract<
  TData = Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalContractsControllerGetContract>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalContractsControllerGetContractQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 계약 당사자(발주기관 또는 공급사)가 취소를 요청합니다. 요청 주체는 세션의 userType에서 판정되며, 반대편 당사자에게 알림/채팅이 발송됩니다. 공급사 요청 시 환불 계좌 정보는 무시되고 결제 원장의 원래 결제 방식대로 처리됩니다.
 * @summary 계약 취소 요청 (C-Market 발주기관 또는 공급사 → 상대편 승인 대기)
 */
export const externalContractsControllerRequestCancellation = (
  id: string,
  cancelContractRequestDto: BodyType<CancelContractRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalContractsControllerRequestCancellation200>({
    url: `/external/contracts/${id}/cancellation-request`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cancelContractRequestDto,
    signal,
  });
};

export const getExternalContractsControllerRequestCancellationMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>,
    TError,
    { id: string; data: BodyType<CancelContractRequestDto> },
    TContext
  > => {
    const mutationKey = ["externalContractsControllerRequestCancellation"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      { id: string; data: BodyType<CancelContractRequestDto> }
    > = (props) => {
      const { id, data } = props ?? {};

      return externalContractsControllerRequestCancellation(id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalContractsControllerRequestCancellationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>
  >;
export type ExternalContractsControllerRequestCancellationMutationBody =
  BodyType<CancelContractRequestDto>;
export type ExternalContractsControllerRequestCancellationMutationError =
  ErrorType<unknown>;

/**
 * @summary 계약 취소 요청 (C-Market 발주기관 또는 공급사 → 상대편 승인 대기)
 */
export const useExternalContractsControllerRequestCancellation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalContractsControllerRequestCancellation>
      >,
      TError,
      { id: string; data: BodyType<CancelContractRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalContractsControllerRequestCancellation>>,
  TError,
  { id: string; data: BodyType<CancelContractRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalContractsControllerRequestCancellationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓 결제창에서 카드 승인이 완료되면 호출된다. 수신 즉시 세모에 계약을 확정한다. 재전송돼도 계약이 중복 생성되지 않는다(멱등) — 이미 확정된 건은 alreadyConfirmed=true 로 응답.
 * @summary 씨마켓 카드결제 완료 통지 (업체 직접 계약)
 */
export const externalPaymentsControllerConfirmCardPayment = (
  cmarketCardPaymentCallbackDto: BodyType<CmarketCardPaymentCallbackDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalPaymentsControllerConfirmCardPayment201>({
    url: `/external/payments/cmarket/callback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketCardPaymentCallbackDto,
    signal,
  });
};

export const getExternalPaymentsControllerConfirmCardPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
    TError,
    { data: BodyType<CmarketCardPaymentCallbackDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
  TError,
  { data: BodyType<CmarketCardPaymentCallbackDto> },
  TContext
> => {
  const mutationKey = ["externalPaymentsControllerConfirmCardPayment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
    { data: BodyType<CmarketCardPaymentCallbackDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalPaymentsControllerConfirmCardPayment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalPaymentsControllerConfirmCardPaymentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>
  >;
export type ExternalPaymentsControllerConfirmCardPaymentMutationBody =
  BodyType<CmarketCardPaymentCallbackDto>;
export type ExternalPaymentsControllerConfirmCardPaymentMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 카드결제 완료 통지 (업체 직접 계약)
 */
export const useExternalPaymentsControllerConfirmCardPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
      TError,
      { data: BodyType<CmarketCardPaymentCallbackDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalPaymentsControllerConfirmCardPayment>>,
  TError,
  { data: BodyType<CmarketCardPaymentCallbackDto> },
  TContext
> => {
  const mutationOptions =
    getExternalPaymentsControllerConfirmCardPaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 파트너에서 탈퇴·정지된 회원을 세모에서도 비활성 처리합니다. 프로필은 변경하지 않습니다. 같은 값으로 여러 번 호출해도 안전합니다(changed=false). 세모에 아직 계정이 없으면 404.
 * @summary 파트너 계정 활성/비활성 전환
 */
export const externalAccountStatusControllerUpdateStatus = (
  updateExternalAccountStatusDto: BodyType<UpdateExternalAccountStatusDto>,
) => {
  return api<ExternalAccountStatusControllerUpdateStatus200>({
    url: `/external/accounts/status`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateExternalAccountStatusDto,
  });
};

export const getExternalAccountStatusControllerUpdateStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
    TError,
    { data: BodyType<UpdateExternalAccountStatusDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
  TError,
  { data: BodyType<UpdateExternalAccountStatusDto> },
  TContext
> => {
  const mutationKey = ["externalAccountStatusControllerUpdateStatus"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
    { data: BodyType<UpdateExternalAccountStatusDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalAccountStatusControllerUpdateStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAccountStatusControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>
  >;
export type ExternalAccountStatusControllerUpdateStatusMutationBody =
  BodyType<UpdateExternalAccountStatusDto>;
export type ExternalAccountStatusControllerUpdateStatusMutationError =
  ErrorType<unknown>;

/**
 * @summary 파트너 계정 활성/비활성 전환
 */
export const useExternalAccountStatusControllerUpdateStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
      TError,
      { data: BodyType<UpdateExternalAccountStatusDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAccountStatusControllerUpdateStatus>>,
  TError,
  { data: BodyType<UpdateExternalAccountStatusDto> },
  TContext
> => {
  const mutationOptions =
    getExternalAccountStatusControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓 나의 계약 관리에서 계산서가 발행요청·발행·취소되면 호출된다. 같은 통지가 다시 와도 계약 상태가 어긋나지 않는다(멱등). 발행완료 계약에 요청 통지가 뒤늦게 닿으면 무시하고 ignoredAsStale=true 로 응답한다.
 * @summary 씨마켓 계산서 요청·발행·취소 통지
 */
export const externalTaxInvoicesControllerApplyTaxInvoiceEvent = (
  cmarketTaxInvoiceCallbackDto: BodyType<CmarketTaxInvoiceCallbackDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200>({
    url: `/external/tax-invoices/cmarket/callback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketTaxInvoiceCallbackDto,
    signal,
  });
};

export const getExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      TError,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
    >,
    TError,
    { data: BodyType<CmarketTaxInvoiceCallbackDto> },
    TContext
  > => {
    const mutationKey = ["externalTaxInvoicesControllerApplyTaxInvoiceEvent"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalTaxInvoicesControllerApplyTaxInvoiceEvent(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
    >
  >;
export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationBody =
  BodyType<CmarketTaxInvoiceCallbackDto>;
export type ExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 계산서 요청·발행·취소 통지
 */
export const useExternalTaxInvoicesControllerApplyTaxInvoiceEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>
      >,
      TError,
      { data: BodyType<CmarketTaxInvoiceCallbackDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTaxInvoicesControllerApplyTaxInvoiceEvent>>,
  TError,
  { data: BodyType<CmarketTaxInvoiceCallbackDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTaxInvoicesControllerApplyTaxInvoiceEventMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓에서 세모 수수료 청구가 납부되면 호출된다. 정산 대기(PENDING) 계약을 입금 완료로 바꾸고 입금일은 씨마켓 납부 시각이다. 이미 완료·보류·취소 계약은 changed=false(멱등).
 * @summary 씨마켓 견적 수수료 납부 통지
 */
export const externalCmarketFeeBillsControllerApplyPaid = (
  cmarketFeeBillPaidDto: BodyType<CmarketFeeBillPaidDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketFeeBillsControllerApplyPaid200>({
    url: `/external/cmarket/fee-bills/paid`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketFeeBillPaidDto,
    signal,
  });
};

export const getExternalCmarketFeeBillsControllerApplyPaidMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>,
    TError,
    { data: BodyType<CmarketFeeBillPaidDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>,
  TError,
  { data: BodyType<CmarketFeeBillPaidDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketFeeBillsControllerApplyPaid"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>,
    { data: BodyType<CmarketFeeBillPaidDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketFeeBillsControllerApplyPaid(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketFeeBillsControllerApplyPaidMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>
  >;
export type ExternalCmarketFeeBillsControllerApplyPaidMutationBody =
  BodyType<CmarketFeeBillPaidDto>;
export type ExternalCmarketFeeBillsControllerApplyPaidMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 견적 수수료 납부 통지
 */
export const useExternalCmarketFeeBillsControllerApplyPaid = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>,
      TError,
      { data: BodyType<CmarketFeeBillPaidDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketFeeBillsControllerApplyPaid>>,
  TError,
  { data: BodyType<CmarketFeeBillPaidDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketFeeBillsControllerApplyPaidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * since 이후 성사된(계약이 만들어진) 계약 중 씨마켓에서 들어온 공급사의 것만, 성사 시각 오름차순으로 한 페이지. 알림에 필요한 최소 필드(계약 id·씨마켓 회원 id·상태·성사 시각·견적 번호·견적 제목)만 준다 — 금액·발주기관·연락처는 없다. 삭제된 계약과 정지된 공급사 계정의 계약은 빠진다. 다음 페이지는 nextCursor 를 그대로 보내고 since 는 첫 페이지와 같게. 결과가 없어도 200(빈 items).
 * @summary 씨마켓 공급사의 성사 계약 피드(견적 계약 성사 알림용)
 */
export const externalCmarketContractsControllerListConcluded = (
  params: ExternalCmarketContractsControllerListConcludedParams,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketContractsControllerListConcluded200>({
    url: `/external/cmarket/contracts/concluded`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalCmarketContractsControllerListConcludedQueryKey = (
  params?: ExternalCmarketContractsControllerListConcludedParams,
) => {
  return [
    `/external/cmarket/contracts/concluded`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalCmarketContractsControllerListConcludedQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalCmarketContractsControllerListConcluded>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalCmarketContractsControllerListConcludedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketContractsControllerListConcluded>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalCmarketContractsControllerListConcludedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalCmarketContractsControllerListConcluded>>
  > = ({ signal }) =>
    externalCmarketContractsControllerListConcluded(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalCmarketContractsControllerListConcluded>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalCmarketContractsControllerListConcludedQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketContractsControllerListConcluded>>
  >;
export type ExternalCmarketContractsControllerListConcludedQueryError =
  ErrorType<unknown>;

export function useExternalCmarketContractsControllerListConcluded<
  TData = Awaited<
    ReturnType<typeof externalCmarketContractsControllerListConcluded>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalCmarketContractsControllerListConcludedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketContractsControllerListConcluded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCmarketContractsControllerListConcluded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCmarketContractsControllerListConcluded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCmarketContractsControllerListConcluded<
  TData = Awaited<
    ReturnType<typeof externalCmarketContractsControllerListConcluded>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalCmarketContractsControllerListConcludedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketContractsControllerListConcluded>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCmarketContractsControllerListConcluded>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCmarketContractsControllerListConcluded>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCmarketContractsControllerListConcluded<
  TData = Awaited<
    ReturnType<typeof externalCmarketContractsControllerListConcluded>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalCmarketContractsControllerListConcludedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketContractsControllerListConcluded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 씨마켓 공급사의 성사 계약 피드(견적 계약 성사 알림용)
 */

export function useExternalCmarketContractsControllerListConcluded<
  TData = Awaited<
    ReturnType<typeof externalCmarketContractsControllerListConcluded>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalCmarketContractsControllerListConcludedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketContractsControllerListConcluded>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalCmarketContractsControllerListConcludedQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 발주기관 소유와 무관하게, 공개 여부와도 무관하게 세모의 견적요청 전체를 페이지로 돌려줍니다. 회원 토큰이 아니라 파트너 API 키(`X-API-Key`)로 호출합니다.

**`buyerMemberId`** 는 씨마켓 임베드로 가입한 발주기관만 값이 있습니다. 세모에 직접 가입한 발주기관은 `null` 이며, 이 목록에는 그 건도 함께 나옵니다(그것이 이 API 의 목적입니다).

**`responseCount`** 는 캐시 컬럼 기준입니다 — 목록 표시용이며 정산·판정 근거로 쓰지 마세요.

**`isPublic` 필터는 제공하지 않습니다.** 어드민은 공개·비공개를 모두 봐야 하므로 항상 전체가 기본값입니다.

**`categoryType`** 은 단일 값 필터이며(`product`·`construction`·`manufacturing`·`used`), 응답의 `categoryType` 이 내려주는 값을 그대로 넣습니다. `meta.totalCount` 는 **필터가 적용된 건수**입니다 — 페이지 수 계산에 그대로 쓰면 됩니다. 목록에 없는 값을 넣으면 400 이며, 조용히 전체를 돌려주지 않습니다.

**진행중·마감 탭은 `isClosed` 하나로 거세요.** `isClosed=true` 는 수동 마감(`status=CLOSED`) **또는** 마감일 경과입니다 — 이 OR 는 서버가 한 쿼리로 걸어야 총 건수가 맞습니다. 파라미터끼리는 AND 라 `status=CLOSED` 와 `deadlineTo` 를 함께 걸면 교집합이 나옵니다.

**`deadlineFrom`·`deadlineTo`** 는 마감일 축의 범위 필터입니다(`publishedFrom`·`publishedTo` 는 등록일 축이라 다릅니다).

**`status`** 는 계약이 걸린 건을 `CONTRACT_IN_PROGRESS` 로 내려 줍니다 — 상세(`GET /external/quote-requests/{id}`)·회원 피드와 같은 값이라 목록과 상세가 다른 배지를 그리지 않습니다. 계약이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)입니다.

필터로도 네 값을 모두 받습니다. 다만 **`status` 필터는 DB 상태 축**이라, `IN_PROGRESS` 로 거르면 계약이 걸린 건(응답에는 `CONTRACT_IN_PROGRESS` 로 나오는 건)도 DB 상태가 `IN_PROGRESS` 인 한 함께 나옵니다. 계약 건만 고르려면 `status=CONTRACT_IN_PROGRESS` 를 쓰세요.
 * @summary 견적공고 전체 목록 (씨마켓 어드민 전용, 서비스 인증)
 */
export const externalAdminQuoteRequestsControllerFindAll = (
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminQuoteRequestsControllerFindAll200>({
    url: `/external/admin/quote-requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminQuoteRequestsControllerFindAllQueryKey = (
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
) => {
  return [
    `/external/admin/quote-requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalAdminQuoteRequestsControllerFindAllQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminQuoteRequestsControllerFindAllQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>
  > = ({ signal }) =>
    externalAdminQuoteRequestsControllerFindAll(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminQuoteRequestsControllerFindAllQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>
  >;
export type ExternalAdminQuoteRequestsControllerFindAllQueryError =
  ErrorType<unknown>;

export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalAdminQuoteRequestsControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적공고 전체 목록 (씨마켓 어드민 전용, 서비스 인증)
 */

export function useExternalAdminQuoteRequestsControllerFindAll<
  TData = Awaited<
    ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminQuoteRequestsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalAdminQuoteRequestsControllerFindAllQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 견적요청을 **사용자 화면에서 감춥니다**. 행은 지우지 않으므로 `POST /external/admin/quote-requests/{id}/restore` 로 되돌릴 수 있습니다.

**식별자**는 조회와 같습니다 — UUID · 공고번호(`AA0115`) · bid id(`AA0115_2`) 모두 받습니다.

**딸린 계약·결제·공급사 견적·채팅방이 함께 감춰집니다.** 공고만 감추면 발주기관 「나의 계약」과 공급사 「내 견적」에 그대로 남기 때문입니다. 참여 업체가 있어도 막지 않습니다.

어드민 목록·정산·수수료 집계는 계속 보입니다 — 감추는 곳은 발주기관·공급사 화면뿐입니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 지웠는지 감사 로그에 남깁니다. 파트너 키만으로는 "씨마켓" 까지만 식별됩니다.
 * @summary 견적공고 삭제 (씨마켓 어드민 전용, 복원 가능)
 */
export const externalAdminQuoteRequestsControllerDeleteOne = (id: string) => {
  return api<ExternalAdminQuoteRequestsControllerDeleteOne200>({
    url: `/external/admin/quote-requests/${id}`,
    method: "DELETE",
  });
};

export const getExternalAdminQuoteRequestsControllerDeleteOneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalAdminQuoteRequestsControllerDeleteOne"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalAdminQuoteRequestsControllerDeleteOne(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminQuoteRequestsControllerDeleteOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>
  >;

export type ExternalAdminQuoteRequestsControllerDeleteOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적공고 삭제 (씨마켓 어드민 전용, 복원 가능)
 */
export const useExternalAdminQuoteRequestsControllerDeleteOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerDeleteOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminQuoteRequestsControllerDeleteOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 삭제된 견적요청과 **함께 감춰졌던 계약·결제·견적·채팅방**을 사용자 화면으로 되돌립니다.

삭제되지 않은 공고에 부르면 아무 것도 하지 않고 성공합니다(멱등).

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 견적공고 삭제 취소 (씨마켓 어드민 전용)
 */
export const externalAdminQuoteRequestsControllerRestoreOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminQuoteRequestsControllerRestoreOne200>({
    url: `/external/admin/quote-requests/${id}/restore`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminQuoteRequestsControllerRestoreOneMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      TError,
      { id: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>,
    TError,
    { id: string },
    TContext
  > => {
    const mutationKey = ["externalAdminQuoteRequestsControllerRestoreOne"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      { id: string }
    > = (props) => {
      const { id } = props ?? {};

      return externalAdminQuoteRequestsControllerRestoreOne(id);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalAdminQuoteRequestsControllerRestoreOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>
  >;

export type ExternalAdminQuoteRequestsControllerRestoreOneMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적공고 삭제 취소 (씨마켓 어드민 전용)
 */
export const useExternalAdminQuoteRequestsControllerRestoreOne = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>
      >,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminQuoteRequestsControllerRestoreOne>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminQuoteRequestsControllerRestoreOneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `quoteRequestId` · `requestNumber` · `externalSupplierId` 중 **최소 하나**로 방을 찾습니다. 조건이 하나도 없으면 400 입니다(전량 조회는 열지 않습니다).

`requestNumber` 는 씨마켓 bid id 형태('AA0014_2')도 받습니다 — `_` 뒤를 떼고 `SE` 접두사를 붙여 해석합니다.

`externalSupplierId` 는 씨마켓 공급사 회원 ID 입니다(SEMO `suppliers.supplier_id`).
 * @summary 채팅방 목록 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindRooms = (
  params?: ExternalAdminChatControllerFindRoomsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminChatControllerFindRooms200>({
    url: `/external/admin/chat-rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminChatControllerFindRoomsQueryKey = (
  params?: ExternalAdminChatControllerFindRoomsParams,
) => {
  return [`/external/admin/chat-rooms`, ...(params ? [params] : [])] as const;
};

export const getExternalAdminChatControllerFindRoomsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminChatControllerFindRoomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
  > = ({ signal }) => externalAdminChatControllerFindRooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminChatControllerFindRoomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
>;
export type ExternalAdminChatControllerFindRoomsQueryError = ErrorType<unknown>;

export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalAdminChatControllerFindRoomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅방 목록 조회 (씨마켓 운영자 전용, 읽기 전용)
 */

export function useExternalAdminChatControllerFindRooms<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalAdminChatControllerFindRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalAdminChatControllerFindRoomsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 응답 형태는 회원용 `GET /chat/rooms/{roomId}/messages` 와 **동일합니다** — admin2 가 기존 화면 코드를 그대로 씁니다.

**발주기관이 본 그대로**를 돌려줍니다. 공급사에게 숨기는 카드(계약서류 선택 등)까지 포함한 전체입니다 — 운영자가 문의에 답하려면 반쪽이 아니라 전체가 필요합니다.

첨부는 만료가 짧은 서명 URL 로 내려갑니다(회원 경로와 같은 생성기).
 * @summary 채팅 메시지 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindMessages = (
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminChatControllerFindMessages200>({
    url: `/external/admin/chat-rooms/${roomId}/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalAdminChatControllerFindMessagesQueryKey = (
  roomId?: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
) => {
  return [
    `/external/admin/chat-rooms/${roomId}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalAdminChatControllerFindMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalAdminChatControllerFindMessagesQueryKey(roomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
  > = ({ signal }) =>
    externalAdminChatControllerFindMessages(roomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalAdminChatControllerFindMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
>;
export type ExternalAdminChatControllerFindMessagesQueryError =
  ErrorType<unknown>;

export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params: undefined | ExternalAdminChatControllerFindMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
          TError,
          Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채팅 메시지 조회 (씨마켓 운영자 전용, 읽기 전용)
 */

export function useExternalAdminChatControllerFindMessages<
  TData = Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
  TError = ErrorType<unknown>,
>(
  roomId: string,
  params?: ExternalAdminChatControllerFindMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalAdminChatControllerFindMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalAdminChatControllerFindMessagesQueryOptions(
    roomId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 이 참여(채팅방 + 딸린 견적)를 **발주기관·공급사 화면에서 감춥니다.** 참여 수와 「견적 N건」에서도 함께 빠집니다.

운영자 목록(`GET /external/admin/chat-rooms`)에는 `participationState: "hidden"` 으로 계속 나옵니다 — 감춘 것이 보여야 되살릴 수 있습니다.

**계약이 진행 중이거나 결제가 오간 참여는 409 로 막힙니다.** 계약서·세금계산서가 그 견적을 되읽기 때문에, 감추는 순간 데이터 정리가 아니라 기능 고장이 됩니다.

이미 숨김 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 감췄는지 감사 로그에 남깁니다.
 * @summary 공급사 참여 이력 숨기기 (씨마켓 운영자 전용, 되살릴 수 있음)
 */
export const externalAdminParticipationsControllerHide = (
  roomId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminParticipationsControllerHide200>({
    url: `/external/admin/participations/${roomId}/hide`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminParticipationsControllerHideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerHide"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerHide(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerHideMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>
  >;

export type ExternalAdminParticipationsControllerHideMutationError =
  ErrorType<unknown>;

/**
 * @summary 공급사 참여 이력 숨기기 (씨마켓 운영자 전용, 되살릴 수 있음)
 */
export const useExternalAdminParticipationsControllerHide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerHide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerHideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 숨김 상태의 참여를 발주기관·공급사 화면으로 되돌립니다. 참여 수와 「견적 N건」도 함께 돌아옵니다.

이미 정상 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 숨긴 참여 이력 되살리기 (씨마켓 운영자 전용)
 */
export const externalAdminParticipationsControllerUnhide = (
  roomId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalAdminParticipationsControllerUnhide200>({
    url: `/external/admin/participations/${roomId}/unhide`,
    method: "POST",
    signal,
  });
};

export const getExternalAdminParticipationsControllerUnhideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerUnhide"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerUnhide(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerUnhideMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>
  >;

export type ExternalAdminParticipationsControllerUnhideMutationError =
  ErrorType<unknown>;

/**
 * @summary 숨긴 참여 이력 되살리기 (씨마켓 운영자 전용)
 */
export const useExternalAdminParticipationsControllerUnhide = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerUnhide>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerUnhideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 숨김 상태의 참여를 **실제로 지웁니다.** 견적·견적서 버전·대화방과 그 업체와 주고받은 대화가 함께 사라지며 **되돌릴 수 없습니다.**

**숨김을 거치지 않은 참여는 409 로 막힙니다** — 먼저 `POST /external/admin/participations/{roomId}/hide` 를 부르고, 감춰진 결과를 확인한 뒤에 지웁니다. 계약·결제가 걸린 참여도 409 입니다.

무엇이 사라졌는지를 수치로 돌려줍니다. 화면에서 사람에게 그대로 보여 주십시오.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 참여 이력 삭제 (씨마켓 운영자 전용) — 되돌릴 수 없음
 */
export const externalAdminParticipationsControllerRemove = (roomId: string) => {
  return api<ExternalAdminParticipationsControllerRemove200>({
    url: `/external/admin/participations/${roomId}`,
    method: "DELETE",
  });
};

export const getExternalAdminParticipationsControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
    TError,
    { roomId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationKey = ["externalAdminParticipationsControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
    { roomId: string }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalAdminParticipationsControllerRemove(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalAdminParticipationsControllerRemoveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>
  >;

export type ExternalAdminParticipationsControllerRemoveMutationError =
  ErrorType<unknown>;

/**
 * @summary 참여 이력 삭제 (씨마켓 운영자 전용) — 되돌릴 수 없음
 */
export const useExternalAdminParticipationsControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
      TError,
      { roomId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalAdminParticipationsControllerRemove>>,
  TError,
  { roomId: string },
  TContext
> => {
  const mutationOptions =
    getExternalAdminParticipationsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 인니 발주자의 RFQ 1건 또는 「팝니다」 한 자리를 세모 공고로 연다. `externalRef` 로 멱등하다 — 같은 본문이면 `UNCHANGED`, 다른 본문이면 409(`TRADE_001`). 내용을 바꾸려면 PUT. 국내 탐색·자동견적·알림 대상이 되지 않는다.
 * @summary 트레이드 프로젝트(공고) 생성
 */
export const externalTradeControllerCreateProject = (
  createTradeProjectRequestDto: BodyType<CreateTradeProjectRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerCreateProject200>({
    url: `/external/trade/projects`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeProjectRequestDto,
    signal,
  });
};

export const getExternalTradeControllerCreateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerCreateProject>>,
    TError,
    { data: BodyType<CreateTradeProjectRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerCreateProject>>,
  TError,
  { data: BodyType<CreateTradeProjectRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerCreateProject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerCreateProject>>,
    { data: BodyType<CreateTradeProjectRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeControllerCreateProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerCreateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerCreateProject>>
>;
export type ExternalTradeControllerCreateProjectMutationBody =
  BodyType<CreateTradeProjectRequestDto>;
export type ExternalTradeControllerCreateProjectMutationError =
  ErrorType<unknown>;

/**
 * @summary 트레이드 프로젝트(공고) 생성
 */
export const useExternalTradeControllerCreateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerCreateProject>>,
      TError,
      { data: BodyType<CreateTradeProjectRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerCreateProject>>,
  TError,
  { data: BodyType<CreateTradeProjectRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerCreateProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `updatedSince` 이후 바뀐 공고를 updated_at 순 커서로 준다. 짝 맞추기 배치의 재료.
 * @summary 트레이드 프로젝트 미러 목록
 */
export const externalTradeControllerListProjects = (
  params?: ExternalTradeControllerListProjectsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerListProjects200>({
    url: `/external/trade/projects`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeControllerListProjectsQueryKey = (
  params?: ExternalTradeControllerListProjectsParams,
) => {
  return [`/external/trade/projects`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeControllerListProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerListProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerListProjectsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerListProjects>>
  > = ({ signal }) => externalTradeControllerListProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerListProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerListProjects>>
>;
export type ExternalTradeControllerListProjectsQueryError = ErrorType<unknown>;

export function useExternalTradeControllerListProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeControllerListProjectsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerListProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerListProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerListProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerListProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerListProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerListProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트레이드 프로젝트 미러 목록
 */

export function useExternalTradeControllerListProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerListProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerListProjectsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 씨마켓에서 RFQ 가 고쳐지면 미러도 따라간다. 전체 교체다. `sourceVersion`(씨마켓 원장 버전)이 저장된 것보다 새 것만 적용하고, 같거나 옛 것이면 `UNCHANGED`(늦게 도착한 옛 요청). 마감·취소된 공고는 409(`TRADE_002`).
 * @summary 트레이드 프로젝트 내용 갱신
 */
export const externalTradeControllerReplaceProject = (
  projectId: string,
  replaceTradeProjectRequestDto: BodyType<ReplaceTradeProjectRequestDto>,
) => {
  return api<ExternalTradeControllerReplaceProject200>({
    url: `/external/trade/projects/${projectId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: replaceTradeProjectRequestDto,
  });
};

export const getExternalTradeControllerReplaceProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>,
    TError,
    { projectId: string; data: BodyType<ReplaceTradeProjectRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>,
  TError,
  { projectId: string; data: BodyType<ReplaceTradeProjectRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerReplaceProject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>,
    { projectId: string; data: BodyType<ReplaceTradeProjectRequestDto> }
  > = (props) => {
    const { projectId, data } = props ?? {};

    return externalTradeControllerReplaceProject(projectId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerReplaceProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>
>;
export type ExternalTradeControllerReplaceProjectMutationBody =
  BodyType<ReplaceTradeProjectRequestDto>;
export type ExternalTradeControllerReplaceProjectMutationError =
  ErrorType<unknown>;

/**
 * @summary 트레이드 프로젝트 내용 갱신
 */
export const useExternalTradeControllerReplaceProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>,
      TError,
      { projectId: string; data: BodyType<ReplaceTradeProjectRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerReplaceProject>>,
  TError,
  { projectId: string; data: BodyType<ReplaceTradeProjectRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerReplaceProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓에서 RFQ 가 닫히거나 취소되면 세모 공고도 닫는다. 이 공고의 모든 대화방이 읽기 전용이 된다. 이미 닫혀 있으면 `UNCHANGED` — 재시도가 안전하다. 되돌리는 길은 없다.
 * @summary 트레이드 프로젝트 마감·취소
 */
export const externalTradeControllerUpdateProject = (
  projectId: string,
  updateTradeProjectRequestDto: BodyType<UpdateTradeProjectRequestDto>,
) => {
  return api<ExternalTradeControllerUpdateProject200>({
    url: `/external/trade/projects/${projectId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateTradeProjectRequestDto,
  });
};

export const getExternalTradeControllerUpdateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>,
    TError,
    { projectId: string; data: BodyType<UpdateTradeProjectRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>,
  TError,
  { projectId: string; data: BodyType<UpdateTradeProjectRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerUpdateProject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>,
    { projectId: string; data: BodyType<UpdateTradeProjectRequestDto> }
  > = (props) => {
    const { projectId, data } = props ?? {};

    return externalTradeControllerUpdateProject(projectId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerUpdateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>
>;
export type ExternalTradeControllerUpdateProjectMutationBody =
  BodyType<UpdateTradeProjectRequestDto>;
export type ExternalTradeControllerUpdateProjectMutationError =
  ErrorType<unknown>;

/**
 * @summary 트레이드 프로젝트 마감·취소
 */
export const useExternalTradeControllerUpdateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>,
      TError,
      { projectId: string; data: BodyType<UpdateTradeProjectRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerUpdateProject>>,
  TError,
  { projectId: string; data: BodyType<UpdateTradeProjectRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerUpdateProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 트레이드 프로젝트 미러 한 건
 */
export const externalTradeControllerGetProject = (
  projectId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerGetProject200>({
    url: `/external/trade/projects/${projectId}`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeControllerGetProjectQueryKey = (
  projectId?: string,
) => {
  return [`/external/trade/projects/${projectId}`] as const;
};

export const getExternalTradeControllerGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerGetProjectQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerGetProject>>
  > = ({ signal }) => externalTradeControllerGetProject(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerGetProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerGetProject>>
>;
export type ExternalTradeControllerGetProjectQueryError = ErrorType<unknown>;

export function useExternalTradeControllerGetProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerGetProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerGetProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerGetProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerGetProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트레이드 프로젝트 미러 한 건
 */

export function useExternalTradeControllerGetProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGetProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerGetProjectQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 한국 공급사 1곳을 프로젝트에 앉히고 1:1 방을 연다. 견적 없이 열린다. (프로젝트, 공급사) 쌍으로 멱등하다 — 이미 있으면 `UNCHANGED`. 마감·취소된 공고에 새 방은 409(`TRADE_002`).
 * @summary 트레이드 대화방 생성 (발주자 ↔ 공급사 1:1)
 */
export const externalTradeControllerCreateRoom = (
  projectId: string,
  createTradeRoomRequestDto: BodyType<CreateTradeRoomRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerCreateRoom200>({
    url: `/external/trade/projects/${projectId}/rooms`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeRoomRequestDto,
    signal,
  });
};

export const getExternalTradeControllerCreateRoomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>,
    TError,
    { projectId: string; data: BodyType<CreateTradeRoomRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>,
  TError,
  { projectId: string; data: BodyType<CreateTradeRoomRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerCreateRoom"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>,
    { projectId: string; data: BodyType<CreateTradeRoomRequestDto> }
  > = (props) => {
    const { projectId, data } = props ?? {};

    return externalTradeControllerCreateRoom(projectId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerCreateRoomMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>
>;
export type ExternalTradeControllerCreateRoomMutationBody =
  BodyType<CreateTradeRoomRequestDto>;
export type ExternalTradeControllerCreateRoomMutationError = ErrorType<unknown>;

/**
 * @summary 트레이드 대화방 생성 (발주자 ↔ 공급사 1:1)
 */
export const useExternalTradeControllerCreateRoom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>,
      TError,
      { projectId: string; data: BodyType<CreateTradeRoomRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerCreateRoom>>,
  TError,
  { projectId: string; data: BodyType<CreateTradeRoomRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerCreateRoomMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 트레이드 프로젝트의 대화방 목록
 */
export const externalTradeControllerListRoomsOfProject = (
  projectId: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerListRoomsOfProject200>({
    url: `/external/trade/projects/${projectId}/rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeControllerListRoomsOfProjectQueryKey = (
  projectId?: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
) => {
  return [
    `/external/trade/projects/${projectId}/rooms`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeControllerListRoomsOfProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerListRoomsOfProjectQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>
  > = ({ signal }) =>
    externalTradeControllerListRoomsOfProject(projectId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerListRoomsOfProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>
>;
export type ExternalTradeControllerListRoomsOfProjectQueryError =
  ErrorType<unknown>;

export function useExternalTradeControllerListRoomsOfProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  params: undefined | ExternalTradeControllerListRoomsOfProjectParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerListRoomsOfProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerListRoomsOfProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트레이드 프로젝트의 대화방 목록
 */

export function useExternalTradeControllerListRoomsOfProject<
  TData = Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
  TError = ErrorType<unknown>,
>(
  projectId: string,
  params?: ExternalTradeControllerListRoomsOfProjectParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerListRoomsOfProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerListRoomsOfProjectQueryOptions(
    projectId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 공급사가 이탈했거나 포인트를 돌려준 경우. 방은 읽기 전용이 된다 — 기록은 남고 새 글은 막힌다. 이미 닫혔으면 `UNCHANGED`.
 * @summary 트레이드 대화방 닫기
 */
export const externalTradeControllerCloseRoom = (
  chatRoomId: string,
  closeTradeRoomRequestDto: BodyType<CloseTradeRoomRequestDto>,
) => {
  return api<ExternalTradeControllerCloseRoom200>({
    url: `/external/trade/rooms/${chatRoomId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: closeTradeRoomRequestDto,
  });
};

export const getExternalTradeControllerCloseRoomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>,
    TError,
    { chatRoomId: string; data: BodyType<CloseTradeRoomRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>,
  TError,
  { chatRoomId: string; data: BodyType<CloseTradeRoomRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerCloseRoom"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>,
    { chatRoomId: string; data: BodyType<CloseTradeRoomRequestDto> }
  > = (props) => {
    const { chatRoomId, data } = props ?? {};

    return externalTradeControllerCloseRoom(chatRoomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerCloseRoomMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>
>;
export type ExternalTradeControllerCloseRoomMutationBody =
  BodyType<CloseTradeRoomRequestDto>;
export type ExternalTradeControllerCloseRoomMutationError = ErrorType<unknown>;

/**
 * @summary 트레이드 대화방 닫기
 */
export const useExternalTradeControllerCloseRoom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>,
      TError,
      { chatRoomId: string; data: BodyType<CloseTradeRoomRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerCloseRoom>>,
  TError,
  { chatRoomId: string; data: BodyType<CloseTradeRoomRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerCloseRoomMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 씨마켓 화면에 대화방을 iframe 으로 띄울 URL 을 만든다. 토큰은 URL 조각(`#token=`)에 실리고 1회용이며 수명이 짧다(약 120초). 트레이드 방이 아니면 404 — 국내 방의 존재를 흘리지 않는다. `externalId` 가 그 방의 해당 자리 당사자가 아니면 403.
 * @summary 트레이드 대화방 임베드 URL 발급
 */
export const externalTradeControllerCreateEmbedUrl = (
  chatRoomId: string,
  tradeEmbedRequestDto: BodyType<TradeEmbedRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerCreateEmbedUrl200>({
    url: `/external/trade/rooms/${chatRoomId}/embed`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tradeEmbedRequestDto,
    signal,
  });
};

export const getExternalTradeControllerCreateEmbedUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>,
    TError,
    { chatRoomId: string; data: BodyType<TradeEmbedRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>,
  TError,
  { chatRoomId: string; data: BodyType<TradeEmbedRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeControllerCreateEmbedUrl"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>,
    { chatRoomId: string; data: BodyType<TradeEmbedRequestDto> }
  > = (props) => {
    const { chatRoomId, data } = props ?? {};

    return externalTradeControllerCreateEmbedUrl(chatRoomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerCreateEmbedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>
>;
export type ExternalTradeControllerCreateEmbedUrlMutationBody =
  BodyType<TradeEmbedRequestDto>;
export type ExternalTradeControllerCreateEmbedUrlMutationError =
  ErrorType<unknown>;

/**
 * @summary 트레이드 대화방 임베드 URL 발급
 */
export const useExternalTradeControllerCreateEmbedUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>,
      TError,
      { chatRoomId: string; data: BodyType<TradeEmbedRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerCreateEmbedUrl>>,
  TError,
  { chatRoomId: string; data: BodyType<TradeEmbedRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerCreateEmbedUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `FAILED` 로 굳은 메시지의 번역을 다시 민다. FAILED 가 아니면 `UNCHANGED`. 원문은 처음부터 보이고 있다.
 * @summary 채팅 번역 복구
 */
export const externalTradeControllerRetranslate = (
  chatRoomId: string,
  messageId: string,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerRetranslate200>({
    url: `/external/trade/rooms/${chatRoomId}/messages/${messageId}/retranslate`,
    method: "POST",
    signal,
  });
};

export const getExternalTradeControllerRetranslateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeControllerRetranslate>>,
    TError,
    { chatRoomId: string; messageId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeControllerRetranslate>>,
  TError,
  { chatRoomId: string; messageId: string },
  TContext
> => {
  const mutationKey = ["externalTradeControllerRetranslate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeControllerRetranslate>>,
    { chatRoomId: string; messageId: string }
  > = (props) => {
    const { chatRoomId, messageId } = props ?? {};

    return externalTradeControllerRetranslate(chatRoomId, messageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeControllerRetranslateMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerRetranslate>>
>;

export type ExternalTradeControllerRetranslateMutationError =
  ErrorType<unknown>;

/**
 * @summary 채팅 번역 복구
 */
export const useExternalTradeControllerRetranslate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeControllerRetranslate>>,
      TError,
      { chatRoomId: string; messageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeControllerRetranslate>>,
  TError,
  { chatRoomId: string; messageId: string },
  TContext
> => {
  const mutationOptions =
    getExternalTradeControllerRetranslateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 세모 채팅 번역이 쓰는 용어집 정본. 씨마켓이 공고를 번역할 때 같은 표를 써야 한 품목이 한 이름으로 불린다.
 * @summary KO↔ID 용어집
 */
export const externalTradeControllerGlossary = (signal?: AbortSignal) => {
  return api<ExternalTradeControllerGlossary200>({
    url: `/external/trade/glossary`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeControllerGlossaryQueryKey = () => {
  return [`/external/trade/glossary`] as const;
};

export const getExternalTradeControllerGlossaryQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExternalTradeControllerGlossaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerGlossary>>
  > = ({ signal }) => externalTradeControllerGlossary(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerGlossaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerGlossary>>
>;
export type ExternalTradeControllerGlossaryQueryError = ErrorType<unknown>;

export function useExternalTradeControllerGlossary<
  TData = Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerGlossary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerGlossary<
  TData = Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerGlossary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerGlossary<
  TData = Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary KO↔ID 용어집
 */

export function useExternalTradeControllerGlossary<
  TData = Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerGlossary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerGlossaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 씨마켓 원장의 RFQ 와 세모 미러를 맞춘다. `GET /projects` 와 같은 목록이다. 어긋나면 씨마켓이 정본 기준으로 같은 호출을 다시 하면 된다.
 * @summary 짝 맞추기 — 공고
 */
export const externalTradeControllerReconcileProjects = (
  params?: ExternalTradeControllerReconcileProjectsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerReconcileProjects200>({
    url: `/external/trade/reconciliation/projects`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeControllerReconcileProjectsQueryKey = (
  params?: ExternalTradeControllerReconcileProjectsParams,
) => {
  return [
    `/external/trade/reconciliation/projects`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeControllerReconcileProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerReconcileProjectsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>
  > = ({ signal }) => externalTradeControllerReconcileProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerReconcileProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>
>;
export type ExternalTradeControllerReconcileProjectsQueryError =
  ErrorType<unknown>;

export function useExternalTradeControllerReconcileProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeControllerReconcileProjectsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 짝 맞추기 — 공고
 */

export function useExternalTradeControllerReconcileProjects<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileProjectsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileProjects>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerReconcileProjectsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 씨마켓의 참여 기록과 세모 방을 맞춘다. 포인트를 받았는데 방이 없으면 방 생성을 다시 부른다.
 * @summary 짝 맞추기 — 대화방
 */
export const externalTradeControllerReconcileRooms = (
  params?: ExternalTradeControllerReconcileRoomsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerReconcileRooms200>({
    url: `/external/trade/reconciliation/rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeControllerReconcileRoomsQueryKey = (
  params?: ExternalTradeControllerReconcileRoomsParams,
) => {
  return [
    `/external/trade/reconciliation/rooms`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeControllerReconcileRoomsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerReconcileRoomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>
  > = ({ signal }) => externalTradeControllerReconcileRooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerReconcileRoomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>
>;
export type ExternalTradeControllerReconcileRoomsQueryError =
  ErrorType<unknown>;

export function useExternalTradeControllerReconcileRooms<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeControllerReconcileRoomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileRooms<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
          TError,
          Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileRooms<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 짝 맞추기 — 대화방
 */

export function useExternalTradeControllerReconcileRooms<
  TData = Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeControllerReconcileRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeControllerReconcileRoomsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 최근 1시간 번역 실패 비율, 대기 체류 p95, 그리고 FAILED 로 굳은 메시지 목록. 굳은 메시지는 retranslate 로 되살린다.
 * @summary 짝 맞추기 — 채팅 번역
 */
export const externalTradeControllerReconcileTranslations = (
  params?: ExternalTradeControllerReconcileTranslationsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeControllerReconcileTranslations200>({
    url: `/external/trade/reconciliation/translations`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeControllerReconcileTranslationsQueryKey = (
  params?: ExternalTradeControllerReconcileTranslationsParams,
) => {
  return [
    `/external/trade/reconciliation/translations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeControllerReconcileTranslationsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeControllerReconcileTranslations>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileTranslationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeControllerReconcileTranslations>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeControllerReconcileTranslationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeControllerReconcileTranslations>>
  > = ({ signal }) =>
    externalTradeControllerReconcileTranslations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeControllerReconcileTranslations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeControllerReconcileTranslationsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeControllerReconcileTranslations>>
  >;
export type ExternalTradeControllerReconcileTranslationsQueryError =
  ErrorType<unknown>;

export function useExternalTradeControllerReconcileTranslations<
  TData = Awaited<
    ReturnType<typeof externalTradeControllerReconcileTranslations>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeControllerReconcileTranslationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeControllerReconcileTranslations>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeControllerReconcileTranslations>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeControllerReconcileTranslations>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileTranslations<
  TData = Awaited<
    ReturnType<typeof externalTradeControllerReconcileTranslations>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileTranslationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeControllerReconcileTranslations>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeControllerReconcileTranslations>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeControllerReconcileTranslations>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeControllerReconcileTranslations<
  TData = Awaited<
    ReturnType<typeof externalTradeControllerReconcileTranslations>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileTranslationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeControllerReconcileTranslations>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 짝 맞추기 — 채팅 번역
 */

export function useExternalTradeControllerReconcileTranslations<
  TData = Awaited<
    ReturnType<typeof externalTradeControllerReconcileTranslations>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeControllerReconcileTranslationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeControllerReconcileTranslations>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeControllerReconcileTranslationsQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 내 무역 기업 프로필
 */
export const externalTradeDomainControllerMyCompany = (
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyCompany200>({
    url: `/external/trade/companies/me`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerMyCompanyQueryKey = () => {
  return [`/external/trade/companies/me`] as const;
};

export const getExternalTradeDomainControllerMyCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyCompanyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>
  > = ({ signal }) => externalTradeDomainControllerMyCompany(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyCompanyQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>
>;
export type ExternalTradeDomainControllerMyCompanyQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerMyCompany<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyCompany<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyCompany<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 무역 기업 프로필
 */

export function useExternalTradeDomainControllerMyCompany<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyCompany>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerMyCompanyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 없으면 만들고(slug 발급) 있으면 고친다. slug 는 한 번 발급되면 바뀌지 않는다.
 * @summary 내 무역 기업 프로필 저장
 */
export const externalTradeDomainControllerUpsertMyCompany = (
  upsertTradeCompanyRequestDto: BodyType<UpsertTradeCompanyRequestDto>,
) => {
  return api<ExternalTradeDomainControllerUpsertMyCompany200>({
    url: `/external/trade/companies/me`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: upsertTradeCompanyRequestDto,
  });
};

export const getExternalTradeDomainControllerUpsertMyCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>,
    TError,
    { data: BodyType<UpsertTradeCompanyRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>,
  TError,
  { data: BodyType<UpsertTradeCompanyRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerUpsertMyCompany"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>,
    { data: BodyType<UpsertTradeCompanyRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeDomainControllerUpsertMyCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerUpsertMyCompanyMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>
  >;
export type ExternalTradeDomainControllerUpsertMyCompanyMutationBody =
  BodyType<UpsertTradeCompanyRequestDto>;
export type ExternalTradeDomainControllerUpsertMyCompanyMutationError =
  ErrorType<unknown>;

/**
 * @summary 내 무역 기업 프로필 저장
 */
export const useExternalTradeDomainControllerUpsertMyCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>,
      TError,
      { data: BodyType<UpsertTradeCompanyRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerUpsertMyCompany>>,
  TError,
  { data: BodyType<UpsertTradeCompanyRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerUpsertMyCompanyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 공개 URL(slug)로 기업 한 곳
 */
export const externalTradeDomainControllerCompanyBySlug = (
  slug: string,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCompanyBySlug200>({
    url: `/external/trade/companies/by-slug/${slug}`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerCompanyBySlugQueryKey = (
  slug?: string,
) => {
  return [`/external/trade/companies/by-slug/${slug}`] as const;
};

export const getExternalTradeDomainControllerCompanyBySlugQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerCompanyBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>
  > = ({ signal }) => externalTradeDomainControllerCompanyBySlug(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerCompanyBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>
>;
export type ExternalTradeDomainControllerCompanyBySlugQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerCompanyBySlug<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerCompanyBySlug<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerCompanyBySlug<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공개 URL(slug)로 기업 한 곳
 */

export function useExternalTradeDomainControllerCompanyBySlug<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompanyBySlug>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompanyBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerCompanyBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 여러 회원의 기업 — 목록 화면이 회원 수만큼 부르지 않게
 */
export const externalTradeDomainControllerCompaniesBatch = (
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCompaniesBatch200>({
    url: `/external/trade/companies/batch`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerCompaniesBatchQueryKey = (
  params?: ExternalTradeDomainControllerCompaniesBatchParams,
) => {
  return [
    `/external/trade/companies/batch`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerCompaniesBatchQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerCompaniesBatchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>
  > = ({ signal }) =>
    externalTradeDomainControllerCompaniesBatch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerCompaniesBatchQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>
  >;
export type ExternalTradeDomainControllerCompaniesBatchQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerCompaniesBatch<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerCompaniesBatch<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerCompaniesBatch<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 여러 회원의 기업 — 목록 화면이 회원 수만큼 부르지 않게
 */

export function useExternalTradeDomainControllerCompaniesBatch<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerCompaniesBatch>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerCompaniesBatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerCompaniesBatch>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerCompaniesBatchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 공개 기업 디렉토리 — 공개(isPublished) 기업만, 최근 수정순
 */
export const externalTradeDomainControllerPublishedCompanies = (
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerPublishedCompanies200>({
    url: `/external/trade/companies`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerPublishedCompaniesQueryKey = (
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
) => {
  return [`/external/trade/companies`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerPublishedCompaniesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerPublishedCompaniesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerPublishedCompanies>>
  > = ({ signal }) =>
    externalTradeDomainControllerPublishedCompanies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerPublishedCompanies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerPublishedCompaniesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerPublishedCompanies>>
  >;
export type ExternalTradeDomainControllerPublishedCompaniesQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerPublishedCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerPublishedCompaniesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerPublishedCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerPublishedCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 공개 기업 디렉토리 — 공개(isPublished) 기업만, 최근 수정순
 */

export function useExternalTradeDomainControllerPublishedCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerPublishedCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerPublishedCompanies>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerPublishedCompaniesQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 어드민 게재 관리 목록 — 공개·비공개 모두
 */
export const externalTradeDomainControllerAdminCompanies = (
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerAdminCompanies200>({
    url: `/external/trade/admin/companies`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerAdminCompaniesQueryKey = (
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
) => {
  return [
    `/external/trade/admin/companies`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerAdminCompaniesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerAdminCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerAdminCompaniesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>
  > = ({ signal }) =>
    externalTradeDomainControllerAdminCompanies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerAdminCompaniesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>
  >;
export type ExternalTradeDomainControllerAdminCompaniesQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerAdminCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerAdminCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerAdminCompaniesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerAdminCompanies>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerAdminCompanies>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerAdminCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerAdminCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerAdminCompanies>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerAdminCompanies>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerAdminCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerAdminCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 어드민 게재 관리 목록 — 공개·비공개 모두
 */

export function useExternalTradeDomainControllerAdminCompanies<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerAdminCompanies>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerAdminCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerAdminCompanies>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerAdminCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 어드민 게재 전환
 */
export const externalTradeDomainControllerSetPublication = (
  memberId: string,
  setTradeCompanyPublicationRequestDto: BodyType<SetTradeCompanyPublicationRequestDto>,
) => {
  return api<ExternalTradeDomainControllerSetPublication200>({
    url: `/external/trade/admin/companies/${memberId}/publication`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: setTradeCompanyPublicationRequestDto,
  });
};

export const getExternalTradeDomainControllerSetPublicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>,
    TError,
    { memberId: string; data: BodyType<SetTradeCompanyPublicationRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>,
  TError,
  { memberId: string; data: BodyType<SetTradeCompanyPublicationRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerSetPublication"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>,
    { memberId: string; data: BodyType<SetTradeCompanyPublicationRequestDto> }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return externalTradeDomainControllerSetPublication(memberId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerSetPublicationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>
  >;
export type ExternalTradeDomainControllerSetPublicationMutationBody =
  BodyType<SetTradeCompanyPublicationRequestDto>;
export type ExternalTradeDomainControllerSetPublicationMutationError =
  ErrorType<unknown>;

/**
 * @summary 어드민 게재 전환
 */
export const useExternalTradeDomainControllerSetPublication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>,
      TError,
      {
        memberId: string;
        data: BodyType<SetTradeCompanyPublicationRequestDto>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerSetPublication>>,
  TError,
  { memberId: string; data: BodyType<SetTradeCompanyPublicationRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerSetPublicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 품목까지 한 트랜잭션. 같은 Idempotency-Key 면 처음 만든 RFQ 를 돌려준다.
 * @summary RFQ 등록 — 인도네시아 발주자만
 */
export const externalTradeDomainControllerCreateRfq = (
  createTradeRfqRequestDto: BodyType<CreateTradeRfqRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCreateRfq200>({
    url: `/external/trade/rfqs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeRfqRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerCreateRfqMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>,
    TError,
    { data: BodyType<CreateTradeRfqRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>,
  TError,
  { data: BodyType<CreateTradeRfqRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerCreateRfq"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>,
    { data: BodyType<CreateTradeRfqRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeDomainControllerCreateRfq(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerCreateRfqMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>
>;
export type ExternalTradeDomainControllerCreateRfqMutationBody =
  BodyType<CreateTradeRfqRequestDto>;
export type ExternalTradeDomainControllerCreateRfqMutationError =
  ErrorType<unknown>;

/**
 * @summary RFQ 등록 — 인도네시아 발주자만
 */
export const useExternalTradeDomainControllerCreateRfq = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>,
      TError,
      { data: BodyType<CreateTradeRfqRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateRfq>>,
  TError,
  { data: BodyType<CreateTradeRfqRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerCreateRfqMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `q` 는 원문(제목·품목명)만 찾는다 — 번역문은 씨마켓 캐시에 있다.
 * @summary RFQ 게시판 — 공개 작성자만, 최신순
 */
export const externalTradeDomainControllerListRfqs = (
  params?: ExternalTradeDomainControllerListRfqsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerListRfqs200>({
    url: `/external/trade/rfqs`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerListRfqsQueryKey = (
  params?: ExternalTradeDomainControllerListRfqsParams,
) => {
  return [`/external/trade/rfqs`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerListRfqsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerListRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerListRfqsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>
  > = ({ signal }) => externalTradeDomainControllerListRfqs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerListRfqsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>
>;
export type ExternalTradeDomainControllerListRfqsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerListRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerListRfqsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerListRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerListRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RFQ 게시판 — 공개 작성자만, 최신순
 */

export function useExternalTradeDomainControllerListRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerListRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListRfqs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerListRfqsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 게시판의 진행 중 RFQ 수(공개 작성자)
 */
export const externalTradeDomainControllerOpenPublicRfqCount = (
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerOpenPublicRfqCount200>({
    url: `/external/trade/rfqs/open-public-count`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerOpenPublicRfqCountQueryKey =
  () => {
    return [`/external/trade/rfqs/open-public-count`] as const;
  };

export const getExternalTradeDomainControllerOpenPublicRfqCountQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerOpenPublicRfqCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>>
  > = ({ signal }) => externalTradeDomainControllerOpenPublicRfqCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerOpenPublicRfqCountQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>>
  >;
export type ExternalTradeDomainControllerOpenPublicRfqCountQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerOpenPublicRfqCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerOpenPublicRfqCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerOpenPublicRfqCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 게시판의 진행 중 RFQ 수(공개 작성자)
 */

export function useExternalTradeDomainControllerOpenPublicRfqCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerOpenPublicRfqCount>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerOpenPublicRfqCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 내가 올린 RFQ
 */
export const externalTradeDomainControllerMyRfqs = (
  params?: ExternalTradeDomainControllerMyRfqsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyRfqs200>({
    url: `/external/trade/me/rfqs`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerMyRfqsQueryKey = (
  params?: ExternalTradeDomainControllerMyRfqsParams,
) => {
  return [`/external/trade/me/rfqs`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerMyRfqsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyRfqsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>
  > = ({ signal }) => externalTradeDomainControllerMyRfqs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyRfqsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>
>;
export type ExternalTradeDomainControllerMyRfqsQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerMyRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerMyRfqsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 올린 RFQ
 */

export function useExternalTradeDomainControllerMyRfqs<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMyRfqsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 내가 올린 RFQ 수
 */
export const externalTradeDomainControllerMyRfqCount = (
  params?: ExternalTradeDomainControllerMyRfqCountParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyRfqCount200>({
    url: `/external/trade/me/rfqs/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerMyRfqCountQueryKey = (
  params?: ExternalTradeDomainControllerMyRfqCountParams,
) => {
  return [
    `/external/trade/me/rfqs/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerMyRfqCountQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyRfqCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>
  > = ({ signal }) => externalTradeDomainControllerMyRfqCount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyRfqCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>
>;
export type ExternalTradeDomainControllerMyRfqCountQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerMyRfqCount<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerMyRfqCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRfqCount<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRfqCount<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내가 올린 RFQ 수
 */

export function useExternalTradeDomainControllerMyRfqCount<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRfqCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRfqCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMyRfqCountQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary RFQ 한 건 — 품목 포함, 작성 기업·제안 수 포함
 */
export const externalTradeDomainControllerRfqDetail = (
  rfqId: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerRfqDetail200>({
    url: `/external/trade/rfqs/${rfqId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerRfqDetailQueryKey = (
  rfqId?: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
) => {
  return [
    `/external/trade/rfqs/${rfqId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerRfqDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerRfqDetailQueryKey(rfqId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>
  > = ({ signal }) =>
    externalTradeDomainControllerRfqDetail(rfqId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!rfqId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerRfqDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>
>;
export type ExternalTradeDomainControllerRfqDetailQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerRfqDetail<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params: undefined | ExternalTradeDomainControllerRfqDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerRfqDetail<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerRfqDetail<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RFQ 한 건 — 품목 포함, 작성 기업·제안 수 포함
 */

export function useExternalTradeDomainControllerRfqDetail<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerRfqDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRfqDetail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerRfqDetailQueryOptions(
    rfqId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 마감된 RFQ 의 방은 전부 읽기 전용이 된다(기록은 남는다).
 * @summary RFQ 마감 — 작성자만, 멱등
 */
export const externalTradeDomainControllerCloseRfq = (
  rfqId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCloseRfq200>({
    url: `/external/trade/rfqs/${rfqId}/close`,
    method: "POST",
    signal,
  });
};

export const getExternalTradeDomainControllerCloseRfqMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>,
    TError,
    { rfqId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>,
  TError,
  { rfqId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerCloseRfq"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>,
    { rfqId: number }
  > = (props) => {
    const { rfqId } = props ?? {};

    return externalTradeDomainControllerCloseRfq(rfqId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerCloseRfqMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>
>;

export type ExternalTradeDomainControllerCloseRfqMutationError =
  ErrorType<unknown>;

/**
 * @summary RFQ 마감 — 작성자만, 멱등
 */
export const useExternalTradeDomainControllerCloseRfq = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>,
      TError,
      { rfqId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerCloseRfq>>,
  TError,
  { rfqId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerCloseRfqMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 제안 제출 — 한국 공급사만, 진행 중 RFQ 에만
 */
export const externalTradeDomainControllerCreateProposal = (
  rfqId: number,
  createTradeProposalRequestDto: BodyType<CreateTradeProposalRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCreateProposal200>({
    url: `/external/trade/rfqs/${rfqId}/proposals`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeProposalRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerCreateProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>,
    TError,
    { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>,
  TError,
  { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerCreateProposal"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>,
    { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> }
  > = (props) => {
    const { rfqId, data } = props ?? {};

    return externalTradeDomainControllerCreateProposal(rfqId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerCreateProposalMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>
  >;
export type ExternalTradeDomainControllerCreateProposalMutationBody =
  BodyType<CreateTradeProposalRequestDto>;
export type ExternalTradeDomainControllerCreateProposalMutationError =
  ErrorType<unknown>;

/**
 * @summary 제안 제출 — 한국 공급사만, 진행 중 RFQ 에만
 */
export const useExternalTradeDomainControllerCreateProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>,
      TError,
      { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateProposal>>,
  TError,
  { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerCreateProposalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary RFQ 의 제안 — proposerMemberId 를 주면 그 제안자 것만
 */
export const externalTradeDomainControllerListProposals = (
  rfqId: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerListProposals200>({
    url: `/external/trade/rfqs/${rfqId}/proposals`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerListProposalsQueryKey = (
  rfqId?: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
) => {
  return [
    `/external/trade/rfqs/${rfqId}/proposals`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerListProposalsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerListProposals>
  >,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerListProposalsQueryKey(rfqId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>
  > = ({ signal }) =>
    externalTradeDomainControllerListProposals(rfqId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!rfqId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerListProposalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>
>;
export type ExternalTradeDomainControllerListProposalsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerListProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerListProposals>
  >,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params: undefined | ExternalTradeDomainControllerListProposalsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerListProposals>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerListProposals>
  >,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerListProposals>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerListProposals>
  >,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RFQ 의 제안 — proposerMemberId 를 주면 그 제안자 것만
 */

export function useExternalTradeDomainControllerListProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerListProposals>
  >,
  TError = ErrorType<unknown>,
>(
  rfqId: number,
  params?: ExternalTradeDomainControllerListProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListProposals>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerListProposalsQueryOptions(
      rfqId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적 제출 — RFQ 방을 열고 견적을 첫 메시지로 남긴다. 한국 공급사만, RFQ 당 quoteCap 곳까지
 */
export const externalTradeDomainControllerSubmitQuote = (
  rfqId: number,
  createTradeProposalRequestDto: BodyType<CreateTradeProposalRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerSubmitQuote200>({
    url: `/external/trade/rfqs/${rfqId}/quotes`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeProposalRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerSubmitQuoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>,
    TError,
    { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>,
  TError,
  { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerSubmitQuote"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>,
    { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> }
  > = (props) => {
    const { rfqId, data } = props ?? {};

    return externalTradeDomainControllerSubmitQuote(rfqId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerSubmitQuoteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>
  >;
export type ExternalTradeDomainControllerSubmitQuoteMutationBody =
  BodyType<CreateTradeProposalRequestDto>;
export type ExternalTradeDomainControllerSubmitQuoteMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적 제출 — RFQ 방을 열고 견적을 첫 메시지로 남긴다. 한국 공급사만, RFQ 당 quoteCap 곳까지
 */
export const useExternalTradeDomainControllerSubmitQuote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>,
      TError,
      { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerSubmitQuote>>,
  TError,
  { rfqId: number; data: BodyType<CreateTradeProposalRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerSubmitQuoteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 제안 한 건
 */
export const externalTradeDomainControllerProposal = (
  proposalId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerProposal200>({
    url: `/external/trade/proposals/${proposalId}`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerProposalQueryKey = (
  proposalId?: number,
) => {
  return [`/external/trade/proposals/${proposalId}`] as const;
};

export const getExternalTradeDomainControllerProposalQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
  TError = ErrorType<unknown>,
>(
  proposalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerProposalQueryKey(proposalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>
  > = ({ signal }) => externalTradeDomainControllerProposal(proposalId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!proposalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerProposalQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>
>;
export type ExternalTradeDomainControllerProposalQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerProposal<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
  TError = ErrorType<unknown>,
>(
  proposalId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerProposal<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
  TError = ErrorType<unknown>,
>(
  proposalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerProposal<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
  TError = ErrorType<unknown>,
>(
  proposalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 제안 한 건
 */

export function useExternalTradeDomainControllerProposal<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
  TError = ErrorType<unknown>,
>(
  proposalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerProposal>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerProposalQueryOptions(
    proposalId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 내 RFQ 전체에 달린 제안 — 남의 RFQ 제안은 나오지 않는다
 */
export const externalTradeDomainControllerReceivedProposals = (
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerReceivedProposals200>({
    url: `/external/trade/me/received-proposals`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerReceivedProposalsQueryKey = (
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
) => {
  return [
    `/external/trade/me/received-proposals`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerReceivedProposalsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposals>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposals>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerReceivedProposalsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerReceivedProposals>>
  > = ({ signal }) =>
    externalTradeDomainControllerReceivedProposals(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerReceivedProposals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerReceivedProposalsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerReceivedProposals>>
  >;
export type ExternalTradeDomainControllerReceivedProposalsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerReceivedProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposals>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerReceivedProposalsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposals>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerReceivedProposals>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerReceivedProposals>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerReceivedProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposals>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposals>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerReceivedProposals>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerReceivedProposals>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerReceivedProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposals>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposals>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 RFQ 전체에 달린 제안 — 남의 RFQ 제안은 나오지 않는다
 */

export function useExternalTradeDomainControllerReceivedProposals<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposals>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposals>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerReceivedProposalsQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 내 RFQ 전체에 달린 제안 수
 */
export const externalTradeDomainControllerReceivedProposalCount = (
  params?: ExternalTradeDomainControllerReceivedProposalCountParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerReceivedProposalCount200>({
    url: `/external/trade/me/received-proposals/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerReceivedProposalCountQueryKey = (
  params?: ExternalTradeDomainControllerReceivedProposalCountParams,
) => {
  return [
    `/external/trade/me/received-proposals/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerReceivedProposalCountQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
    >,
    TError = ErrorType<unknown>,
  >(
    params?: ExternalTradeDomainControllerReceivedProposalCountParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof externalTradeDomainControllerReceivedProposalCount
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExternalTradeDomainControllerReceivedProposalCountQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
      >
    > = ({ signal }) =>
      externalTradeDomainControllerReceivedProposalCount(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExternalTradeDomainControllerReceivedProposalCountQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
    >
  >;
export type ExternalTradeDomainControllerReceivedProposalCountQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerReceivedProposalCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerReceivedProposalCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalTradeDomainControllerReceivedProposalCount
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalTradeDomainControllerReceivedProposalCount
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerReceivedProposalCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof externalTradeDomainControllerReceivedProposalCount
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof externalTradeDomainControllerReceivedProposalCount
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerReceivedProposalCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 RFQ 전체에 달린 제안 수
 */

export function useExternalTradeDomainControllerReceivedProposalCount<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerReceivedProposalCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalTradeDomainControllerReceivedProposalCount>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerReceivedProposalCountQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * `expectedStatus` 인 때만 전이한다(조건부 UPDATE). 아니면 `decided=false`. 수락 안내를 주면 두 당사자의 직접 문의 방에 같은 트랜잭션으로 남는다.
 * @summary 제안 수락·거절 — RFQ 작성자만
 */
export const externalTradeDomainControllerDecideProposal = (
  proposalId: number,
  decideTradeProposalRequestDto: BodyType<DecideTradeProposalRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerDecideProposal200>({
    url: `/external/trade/proposals/${proposalId}/decision`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: decideTradeProposalRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerDecideProposalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>,
    TError,
    { proposalId: number; data: BodyType<DecideTradeProposalRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>,
  TError,
  { proposalId: number; data: BodyType<DecideTradeProposalRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerDecideProposal"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>,
    { proposalId: number; data: BodyType<DecideTradeProposalRequestDto> }
  > = (props) => {
    const { proposalId, data } = props ?? {};

    return externalTradeDomainControllerDecideProposal(proposalId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerDecideProposalMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>
  >;
export type ExternalTradeDomainControllerDecideProposalMutationBody =
  BodyType<DecideTradeProposalRequestDto>;
export type ExternalTradeDomainControllerDecideProposalMutationError =
  ErrorType<unknown>;

/**
 * @summary 제안 수락·거절 — RFQ 작성자만
 */
export const useExternalTradeDomainControllerDecideProposal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>,
      TError,
      { proposalId: number; data: BodyType<DecideTradeProposalRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerDecideProposal>>,
  TError,
  { proposalId: number; data: BodyType<DecideTradeProposalRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerDecideProposalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 게재 — 한국 공급사만. 품목까지 한 트랜잭션
 */
export const externalTradeDomainControllerCreateListing = (
  createTradeListingRequestDto: BodyType<CreateTradeListingRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCreateListing200>({
    url: `/external/trade/listings`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeListingRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerCreateListingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>,
    TError,
    { data: BodyType<CreateTradeListingRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>,
  TError,
  { data: BodyType<CreateTradeListingRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerCreateListing"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>,
    { data: BodyType<CreateTradeListingRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeDomainControllerCreateListing(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerCreateListingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>
  >;
export type ExternalTradeDomainControllerCreateListingMutationBody =
  BodyType<CreateTradeListingRequestDto>;
export type ExternalTradeDomainControllerCreateListingMutationError =
  ErrorType<unknown>;

/**
 * @summary 게재 — 한국 공급사만. 품목까지 한 트랜잭션
 */
export const useExternalTradeDomainControllerCreateListing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>,
      TError,
      { data: BodyType<CreateTradeListingRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerCreateListing>>,
  TError,
  { data: BodyType<CreateTradeListingRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerCreateListingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 게재 게시판 — 진행 중만, 최신순
 */
export const externalTradeDomainControllerActiveListings = (
  params?: ExternalTradeDomainControllerActiveListingsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerActiveListings200>({
    url: `/external/trade/listings`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerActiveListingsQueryKey = (
  params?: ExternalTradeDomainControllerActiveListingsParams,
) => {
  return [`/external/trade/listings`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerActiveListingsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerActiveListings>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerActiveListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerActiveListingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>
  > = ({ signal }) =>
    externalTradeDomainControllerActiveListings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerActiveListingsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>
  >;
export type ExternalTradeDomainControllerActiveListingsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerActiveListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerActiveListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerActiveListingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerActiveListings>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerActiveListings>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerActiveListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerActiveListings>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerActiveListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerActiveListings>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerActiveListings>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerActiveListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerActiveListings>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerActiveListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 게재 게시판 — 진행 중만, 최신순
 */

export function useExternalTradeDomainControllerActiveListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerActiveListings>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerActiveListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerActiveListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerActiveListingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 응답을 잃은 마감·만료를 되찾는다. id 오름차순 커서.
 * @summary 끝난 게재(마감·만료) — 씨마켓 이월 적립의 대조 재료
 */
export const externalTradeDomainControllerEndedListings = (
  params: ExternalTradeDomainControllerEndedListingsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerEndedListings200>({
    url: `/external/trade/listings/ended`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerEndedListingsQueryKey = (
  params?: ExternalTradeDomainControllerEndedListingsParams,
) => {
  return [
    `/external/trade/listings/ended`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerEndedListingsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerEndedListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerEndedListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerEndedListingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>
  > = ({ signal }) =>
    externalTradeDomainControllerEndedListings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerEndedListingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>
>;
export type ExternalTradeDomainControllerEndedListingsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerEndedListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerEndedListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerEndedListingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerEndedListings>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerEndedListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerEndedListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerEndedListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerEndedListings>
          >,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerEndedListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerEndedListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerEndedListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 끝난 게재(마감·만료) — 씨마켓 이월 적립의 대조 재료
 */

export function useExternalTradeDomainControllerEndedListings<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerEndedListings>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerEndedListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerEndedListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerEndedListingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 씨마켓 스케줄러가 부른다. 돌려준 게재의 미사용 자리를 씨마켓이 이월 석으로 적립한다.
 * @summary 만료 스윕 — 60일 지난 게재·7일 지난 대기
 */
export const externalTradeDomainControllerExpireDue = (
  expireTradeListingsRequestDto: BodyType<ExpireTradeListingsRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerExpireDue200>({
    url: `/external/trade/listings/expire-due`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: expireTradeListingsRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerExpireDueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>,
    TError,
    { data: BodyType<ExpireTradeListingsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>,
  TError,
  { data: BodyType<ExpireTradeListingsRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerExpireDue"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>,
    { data: BodyType<ExpireTradeListingsRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeDomainControllerExpireDue(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerExpireDueMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>
>;
export type ExternalTradeDomainControllerExpireDueMutationBody =
  BodyType<ExpireTradeListingsRequestDto>;
export type ExternalTradeDomainControllerExpireDueMutationError =
  ErrorType<unknown>;

/**
 * @summary 만료 스윕 — 60일 지난 게재·7일 지난 대기
 */
export const useExternalTradeDomainControllerExpireDue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>,
      TError,
      { data: BodyType<ExpireTradeListingsRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerExpireDue>>,
  TError,
  { data: BodyType<ExpireTradeListingsRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerExpireDueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 게재 — 상태 무관, 대기 인원 포함
 */
export const externalTradeDomainControllerMyListings = (
  params?: ExternalTradeDomainControllerMyListingsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyListings200>({
    url: `/external/trade/me/listings`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerMyListingsQueryKey = (
  params?: ExternalTradeDomainControllerMyListingsParams,
) => {
  return [`/external/trade/me/listings`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerMyListingsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyListingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>
  > = ({ signal }) => externalTradeDomainControllerMyListings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyListingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>
>;
export type ExternalTradeDomainControllerMyListingsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerMyListings<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerMyListingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyListings<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyListings<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 게재 — 상태 무관, 대기 인원 포함
 */

export function useExternalTradeDomainControllerMyListings<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyListings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMyListingsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 게재 한 건
 */
export const externalTradeDomainControllerListing = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerListing200>({
    url: `/external/trade/listings/${listingId}`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerListingQueryKey = (
  listingId?: number,
) => {
  return [`/external/trade/listings/${listingId}`] as const;
};

export const getExternalTradeDomainControllerListingQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerListingQueryKey(listingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerListing>>
  > = ({ signal }) => externalTradeDomainControllerListing(listingId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!listingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerListingQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerListing>>
>;
export type ExternalTradeDomainControllerListingQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerListing<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListing>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListing<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerListing>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerListing<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 게재 한 건
 */

export function useExternalTradeDomainControllerListing<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerListing>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerListingQueryOptions(
    listingId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 씨마켓이 게재료를 못 받았을 때만 부른다. 아무도 앉지 않았어야 한다. 이미 없으면 204.
 * @summary 과금되지 못한 게재 철거
 */
export const externalTradeDomainControllerRemoveListing = (
  listingId: number,
) => {
  return api<void>({
    url: `/external/trade/listings/${listingId}`,
    method: "DELETE",
  });
};

export const getExternalTradeDomainControllerRemoveListingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>,
    TError,
    { listingId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerRemoveListing"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>,
    { listingId: number }
  > = (props) => {
    const { listingId } = props ?? {};

    return externalTradeDomainControllerRemoveListing(listingId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerRemoveListingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>
  >;

export type ExternalTradeDomainControllerRemoveListingMutationError =
  ErrorType<unknown>;

/**
 * @summary 과금되지 못한 게재 철거
 */
export const useExternalTradeDomainControllerRemoveListing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>,
      TError,
      { listingId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerRemoveListing>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerRemoveListingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 게재 마감 — 소유자만. 미사용 자리 수를 돌려준다
 */
export const externalTradeDomainControllerCloseListing = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerCloseListing200>({
    url: `/external/trade/listings/${listingId}/close`,
    method: "POST",
    signal,
  });
};

export const getExternalTradeDomainControllerCloseListingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>,
    TError,
    { listingId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerCloseListing"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>,
    { listingId: number }
  > = (props) => {
    const { listingId } = props ?? {};

    return externalTradeDomainControllerCloseListing(listingId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerCloseListingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>
  >;

export type ExternalTradeDomainControllerCloseListingMutationError =
  ErrorType<unknown>;

/**
 * @summary 게재 마감 — 소유자만. 미사용 자리 수를 돌려준다
 */
export const useExternalTradeDomainControllerCloseListing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>,
      TError,
      { listingId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerCloseListing>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerCloseListingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 같은 Idempotency-Key(씨마켓 결제 원장 ref)면 자리를 다시 늘리지 않는다(`UNCHANGED`).
 * @summary 자리 추가 — 소유자만, 대기열을 같은 트랜잭션에서 소진
 */
export const externalTradeDomainControllerAddCapacity = (
  listingId: number,
  addTradeListingCapacityRequestDto: BodyType<AddTradeListingCapacityRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerAddCapacity200>({
    url: `/external/trade/listings/${listingId}/capacity`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addTradeListingCapacityRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerAddCapacityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>,
    TError,
    { listingId: number; data: BodyType<AddTradeListingCapacityRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>,
  TError,
  { listingId: number; data: BodyType<AddTradeListingCapacityRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerAddCapacity"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>,
    { listingId: number; data: BodyType<AddTradeListingCapacityRequestDto> }
  > = (props) => {
    const { listingId, data } = props ?? {};

    return externalTradeDomainControllerAddCapacity(listingId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerAddCapacityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>
  >;
export type ExternalTradeDomainControllerAddCapacityMutationBody =
  BodyType<AddTradeListingCapacityRequestDto>;
export type ExternalTradeDomainControllerAddCapacityMutationError =
  ErrorType<unknown>;

/**
 * @summary 자리 추가 — 소유자만, 대기열을 같은 트랜잭션에서 소진
 */
export const useExternalTradeDomainControllerAddCapacity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>,
      TError,
      { listingId: number; data: BodyType<AddTradeListingCapacityRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerAddCapacity>>,
  TError,
  { listingId: number; data: BodyType<AddTradeListingCapacityRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerAddCapacityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * (게재, 발주자) 자연키로 멱등. 만석이면 `FULL`(대기열로). 끝난 게재는 409(`TRADE_004`).
 * @summary 자리 차지 + 방 개설 — 인도네시아 발주자, 선착순
 */
export const externalTradeDomainControllerTakeSeat = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerTakeSeat200>({
    url: `/external/trade/listings/${listingId}/seats`,
    method: "POST",
    signal,
  });
};

export const getExternalTradeDomainControllerTakeSeatMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>,
    TError,
    { listingId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerTakeSeat"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>,
    { listingId: number }
  > = (props) => {
    const { listingId } = props ?? {};

    return externalTradeDomainControllerTakeSeat(listingId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerTakeSeatMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>
>;

export type ExternalTradeDomainControllerTakeSeatMutationError =
  ErrorType<unknown>;

/**
 * @summary 자리 차지 + 방 개설 — 인도네시아 발주자, 선착순
 */
export const useExternalTradeDomainControllerTakeSeat = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>,
      TError,
      { listingId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerTakeSeat>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerTakeSeatMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 판매자의 채팅방 목록 — 소유자만, 앉은 순서대로
 */
export const externalTradeDomainControllerOpenSeats = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerOpenSeats200>({
    url: `/external/trade/listings/${listingId}/seats`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerOpenSeatsQueryKey = (
  listingId?: number,
) => {
  return [`/external/trade/listings/${listingId}/seats`] as const;
};

export const getExternalTradeDomainControllerOpenSeatsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerOpenSeatsQueryKey(listingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>
  > = ({ signal }) => externalTradeDomainControllerOpenSeats(listingId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!listingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerOpenSeatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>
>;
export type ExternalTradeDomainControllerOpenSeatsQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerOpenSeats<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerOpenSeats<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerOpenSeats<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 판매자의 채팅방 목록 — 소유자만, 앉은 순서대로
 */

export function useExternalTradeDomainControllerOpenSeats<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerOpenSeats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerOpenSeatsQueryOptions(
    listingId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 이 게재의 내 자리 — 없으면 null
 */
export const externalTradeDomainControllerMySeat = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMySeat200>({
    url: `/external/trade/listings/${listingId}/seats/me`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerMySeatQueryKey = (
  listingId?: number,
) => {
  return [`/external/trade/listings/${listingId}/seats/me`] as const;
};

export const getExternalTradeDomainControllerMySeatQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMySeatQueryKey(listingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>
  > = ({ signal }) => externalTradeDomainControllerMySeat(listingId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!listingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMySeatQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>
>;
export type ExternalTradeDomainControllerMySeatQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerMySeat<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMySeat<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMySeat<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 이 게재의 내 자리 — 없으면 null
 */

export function useExternalTradeDomainControllerMySeat<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMySeat>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMySeatQueryOptions(
    listingId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 이 게재의 내 대기 — 가장 최근 기록, 없으면 null
 */
export const externalTradeDomainControllerMyWaitlist = (
  listingId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyWaitlist200>({
    url: `/external/trade/listings/${listingId}/waitlist/me`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerMyWaitlistQueryKey = (
  listingId?: number,
) => {
  return [`/external/trade/listings/${listingId}/waitlist/me`] as const;
};

export const getExternalTradeDomainControllerMyWaitlistQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyWaitlistQueryKey(listingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>
  > = ({ signal }) =>
    externalTradeDomainControllerMyWaitlist(listingId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!listingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyWaitlistQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>
>;
export type ExternalTradeDomainControllerMyWaitlistQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerMyWaitlist<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyWaitlist<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyWaitlist<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 이 게재의 내 대기 — 가장 최근 기록, 없으면 null
 */

export function useExternalTradeDomainControllerMyWaitlist<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
  TError = ErrorType<unknown>,
>(
  listingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyWaitlist>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMyWaitlistQueryOptions(
    listingId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 줄 서기 — 멱등
 */
export const externalTradeDomainControllerJoinWaitlist = (
  listingId: number,
  joinTradeWaitlistRequestDto: BodyType<JoinTradeWaitlistRequestDto>,
) => {
  return api<ExternalTradeDomainControllerJoinWaitlist200>({
    url: `/external/trade/listings/${listingId}/waitlist/me`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: joinTradeWaitlistRequestDto,
  });
};

export const getExternalTradeDomainControllerJoinWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>,
    TError,
    { listingId: number; data: BodyType<JoinTradeWaitlistRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>,
  TError,
  { listingId: number; data: BodyType<JoinTradeWaitlistRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerJoinWaitlist"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>,
    { listingId: number; data: BodyType<JoinTradeWaitlistRequestDto> }
  > = (props) => {
    const { listingId, data } = props ?? {};

    return externalTradeDomainControllerJoinWaitlist(listingId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerJoinWaitlistMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>
  >;
export type ExternalTradeDomainControllerJoinWaitlistMutationBody =
  BodyType<JoinTradeWaitlistRequestDto>;
export type ExternalTradeDomainControllerJoinWaitlistMutationError =
  ErrorType<unknown>;

/**
 * @summary 줄 서기 — 멱등
 */
export const useExternalTradeDomainControllerJoinWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>,
      TError,
      { listingId: number; data: BodyType<JoinTradeWaitlistRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerJoinWaitlist>>,
  TError,
  { listingId: number; data: BodyType<JoinTradeWaitlistRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerJoinWaitlistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 줄 빠지기 — 대기 중일 때만, 멱등
 */
export const externalTradeDomainControllerLeaveWaitlist = (
  listingId: number,
) => {
  return api<void>({
    url: `/external/trade/listings/${listingId}/waitlist/me`,
    method: "DELETE",
  });
};

export const getExternalTradeDomainControllerLeaveWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>,
    TError,
    { listingId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerLeaveWaitlist"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>,
    { listingId: number }
  > = (props) => {
    const { listingId } = props ?? {};

    return externalTradeDomainControllerLeaveWaitlist(listingId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerLeaveWaitlistMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>
  >;

export type ExternalTradeDomainControllerLeaveWaitlistMutationError =
  ErrorType<unknown>;

/**
 * @summary 줄 빠지기 — 대기 중일 때만, 멱등
 */
export const useExternalTradeDomainControllerLeaveWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>,
      TError,
      { listingId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerLeaveWaitlist>>,
  TError,
  { listingId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerLeaveWaitlistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * RFQ: 행위자=한국 공급사, 씨마켓이 참여 포인트를 받은 뒤 부른다. DIRECT: 두 기업 중 누가 불러도 같은 방. 자연키로 멱등. 게재 방은 자리 차지(`POST listings/:id/seats`)가 연다.
 * @summary 무역 방 열기 — RFQ 참여(공급사) 또는 직접 문의
 */
export const externalTradeDomainControllerOpenRoom = (
  createTradeRoomV2RequestDto: BodyType<CreateTradeRoomV2RequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerOpenRoom200>({
    url: `/external/trade/rooms`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTradeRoomV2RequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerOpenRoomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>,
    TError,
    { data: BodyType<CreateTradeRoomV2RequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>,
  TError,
  { data: BodyType<CreateTradeRoomV2RequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerOpenRoom"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>,
    { data: BodyType<CreateTradeRoomV2RequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalTradeDomainControllerOpenRoom(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerOpenRoomMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>
>;
export type ExternalTradeDomainControllerOpenRoomMutationBody =
  BodyType<CreateTradeRoomV2RequestDto>;
export type ExternalTradeDomainControllerOpenRoomMutationError =
  ErrorType<unknown>;

/**
 * @summary 무역 방 열기 — RFQ 참여(공급사) 또는 직접 문의
 */
export const useExternalTradeDomainControllerOpenRoom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>,
      TError,
      { data: BodyType<CreateTradeRoomV2RequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerOpenRoom>>,
  TError,
  { data: BodyType<CreateTradeRoomV2RequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerOpenRoomMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 방 — 유료·무료 전부, 마지막 메시지(원문+번역문)·미읽음
 */
export const externalTradeDomainControllerMyRooms = (
  params?: ExternalTradeDomainControllerMyRoomsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerMyRooms200>({
    url: `/external/trade/me/rooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerMyRoomsQueryKey = (
  params?: ExternalTradeDomainControllerMyRoomsParams,
) => {
  return [`/external/trade/me/rooms`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerMyRoomsQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerMyRoomsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>
  > = ({ signal }) => externalTradeDomainControllerMyRooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerMyRoomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>
>;
export type ExternalTradeDomainControllerMyRoomsQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerMyRooms<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerMyRoomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRooms<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerMyRooms<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 방 — 유료·무료 전부, 마지막 메시지(원문+번역문)·미읽음
 */

export function useExternalTradeDomainControllerMyRooms<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerMyRoomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerMyRooms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerMyRoomsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 무역 방 한 건
 */
export const externalTradeDomainControllerRoom = (
  roomId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerRoom200>({
    url: `/external/trade/rooms/${roomId}`,
    method: "GET",
    signal,
  });
};

export const getExternalTradeDomainControllerRoomQueryKey = (
  roomId?: number,
) => {
  return [`/external/trade/rooms/${roomId}`] as const;
};

export const getExternalTradeDomainControllerRoomQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerRoomQueryKey(roomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>
  > = ({ signal }) => externalTradeDomainControllerRoom(roomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!roomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerRoomQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>
>;
export type ExternalTradeDomainControllerRoomQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerRoom<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerRoom<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerRoom<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 무역 방 한 건
 */

export function useExternalTradeDomainControllerRoom<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
  TError = ErrorType<unknown>,
>(
  roomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerRoom>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerRoomQueryOptions(
    roomId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 토큰은 URL 조각(`#token=`)에 실리고 1회용·약 120초.
 * @summary 임베드 URL — 행위자의 자리(발주자·공급사)로. 당사자가 아니면 403
 */
export const externalTradeDomainControllerEmbed = (
  roomId: number,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerEmbed200>({
    url: `/external/trade/rooms/${roomId}/embed-url`,
    method: "POST",
    signal,
  });
};

export const getExternalTradeDomainControllerEmbedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>,
    TError,
    { roomId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>,
  TError,
  { roomId: number },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerEmbed"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>,
    { roomId: number }
  > = (props) => {
    const { roomId } = props ?? {};

    return externalTradeDomainControllerEmbed(roomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerEmbedMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>
>;

export type ExternalTradeDomainControllerEmbedMutationError =
  ErrorType<unknown>;

/**
 * @summary 임베드 URL — 행위자의 자리(발주자·공급사)로. 당사자가 아니면 403
 */
export const useExternalTradeDomainControllerEmbed = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>,
      TError,
      { roomId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerEmbed>>,
  TError,
  { roomId: number },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerEmbedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 임베드 밖(씨마켓 화면의 「거래 문의」)에서 쓰는 글. 채팅 엔진의 글 메시지 경로를 그대로 탄다 — 번역·실시간·알림이 같다. 당사자가 아니면 403, 닫힌 방이면 409.
 * @summary 방에 글 보내기 — 행위자의 자리로
 */
export const externalTradeDomainControllerSendMessage = (
  roomId: number,
  sendTradeRoomMessageRequestDto: BodyType<SendTradeRoomMessageRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerSendMessage200>({
    url: `/external/trade/rooms/${roomId}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendTradeRoomMessageRequestDto,
    signal,
  });
};

export const getExternalTradeDomainControllerSendMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>,
    TError,
    { roomId: number; data: BodyType<SendTradeRoomMessageRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>,
  TError,
  { roomId: number; data: BodyType<SendTradeRoomMessageRequestDto> },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerSendMessage"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>,
    { roomId: number; data: BodyType<SendTradeRoomMessageRequestDto> }
  > = (props) => {
    const { roomId, data } = props ?? {};

    return externalTradeDomainControllerSendMessage(roomId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerSendMessageMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>
  >;
export type ExternalTradeDomainControllerSendMessageMutationBody =
  BodyType<SendTradeRoomMessageRequestDto>;
export type ExternalTradeDomainControllerSendMessageMutationError =
  ErrorType<unknown>;

/**
 * @summary 방에 글 보내기 — 행위자의 자리로
 */
export const useExternalTradeDomainControllerSendMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>,
      TError,
      { roomId: number; data: BodyType<SendTradeRoomMessageRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerSendMessage>>,
  TError,
  { roomId: number; data: BodyType<SendTradeRoomMessageRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 미읽음이 있는 방 전체. since 없는 스냅샷이라 늦게 커밋된 메시지를 놓치지 않는다. 본문은 싣지 않는다.
 * @summary 미읽음 스냅샷(씨마켓 5분 폴링) — 무역 방 기준
 */
export const externalTradeDomainControllerUnread = (
  params?: ExternalTradeDomainControllerUnreadParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerUnread200>({
    url: `/external/trade/unread`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerUnreadQueryKey = (
  params?: ExternalTradeDomainControllerUnreadParams,
) => {
  return [`/external/trade/unread`, ...(params ? [params] : [])] as const;
};

export const getExternalTradeDomainControllerUnreadQueryOptions = <
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerUnreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerUnreadQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>
  > = ({ signal }) => externalTradeDomainControllerUnread(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerUnreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>
>;
export type ExternalTradeDomainControllerUnreadQueryError = ErrorType<unknown>;

export function useExternalTradeDomainControllerUnread<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalTradeDomainControllerUnreadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerUnread<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerUnreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
          TError,
          Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerUnread<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerUnreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 미읽음 스냅샷(씨마켓 5분 폴링) — 무역 방 기준
 */

export function useExternalTradeDomainControllerUnread<
  TData = Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalTradeDomainControllerUnreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerUnread>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalTradeDomainControllerUnreadQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 차단 — 멱등. 두 사람 사이의 열린 방이 읽기 전용이 된다
 */
export const externalTradeDomainControllerBlock = (memberId: string) => {
  return api<void>({
    url: `/external/trade/me/blocks/${memberId}`,
    method: "PUT",
  });
};

export const getExternalTradeDomainControllerBlockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>,
    TError,
    { memberId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerBlock"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>,
    { memberId: string }
  > = (props) => {
    const { memberId } = props ?? {};

    return externalTradeDomainControllerBlock(memberId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>
>;

export type ExternalTradeDomainControllerBlockMutationError =
  ErrorType<unknown>;

/**
 * @summary 차단 — 멱등. 두 사람 사이의 열린 방이 읽기 전용이 된다
 */
export const useExternalTradeDomainControllerBlock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>,
      TError,
      { memberId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerBlock>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerBlockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 차단 해제 — 멱등. 반대쪽도 막고 있지 않으면 차단으로 닫혔던 방을 다시 연다
 */
export const externalTradeDomainControllerUnblock = (memberId: string) => {
  return api<void>({
    url: `/external/trade/me/blocks/${memberId}`,
    method: "DELETE",
  });
};

export const getExternalTradeDomainControllerUnblockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>,
    TError,
    { memberId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationKey = ["externalTradeDomainControllerUnblock"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>,
    { memberId: string }
  > = (props) => {
    const { memberId } = props ?? {};

    return externalTradeDomainControllerUnblock(memberId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalTradeDomainControllerUnblockMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>
>;

export type ExternalTradeDomainControllerUnblockMutationError =
  ErrorType<unknown>;

/**
 * @summary 차단 해제 — 멱등. 반대쪽도 막고 있지 않으면 차단으로 닫혔던 방을 다시 연다
 */
export const useExternalTradeDomainControllerUnblock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>,
      TError,
      { memberId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalTradeDomainControllerUnblock>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationOptions =
    getExternalTradeDomainControllerUnblockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 둘 중 한쪽이라도 상대를 막았는가 — 방향은 말하지 않는다
 */
export const externalTradeDomainControllerBlockedBetween = (
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  signal?: AbortSignal,
) => {
  return api<ExternalTradeDomainControllerBlockedBetween200>({
    url: `/external/trade/blocks/between`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalTradeDomainControllerBlockedBetweenQueryKey = (
  params?: ExternalTradeDomainControllerBlockedBetweenParams,
) => {
  return [
    `/external/trade/blocks/between`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalTradeDomainControllerBlockedBetweenQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerBlockedBetween>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalTradeDomainControllerBlockedBetweenQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>
  > = ({ signal }) =>
    externalTradeDomainControllerBlockedBetween(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalTradeDomainControllerBlockedBetweenQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>
  >;
export type ExternalTradeDomainControllerBlockedBetweenQueryError =
  ErrorType<unknown>;

export function useExternalTradeDomainControllerBlockedBetween<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerBlockedBetween>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerBlockedBetween>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerBlockedBetween>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerBlockedBetween<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerBlockedBetween>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalTradeDomainControllerBlockedBetween>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalTradeDomainControllerBlockedBetween>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalTradeDomainControllerBlockedBetween<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerBlockedBetween>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 둘 중 한쪽이라도 상대를 막았는가 — 방향은 말하지 않는다
 */

export function useExternalTradeDomainControllerBlockedBetween<
  TData = Awaited<
    ReturnType<typeof externalTradeDomainControllerBlockedBetween>
  >,
  TError = ErrorType<unknown>,
>(
  params: ExternalTradeDomainControllerBlockedBetweenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalTradeDomainControllerBlockedBetween>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalTradeDomainControllerBlockedBetweenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 제목(과 설명)으로 종목을 고르고(규칙 엔진, AI 없음) 그 종목으로 «바로 업체 찾기» 와 같은 문턱의 업체 수를 센다. kind 를 주면 그 갈래 후보만 쓴다. 갈래를 못 정하면 preview=null. 코드 표가 비어 있으면 codes=[]. 회사 이름은 없다.
 * @summary 씨마켓 AI 공고 등록 — 공사·용역 종목 판정 + 자격 맞는 업체 수 + 조달청 표준 코드
 */
export const externalCmarketAiBidControllerWork = (
  cmarketAiBidWorkRequestDto: BodyType<CmarketAiBidWorkRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketAiBidControllerWork200>({
    url: `/external/cmarket/ai-bid/work`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketAiBidWorkRequestDto,
    signal,
  });
};

export const getExternalCmarketAiBidControllerWorkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>,
    TError,
    { data: BodyType<CmarketAiBidWorkRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>,
  TError,
  { data: BodyType<CmarketAiBidWorkRequestDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketAiBidControllerWork"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>,
    { data: BodyType<CmarketAiBidWorkRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketAiBidControllerWork(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketAiBidControllerWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>
>;
export type ExternalCmarketAiBidControllerWorkMutationBody =
  BodyType<CmarketAiBidWorkRequestDto>;
export type ExternalCmarketAiBidControllerWorkMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 AI 공고 등록 — 공사·용역 종목 판정 + 자격 맞는 업체 수 + 조달청 표준 코드
 */
export const useExternalCmarketAiBidControllerWork = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>,
      TError,
      { data: BodyType<CmarketAiBidWorkRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketAiBidControllerWork>>,
  TError,
  { data: BodyType<CmarketAiBidWorkRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketAiBidControllerWorkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 바코드표(공용 GTIN·내 품번)·세모 상품코드 정확일치는 자동 확정(match), 제조사 품번 정확·접두 일치는 후보(candidates). 둘 다 없으면 404.
 * @summary 스캔값으로 내 물품 찾기
 */
export const itemBarcodeControllerLookup = (
  params: ItemBarcodeControllerLookupParams,
  signal?: AbortSignal,
) => {
  return api<ItemBarcodeControllerLookup200>({
    url: `/external/items/lookup`,
    method: "GET",
    params,
    signal,
  });
};

export const getItemBarcodeControllerLookupQueryKey = (
  params?: ItemBarcodeControllerLookupParams,
) => {
  return [`/external/items/lookup`, ...(params ? [params] : [])] as const;
};

export const getItemBarcodeControllerLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
  TError = ErrorType<unknown>,
>(
  params: ItemBarcodeControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemBarcodeControllerLookupQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemBarcodeControllerLookup>>
  > = ({ signal }) => itemBarcodeControllerLookup(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemBarcodeControllerLookupQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemBarcodeControllerLookup>>
>;
export type ItemBarcodeControllerLookupQueryError = ErrorType<unknown>;

export function useItemBarcodeControllerLookup<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
  TError = ErrorType<unknown>,
>(
  params: ItemBarcodeControllerLookupParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
          TError,
          Awaited<ReturnType<typeof itemBarcodeControllerLookup>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemBarcodeControllerLookup<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
  TError = ErrorType<unknown>,
>(
  params: ItemBarcodeControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
          TError,
          Awaited<ReturnType<typeof itemBarcodeControllerLookup>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemBarcodeControllerLookup<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
  TError = ErrorType<unknown>,
>(
  params: ItemBarcodeControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 스캔값으로 내 물품 찾기
 */

export function useItemBarcodeControllerLookup<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
  TError = ErrorType<unknown>,
>(
  params: ItemBarcodeControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerLookup>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemBarcodeControllerLookupQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 물품의 바코드 목록 (공용 전부 + 내 품번)
 */
export const itemBarcodeControllerList = (id: string, signal?: AbortSignal) => {
  return api<ItemBarcodeControllerList200>({
    url: `/external/items/${id}/barcodes`,
    method: "GET",
    signal,
  });
};

export const getItemBarcodeControllerListQueryKey = (id?: string) => {
  return [`/external/items/${id}/barcodes`] as const;
};

export const getItemBarcodeControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof itemBarcodeControllerList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getItemBarcodeControllerListQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof itemBarcodeControllerList>>
  > = ({ signal }) => itemBarcodeControllerList(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof itemBarcodeControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ItemBarcodeControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof itemBarcodeControllerList>>
>;
export type ItemBarcodeControllerListQueryError = ErrorType<unknown>;

export function useItemBarcodeControllerList<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemBarcodeControllerList>>,
          TError,
          Awaited<ReturnType<typeof itemBarcodeControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemBarcodeControllerList<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemBarcodeControllerList>>,
          TError,
          Awaited<ReturnType<typeof itemBarcodeControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useItemBarcodeControllerList<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 물품의 바코드 목록 (공용 전부 + 내 품번)
 */

export function useItemBarcodeControllerList<
  TData = Awaited<ReturnType<typeof itemBarcodeControllerList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof itemBarcodeControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getItemBarcodeControllerListQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * PUBLIC 은 GTIN 체크섬 검증(틀리면 400), 이미 다른 물품에 있으면 409. PRIVATE 은 내 품번.
 * @summary 물품에 바코드 연결
 */
export const itemBarcodeControllerRegister = (
  id: string,
  registerItemBarcodeDto: BodyType<RegisterItemBarcodeDto>,
  signal?: AbortSignal,
) => {
  return api<ItemBarcodeControllerRegister201>({
    url: `/external/items/${id}/barcodes`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerItemBarcodeDto,
    signal,
  });
};

export const getItemBarcodeControllerRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof itemBarcodeControllerRegister>>,
    TError,
    { id: string; data: BodyType<RegisterItemBarcodeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof itemBarcodeControllerRegister>>,
  TError,
  { id: string; data: BodyType<RegisterItemBarcodeDto> },
  TContext
> => {
  const mutationKey = ["itemBarcodeControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof itemBarcodeControllerRegister>>,
    { id: string; data: BodyType<RegisterItemBarcodeDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return itemBarcodeControllerRegister(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ItemBarcodeControllerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof itemBarcodeControllerRegister>>
>;
export type ItemBarcodeControllerRegisterMutationBody =
  BodyType<RegisterItemBarcodeDto>;
export type ItemBarcodeControllerRegisterMutationError = ErrorType<unknown>;

/**
 * @summary 물품에 바코드 연결
 */
export const useItemBarcodeControllerRegister = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof itemBarcodeControllerRegister>>,
      TError,
      { id: string; data: BodyType<RegisterItemBarcodeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof itemBarcodeControllerRegister>>,
  TError,
  { id: string; data: BodyType<RegisterItemBarcodeDto> },
  TContext
> => {
  const mutationOptions =
    getItemBarcodeControllerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 품번 삭제 (공용 바코드는 운영자만)
 */
export const itemBarcodeControllerRemove = (id: string, barcodeId: string) => {
  return api<void>({
    url: `/external/items/${id}/barcodes/${barcodeId}`,
    method: "DELETE",
  });
};

export const getItemBarcodeControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof itemBarcodeControllerRemove>>,
    TError,
    { id: string; barcodeId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof itemBarcodeControllerRemove>>,
  TError,
  { id: string; barcodeId: string },
  TContext
> => {
  const mutationKey = ["itemBarcodeControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof itemBarcodeControllerRemove>>,
    { id: string; barcodeId: string }
  > = (props) => {
    const { id, barcodeId } = props ?? {};

    return itemBarcodeControllerRemove(id, barcodeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ItemBarcodeControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof itemBarcodeControllerRemove>>
>;

export type ItemBarcodeControllerRemoveMutationError = ErrorType<unknown>;

/**
 * @summary 내 품번 삭제 (공용 바코드는 운영자만)
 */
export const useItemBarcodeControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof itemBarcodeControllerRemove>>,
      TError,
      { id: string; barcodeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof itemBarcodeControllerRemove>>,
  TError,
  { id: string; barcodeId: string },
  TContext
> => {
  const mutationOptions =
    getItemBarcodeControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 물품 id 순 페이지(after = 이전 응답의 nextAfter). 품명이 번호뿐인 물품은 뺀다(skippedUnnamed). 각 물품에 열린 공고 수와, 업체가 단가를 넣을 대표 공고 줄(sampleBid)을 붙인다. 회원 정보는 다루지 않는다.
 * @summary 단가가 필요한 세모 물품 — 열린 물품 공고 줄에 연결됐는데 단가 넣은 업체가 없는 것
 */
export const externalPriceRequestDemandControllerPage = (
  params?: ExternalPriceRequestDemandControllerPageParams,
  signal?: AbortSignal,
) => {
  return api<ExternalPriceRequestDemandControllerPage200>({
    url: `/external/cmarket/price-request-demand`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalPriceRequestDemandControllerPageQueryKey = (
  params?: ExternalPriceRequestDemandControllerPageParams,
) => {
  return [
    `/external/cmarket/price-request-demand`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalPriceRequestDemandControllerPageQueryOptions = <
  TData = Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalPriceRequestDemandControllerPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalPriceRequestDemandControllerPageQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>
  > = ({ signal }) => externalPriceRequestDemandControllerPage(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalPriceRequestDemandControllerPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>
>;
export type ExternalPriceRequestDemandControllerPageQueryError =
  ErrorType<unknown>;

export function useExternalPriceRequestDemandControllerPage<
  TData = Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalPriceRequestDemandControllerPageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
          TError,
          Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalPriceRequestDemandControllerPage<
  TData = Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalPriceRequestDemandControllerPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
          TError,
          Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalPriceRequestDemandControllerPage<
  TData = Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalPriceRequestDemandControllerPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 단가가 필요한 세모 물품 — 열린 물품 공고 줄에 연결됐는데 단가 넣은 업체가 없는 것
 */

export function useExternalPriceRequestDemandControllerPage<
  TData = Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalPriceRequestDemandControllerPageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalPriceRequestDemandControllerPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalPriceRequestDemandControllerPageQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 씨마켓 공고 줄 → 세모 물품 연결·신규 등록 판정(기본 예행연습, 한 번에 200줄)
 */
export const externalCmarketBidsControllerResolveLines = (
  cmarketLineResolveDto: BodyType<CmarketLineResolveDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerResolveLines200>({
    url: `/external/bids/lines/resolve`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketLineResolveDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerResolveLinesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>,
    TError,
    { data: BodyType<CmarketLineResolveDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>,
  TError,
  { data: BodyType<CmarketLineResolveDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketBidsControllerResolveLines"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>,
    { data: BodyType<CmarketLineResolveDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketBidsControllerResolveLines(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketBidsControllerResolveLinesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>
  >;
export type ExternalCmarketBidsControllerResolveLinesMutationBody =
  BodyType<CmarketLineResolveDto>;
export type ExternalCmarketBidsControllerResolveLinesMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 공고 줄 → 세모 물품 연결·신규 등록 판정(기본 예행연습, 한 번에 200줄)
 */
export const useExternalCmarketBidsControllerResolveLines = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>,
      TError,
      { data: BodyType<CmarketLineResolveDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerResolveLines>>,
  TError,
  { data: BodyType<CmarketLineResolveDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerResolveLinesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공고 한 건을 통째로 받아 `CMARKET:<공고번호>` 키로 덮어쓴다. 줄에 붙은 세모 물품 id(itemId)는 이름 매칭보다 먼저 «연결 일치» 로 판정된다. 같은 내용을 다시 보내도 무해하다.
 * @summary 씨마켓 공고 — 세모 공고함 원장에 싣기(등록·수정·마감·취소·낙찰마다)
 */
export const externalCmarketBidsControllerSync = (
  cmarketBidSyncDto: BodyType<CmarketBidSyncDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerSync200>({
    url: `/external/bids/sync`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketBidSyncDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerSyncMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>,
    TError,
    { data: BodyType<CmarketBidSyncDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>,
  TError,
  { data: BodyType<CmarketBidSyncDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketBidsControllerSync"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>,
    { data: BodyType<CmarketBidSyncDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketBidsControllerSync(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketBidsControllerSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>
>;
export type ExternalCmarketBidsControllerSyncMutationBody =
  BodyType<CmarketBidSyncDto>;
export type ExternalCmarketBidsControllerSyncMutationError = ErrorType<unknown>;

/**
 * @summary 씨마켓 공고 — 세모 공고함 원장에 싣기(등록·수정·마감·취소·낙찰마다)
 */
export const useExternalCmarketBidsControllerSync = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>,
      TError,
      { data: BodyType<CmarketBidSyncDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerSync>>,
  TError,
  { data: BodyType<CmarketBidSyncDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공고 줄에 붙은 세모 물품을 파는 공급사에게 세모 인앱 알림 한 통, 줄마다 공급가액이 가장 싼 2곳에는 문자(SMS)도. (공고, 업체) 한 번만 — 다시 불러도 두 번 울리지 않는다.
 * @summary 씨마켓 공고 — 취급 기업에게 공고참여 안내
 */
export const externalCmarketBidsControllerAnnounce = (
  cmarketBidAnnounceDto: BodyType<CmarketBidAnnounceDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerAnnounce200>({
    url: `/external/bids/announce`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketBidAnnounceDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerAnnounceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>,
    TError,
    { data: BodyType<CmarketBidAnnounceDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>,
  TError,
  { data: BodyType<CmarketBidAnnounceDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketBidsControllerAnnounce"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>,
    { data: BodyType<CmarketBidAnnounceDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketBidsControllerAnnounce(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketBidsControllerAnnounceMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>
>;
export type ExternalCmarketBidsControllerAnnounceMutationBody =
  BodyType<CmarketBidAnnounceDto>;
export type ExternalCmarketBidsControllerAnnounceMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 공고 — 취급 기업에게 공고참여 안내
 */
export const useExternalCmarketBidsControllerAnnounce = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>,
      TError,
      { data: BodyType<CmarketBidAnnounceDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerAnnounce>>,
  TError,
  { data: BodyType<CmarketBidAnnounceDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerAnnounceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 씨마켓 어드민 — 세모 마스터 물품 신규 등록
 */
export const externalCmarketBidsControllerCreateMasterItem = (
  cmarketCreateMasterItemDto: BodyType<CmarketCreateMasterItemDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerCreateMasterItem201>({
    url: `/external/bids/master-items`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketCreateMasterItemDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerCreateMasterItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>,
    TError,
    { data: BodyType<CmarketCreateMasterItemDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>,
  TError,
  { data: BodyType<CmarketCreateMasterItemDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketBidsControllerCreateMasterItem"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>,
    { data: BodyType<CmarketCreateMasterItemDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketBidsControllerCreateMasterItem(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketBidsControllerCreateMasterItemMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>
  >;
export type ExternalCmarketBidsControllerCreateMasterItemMutationBody =
  BodyType<CmarketCreateMasterItemDto>;
export type ExternalCmarketBidsControllerCreateMasterItemMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 어드민 — 세모 마스터 물품 신규 등록
 */
export const useExternalCmarketBidsControllerCreateMasterItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>,
      TError,
      { data: BodyType<CmarketCreateMasterItemDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerCreateMasterItem>>,
  TError,
  { data: BodyType<CmarketCreateMasterItemDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerCreateMasterItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 씨마켓 공고 시약 줄 — 제조사 제품번호로 세모 시약을 찾거나 없으면 만든다
 */
export const externalCmarketBidsControllerEnsureReagentItem = (
  cmarketEnsureReagentItemDto: BodyType<CmarketEnsureReagentItemDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerEnsureReagentItem200>({
    url: `/external/bids/master-items/reagents/ensure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketEnsureReagentItemDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerEnsureReagentItemMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>
      >,
      TError,
      { data: BodyType<CmarketEnsureReagentItemDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>>,
    TError,
    { data: BodyType<CmarketEnsureReagentItemDto> },
    TContext
  > => {
    const mutationKey = ["externalCmarketBidsControllerEnsureReagentItem"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>
      >,
      { data: BodyType<CmarketEnsureReagentItemDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalCmarketBidsControllerEnsureReagentItem(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalCmarketBidsControllerEnsureReagentItemMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>>
  >;
export type ExternalCmarketBidsControllerEnsureReagentItemMutationBody =
  BodyType<CmarketEnsureReagentItemDto>;
export type ExternalCmarketBidsControllerEnsureReagentItemMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 공고 시약 줄 — 제조사 제품번호로 세모 시약을 찾거나 없으면 만든다
 */
export const useExternalCmarketBidsControllerEnsureReagentItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>
      >,
      TError,
      { data: BodyType<CmarketEnsureReagentItemDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerEnsureReagentItem>>,
  TError,
  { data: BodyType<CmarketEnsureReagentItemDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerEnsureReagentItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 세모 물품 id 들의 이름·규격·단위·카테고리 — 어드민 공고 줄에 어느 물품인지 보여 준다
 */
export const externalCmarketBidsControllerMasterItemNames = (
  cmarketMasterItemNamesDto: BodyType<CmarketMasterItemNamesDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerMasterItemNames200>({
    url: `/external/bids/master-items/names`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketMasterItemNamesDto,
    signal,
  });
};

export const getExternalCmarketBidsControllerMasterItemNamesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>,
    TError,
    { data: BodyType<CmarketMasterItemNamesDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>,
  TError,
  { data: BodyType<CmarketMasterItemNamesDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketBidsControllerMasterItemNames"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>,
    { data: BodyType<CmarketMasterItemNamesDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketBidsControllerMasterItemNames(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketBidsControllerMasterItemNamesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>
  >;
export type ExternalCmarketBidsControllerMasterItemNamesMutationBody =
  BodyType<CmarketMasterItemNamesDto>;
export type ExternalCmarketBidsControllerMasterItemNamesMutationError =
  ErrorType<unknown>;

/**
 * @summary 세모 물품 id 들의 이름·규격·단위·카테고리 — 어드민 공고 줄에 어느 물품인지 보여 준다
 */
export const useExternalCmarketBidsControllerMasterItemNames = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>,
      TError,
      { data: BodyType<CmarketMasterItemNamesDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketBidsControllerMasterItemNames>>,
  TError,
  { data: BodyType<CmarketMasterItemNamesDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketBidsControllerMasterItemNamesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 세모 카테고리 이름 검색(활성만, 최대 30) — 신규 등록 폼용
 */
export const externalCmarketBidsControllerMasterCategories = (
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketBidsControllerMasterCategories200>({
    url: `/external/bids/master-items/categories`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalCmarketBidsControllerMasterCategoriesQueryKey = (
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
) => {
  return [
    `/external/bids/master-items/categories`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalCmarketBidsControllerMasterCategoriesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalCmarketBidsControllerMasterCategories>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketBidsControllerMasterCategories>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalCmarketBidsControllerMasterCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterCategories>>
  > = ({ signal }) =>
    externalCmarketBidsControllerMasterCategories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalCmarketBidsControllerMasterCategoriesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketBidsControllerMasterCategories>>
  >;
export type ExternalCmarketBidsControllerMasterCategoriesQueryError =
  ErrorType<unknown>;

export function useExternalCmarketBidsControllerMasterCategories<
  TData = Awaited<
    ReturnType<typeof externalCmarketBidsControllerMasterCategories>
  >,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalCmarketBidsControllerMasterCategoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketBidsControllerMasterCategories>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCmarketBidsControllerMasterCategories>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCmarketBidsControllerMasterCategories>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCmarketBidsControllerMasterCategories<
  TData = Awaited<
    ReturnType<typeof externalCmarketBidsControllerMasterCategories>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketBidsControllerMasterCategories>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalCmarketBidsControllerMasterCategories>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalCmarketBidsControllerMasterCategories>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalCmarketBidsControllerMasterCategories<
  TData = Awaited<
    ReturnType<typeof externalCmarketBidsControllerMasterCategories>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketBidsControllerMasterCategories>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 세모 카테고리 이름 검색(활성만, 최대 30) — 신규 등록 폼용
 */

export function useExternalCmarketBidsControllerMasterCategories<
  TData = Awaited<
    ReturnType<typeof externalCmarketBidsControllerMasterCategories>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ExternalCmarketBidsControllerMasterCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalCmarketBidsControllerMasterCategories>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalCmarketBidsControllerMasterCategoriesQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 회사 단위 전체 교체 — 회사마다 그 회사의 키워드 전부를 보낸다(빈 배열이면 세모에 있던 이력을 지운다). 씨마켓 회원 아이디로 세모 공급사를 찾고, 못 찾으면 건너뛰어 unknownSuppliers 로 센다. 내용이 바뀐 공급사는 공고함 공사·용역 추천(«씨마켓 실적 ‹…› n회 참여·m회 낙찰»)을 배경에서 다시 계산한다. 같은 배치를 다시 보내도 결과가 같다(멱등). 저장 실패만 5xx.
 * @summary 씨마켓 회사 × 업종 키워드(공사 G·용역 S) 참여·낙찰 이력 수신
 */
export const externalCmarketKeywordStatsControllerReceive = (
  cmarketKeywordStatsBatchDto: BodyType<CmarketKeywordStatsBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketKeywordStatsControllerReceive200>({
    url: `/external/cmarket/supplier-keyword-stats`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketKeywordStatsBatchDto,
    signal,
  });
};

export const getExternalCmarketKeywordStatsControllerReceiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>,
    TError,
    { data: BodyType<CmarketKeywordStatsBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>,
  TError,
  { data: BodyType<CmarketKeywordStatsBatchDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketKeywordStatsControllerReceive"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>,
    { data: BodyType<CmarketKeywordStatsBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketKeywordStatsControllerReceive(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketKeywordStatsControllerReceiveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>
  >;
export type ExternalCmarketKeywordStatsControllerReceiveMutationBody =
  BodyType<CmarketKeywordStatsBatchDto>;
export type ExternalCmarketKeywordStatsControllerReceiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 회사 × 업종 키워드(공사 G·용역 S) 참여·낙찰 이력 수신
 */
export const useExternalCmarketKeywordStatsControllerReceive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>,
      TError,
      { data: BodyType<CmarketKeywordStatsBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketKeywordStatsControllerReceive>>,
  TError,
  { data: BodyType<CmarketKeywordStatsBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketKeywordStatsControllerReceiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 관측은 전부 남기고, 공급사 현재가는 규칙대로만 건드린다 — 업체가 동의한 응찰(updateCatalog)만 덮어쓰기, 없는 단가는 등재, 있고 더 최신·다르면 «제안»(판매자 센터 행 안 [최신가격 반영]), 아니면 둔다. 같은 externalKey 는 몇 번 보내도 한 행(멱등). 4xx 는 내지 않는다 — 문제가 있는 줄은 ignored 로 돌려준다.
 * @summary 씨마켓 응찰·낙찰 단가 수신
 */
export const externalPriceObservationsControllerReceive = (
  priceObservationBatchDto: BodyType<PriceObservationBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalPriceObservationsControllerReceive200>({
    url: `/external/price-observations`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: priceObservationBatchDto,
    signal,
  });
};

export const getExternalPriceObservationsControllerReceiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>,
    TError,
    { data: BodyType<PriceObservationBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>,
  TError,
  { data: BodyType<PriceObservationBatchDto> },
  TContext
> => {
  const mutationKey = ["externalPriceObservationsControllerReceive"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>,
    { data: BodyType<PriceObservationBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalPriceObservationsControllerReceive(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalPriceObservationsControllerReceiveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>
  >;
export type ExternalPriceObservationsControllerReceiveMutationBody =
  BodyType<PriceObservationBatchDto>;
export type ExternalPriceObservationsControllerReceiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 응찰·낙찰 단가 수신
 */
export const useExternalPriceObservationsControllerReceive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>,
      TError,
      { data: BodyType<PriceObservationBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalPriceObservationsControllerReceive>>,
  TError,
  { data: BodyType<PriceObservationBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalPriceObservationsControllerReceiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 같은 관측 행의 status/won/awardedAt 만 바꾼다. 대상은 externalKeys 또는 (bidNo, supplierExternalId) 에서 excludeExternalKeys 를 뺀 것. 철회(voided)면 그 관측에서 나온 대기 제안도 닫는다.
 * @summary 씨마켓 응찰 철회·낙찰·낙찰 취소 반영
 */
export const externalPriceObservationsControllerUpdateStatus = (
  priceObservationStatusDto: BodyType<PriceObservationStatusDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalPriceObservationsControllerUpdateStatus200>({
    url: `/external/price-observations/status`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: priceObservationStatusDto,
    signal,
  });
};

export const getExternalPriceObservationsControllerUpdateStatusMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalPriceObservationsControllerUpdateStatus>
      >,
      TError,
      { data: BodyType<PriceObservationStatusDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalPriceObservationsControllerUpdateStatus>>,
    TError,
    { data: BodyType<PriceObservationStatusDto> },
    TContext
  > => {
    const mutationKey = ["externalPriceObservationsControllerUpdateStatus"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalPriceObservationsControllerUpdateStatus>
      >,
      { data: BodyType<PriceObservationStatusDto> }
    > = (props) => {
      const { data } = props ?? {};

      return externalPriceObservationsControllerUpdateStatus(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalPriceObservationsControllerUpdateStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalPriceObservationsControllerUpdateStatus>>
  >;
export type ExternalPriceObservationsControllerUpdateStatusMutationBody =
  BodyType<PriceObservationStatusDto>;
export type ExternalPriceObservationsControllerUpdateStatusMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 응찰 철회·낙찰·낙찰 취소 반영
 */
export const useExternalPriceObservationsControllerUpdateStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalPriceObservationsControllerUpdateStatus>
      >,
      TError,
      { data: BodyType<PriceObservationStatusDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalPriceObservationsControllerUpdateStatus>>,
  TError,
  { data: BodyType<PriceObservationStatusDto> },
  TContext
> => {
  const mutationOptions =
    getExternalPriceObservationsControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * https URL 만 받는다. 사설/내부 주소(localhost·10/8·169.254/16 등)로 해석되면 거부. 응답의 secret 은 이 한 번만 보인다.
 * @summary 웹훅 구독 등록 (파트너)
 */
export const externalWebhooksControllerCreate = (
  createWebhookSubscriptionDto: BodyType<CreateWebhookSubscriptionDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalWebhooksControllerCreate201>({
    url: `/external/webhooks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createWebhookSubscriptionDto,
    signal,
  });
};

export const getExternalWebhooksControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerCreate>>,
    TError,
    { data: BodyType<CreateWebhookSubscriptionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalWebhooksControllerCreate>>,
  TError,
  { data: BodyType<CreateWebhookSubscriptionDto> },
  TContext
> => {
  const mutationKey = ["externalWebhooksControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerCreate>>,
    { data: BodyType<CreateWebhookSubscriptionDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalWebhooksControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalWebhooksControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerCreate>>
>;
export type ExternalWebhooksControllerCreateMutationBody =
  BodyType<CreateWebhookSubscriptionDto>;
export type ExternalWebhooksControllerCreateMutationError = ErrorType<unknown>;

/**
 * @summary 웹훅 구독 등록 (파트너)
 */
export const useExternalWebhooksControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerCreate>>,
      TError,
      { data: BodyType<CreateWebhookSubscriptionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalWebhooksControllerCreate>>,
  TError,
  { data: BodyType<CreateWebhookSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalWebhooksControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 웹훅 구독 목록 (파트너)
 */
export const externalWebhooksControllerList = (signal?: AbortSignal) => {
  return api<ExternalWebhooksControllerList200>({
    url: `/external/webhooks`,
    method: "GET",
    signal,
  });
};

export const getExternalWebhooksControllerListQueryKey = () => {
  return [`/external/webhooks`] as const;
};

export const getExternalWebhooksControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalWebhooksControllerList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerList>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExternalWebhooksControllerListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerList>>
  > = ({ signal }) => externalWebhooksControllerList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalWebhooksControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerList>>
>;
export type ExternalWebhooksControllerListQueryError = ErrorType<unknown>;

export function useExternalWebhooksControllerList<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerList>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalWebhooksControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalWebhooksControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalWebhooksControllerList<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalWebhooksControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalWebhooksControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalWebhooksControllerList<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 웹훅 구독 목록 (파트너)
 */

export function useExternalWebhooksControllerList<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerList>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalWebhooksControllerListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 재활성화 포함 — isActive=true 로 보내면 자동 정지된 구독이 되살아난다(사유·연속 실패 초기화).
 * @summary 웹훅 구독 수정 (URL·토픽·재활성화)
 */
export const externalWebhooksControllerUpdate = (
  id: string,
  updateWebhookSubscriptionDto: BodyType<UpdateWebhookSubscriptionDto>,
) => {
  return api<ExternalWebhooksControllerUpdate200>({
    url: `/external/webhooks/${id}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateWebhookSubscriptionDto,
  });
};

export const getExternalWebhooksControllerUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>,
    TError,
    { id: string; data: BodyType<UpdateWebhookSubscriptionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>,
  TError,
  { id: string; data: BodyType<UpdateWebhookSubscriptionDto> },
  TContext
> => {
  const mutationKey = ["externalWebhooksControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>,
    { id: string; data: BodyType<UpdateWebhookSubscriptionDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return externalWebhooksControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalWebhooksControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>
>;
export type ExternalWebhooksControllerUpdateMutationBody =
  BodyType<UpdateWebhookSubscriptionDto>;
export type ExternalWebhooksControllerUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 웹훅 구독 수정 (URL·토픽·재활성화)
 */
export const useExternalWebhooksControllerUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>,
      TError,
      { id: string; data: BodyType<UpdateWebhookSubscriptionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalWebhooksControllerUpdate>>,
  TError,
  { id: string; data: BodyType<UpdateWebhookSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getExternalWebhooksControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 새 비밀키를 발급한다. 이전 키는 즉시 무효. 응답의 secret 은 이 한 번만 보인다.
 * @summary 웹훅 비밀키 회전
 */
export const externalWebhooksControllerRotateSecret = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalWebhooksControllerRotateSecret200>({
    url: `/external/webhooks/${id}/rotate-secret`,
    method: "POST",
    signal,
  });
};

export const getExternalWebhooksControllerRotateSecretMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalWebhooksControllerRotateSecret"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalWebhooksControllerRotateSecret(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalWebhooksControllerRotateSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>
>;

export type ExternalWebhooksControllerRotateSecretMutationError =
  ErrorType<unknown>;

/**
 * @summary 웹훅 비밀키 회전
 */
export const useExternalWebhooksControllerRotateSecret = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalWebhooksControllerRotateSecret>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalWebhooksControllerRotateSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * topic=test/ping 봉투를 즉시 보내고 결과를 돌려준다. 실제 서명·헤더가 그대로 붙는다. 배달 이력에도 남는다.
 * @summary 웹훅 테스트 발사
 */
export const externalWebhooksControllerSendTest = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalWebhooksControllerSendTest200>({
    url: `/external/webhooks/${id}/test`,
    method: "POST",
    signal,
  });
};

export const getExternalWebhooksControllerSendTestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalWebhooksControllerSendTest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalWebhooksControllerSendTest(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalWebhooksControllerSendTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>
>;

export type ExternalWebhooksControllerSendTestMutationError =
  ErrorType<unknown>;

/**
 * @summary 웹훅 테스트 발사
 */
export const useExternalWebhooksControllerSendTest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalWebhooksControllerSendTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalWebhooksControllerSendTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 웹훅 배달 이력 (구독별 최신순)
 */
export const externalWebhooksControllerListDeliveries = (
  id: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalWebhooksControllerListDeliveries200>({
    url: `/external/webhooks/${id}/deliveries`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalWebhooksControllerListDeliveriesQueryKey = (
  id?: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
) => {
  return [
    `/external/webhooks/${id}/deliveries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalWebhooksControllerListDeliveriesQueryOptions = <
  TData = Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalWebhooksControllerListDeliveriesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>
  > = ({ signal }) =>
    externalWebhooksControllerListDeliveries(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalWebhooksControllerListDeliveriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>
>;
export type ExternalWebhooksControllerListDeliveriesQueryError =
  ErrorType<unknown>;

export function useExternalWebhooksControllerListDeliveries<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | ExternalWebhooksControllerListDeliveriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
          TError,
          Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalWebhooksControllerListDeliveries<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
          TError,
          Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalWebhooksControllerListDeliveries<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 웹훅 배달 이력 (구독별 최신순)
 */

export function useExternalWebhooksControllerListDeliveries<
  TData = Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ExternalWebhooksControllerListDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalWebhooksControllerListDeliveries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalWebhooksControllerListDeliveriesQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * HELD/DEAD/RETRYING 건을 PENDING 으로 되돌린다. 워커가 15초 안에 다시 보낸다.
 * @summary 배달 수동 재전송
 */
export const externalWebhooksControllerRetry = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalWebhooksControllerRetry200>({
    url: `/external/webhooks/deliveries/${id}/retry`,
    method: "POST",
    signal,
  });
};

export const getExternalWebhooksControllerRetryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalWebhooksControllerRetry>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalWebhooksControllerRetry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalWebhooksControllerRetry"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalWebhooksControllerRetry>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalWebhooksControllerRetry(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalWebhooksControllerRetryMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalWebhooksControllerRetry>>
>;

export type ExternalWebhooksControllerRetryMutationError = ErrorType<unknown>;

/**
 * @summary 배달 수동 재전송
 */
export const useExternalWebhooksControllerRetry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalWebhooksControllerRetry>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalWebhooksControllerRetry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalWebhooksControllerRetryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 🛒 세모네모 내 찜 목록 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerListWishes = (
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReactionsControllerListWishes200>({
    url: `/external/storefronts/${slug}/reactions/wishes`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontReactionsControllerListWishesQueryKey = (
  slug?: string,
  params?: ExternalStorefrontReactionsControllerListWishesParams,
) => {
  return [
    `/external/storefronts/${slug}/reactions/wishes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontReactionsControllerListWishesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerListWishes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerListWishes>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontReactionsControllerListWishesQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerListWishes>>
  > = ({ signal }) =>
    externalStorefrontReactionsControllerListWishes(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerListWishes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontReactionsControllerListWishesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerListWishes>>
  >;
export type ExternalStorefrontReactionsControllerListWishesQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontReactionsControllerListWishes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerListWishes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerListWishes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerListWishes>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerListWishes>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerListWishes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerListWishes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerListWishes>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerListWishes>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerListWishes>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerListWishes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerListWishes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerListWishes>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 세모네모 내 찜 목록 (파트너 API 키)
 */

export function useExternalStorefrontReactionsControllerListWishes<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerListWishes>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerListWishesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerListWishes>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontReactionsControllerListWishesQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 지금 이 몰에서 파는 상품만. 이미 찜했으면 그대로 둔다(처음 찜한 때·가격 유지).
 * @summary 🛒 세모네모 찜 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerAddWish = (
  slug: string,
  itemId: string,
  reactionOwnerBodyDto: BodyType<ReactionOwnerBodyDto>,
) => {
  return api<ExternalStorefrontReactionsControllerAddWish200>({
    url: `/external/storefronts/${slug}/reactions/wishes/${itemId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: reactionOwnerBodyDto,
  });
};

export const getExternalStorefrontReactionsControllerAddWishMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>,
    TError,
    { slug: string; itemId: string; data: BodyType<ReactionOwnerBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>,
  TError,
  { slug: string; itemId: string; data: BodyType<ReactionOwnerBodyDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReactionsControllerAddWish"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>,
    { slug: string; itemId: string; data: BodyType<ReactionOwnerBodyDto> }
  > = (props) => {
    const { slug, itemId, data } = props ?? {};

    return externalStorefrontReactionsControllerAddWish(slug, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReactionsControllerAddWishMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>
  >;
export type ExternalStorefrontReactionsControllerAddWishMutationBody =
  BodyType<ReactionOwnerBodyDto>;
export type ExternalStorefrontReactionsControllerAddWishMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 찜 (파트너 API 키)
 */
export const useExternalStorefrontReactionsControllerAddWish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>,
      TError,
      { slug: string; itemId: string; data: BodyType<ReactionOwnerBodyDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerAddWish>>,
  TError,
  { slug: string; itemId: string; data: BodyType<ReactionOwnerBodyDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReactionsControllerAddWishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 🛒 세모네모 찜 해제 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerRemoveWish = (
  slug: string,
  itemId: string,
  params: ExternalStorefrontReactionsControllerRemoveWishParams,
) => {
  return api<ExternalStorefrontReactionsControllerRemoveWish200>({
    url: `/external/storefronts/${slug}/reactions/wishes/${itemId}`,
    method: "DELETE",
    params,
  });
};

export const getExternalStorefrontReactionsControllerRemoveWishMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>
      >,
      TError,
      {
        slug: string;
        itemId: string;
        params: ExternalStorefrontReactionsControllerRemoveWishParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>>,
    TError,
    {
      slug: string;
      itemId: string;
      params: ExternalStorefrontReactionsControllerRemoveWishParams;
    },
    TContext
  > => {
    const mutationKey = ["externalStorefrontReactionsControllerRemoveWish"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>
      >,
      {
        slug: string;
        itemId: string;
        params: ExternalStorefrontReactionsControllerRemoveWishParams;
      }
    > = (props) => {
      const { slug, itemId, params } = props ?? {};

      return externalStorefrontReactionsControllerRemoveWish(
        slug,
        itemId,
        params,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontReactionsControllerRemoveWishMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>>
  >;

export type ExternalStorefrontReactionsControllerRemoveWishMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 찜 해제 (파트너 API 키)
 */
export const useExternalStorefrontReactionsControllerRemoveWish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>
      >,
      TError,
      {
        slug: string;
        itemId: string;
        params: ExternalStorefrontReactionsControllerRemoveWishParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerRemoveWish>>,
  TError,
  {
    slug: string;
    itemId: string;
    params: ExternalStorefrontReactionsControllerRemoveWishParams;
  },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReactionsControllerRemoveWishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 회원·상품·날짜(KST)당 한 줄. 판매자 카드 «기관 N곳이 다시 봤어요» 의 원천.
 * @summary 🛒 세모네모 상품 상세 열람 기록 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerRecordView = (
  slug: string,
  recordItemViewDto: BodyType<RecordItemViewDto>,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/external/storefronts/${slug}/reactions/views`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: recordItemViewDto,
    signal,
  });
};

export const getExternalStorefrontReactionsControllerRecordViewMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRecordView>
      >,
      TError,
      { slug: string; data: BodyType<RecordItemViewDto> },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRecordView>>,
    TError,
    { slug: string; data: BodyType<RecordItemViewDto> },
    TContext
  > => {
    const mutationKey = ["externalStorefrontReactionsControllerRecordView"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRecordView>
      >,
      { slug: string; data: BodyType<RecordItemViewDto> }
    > = (props) => {
      const { slug, data } = props ?? {};

      return externalStorefrontReactionsControllerRecordView(slug, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExternalStorefrontReactionsControllerRecordViewMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRecordView>>
  >;
export type ExternalStorefrontReactionsControllerRecordViewMutationBody =
  BodyType<RecordItemViewDto>;
export type ExternalStorefrontReactionsControllerRecordViewMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 상품 상세 열람 기록 (파트너 API 키)
 */
export const useExternalStorefrontReactionsControllerRecordView = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof externalStorefrontReactionsControllerRecordView>
      >,
      TError,
      { slug: string; data: BodyType<RecordItemViewDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerRecordView>>,
  TError,
  { slug: string; data: BodyType<RecordItemViewDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReactionsControllerRecordViewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * «대학 5곳이 최근 30일 재구매» 배지. 실제 발주기관 주문만, 기관명은 가리고, 2곳 미만이면 null.
 * @summary 🛒 세모네모 목록 신호 — 찜 여부 + 사회적 증거 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerSignals = (
  slug: string,
  itemSignalsRequestDto: BodyType<ItemSignalsRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReactionsControllerSignals200>({
    url: `/external/storefronts/${slug}/reactions/signals`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: itemSignalsRequestDto,
    signal,
  });
};

export const getExternalStorefrontReactionsControllerSignalsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>,
    TError,
    { slug: string; data: BodyType<ItemSignalsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>,
  TError,
  { slug: string; data: BodyType<ItemSignalsRequestDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReactionsControllerSignals"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>,
    { slug: string; data: BodyType<ItemSignalsRequestDto> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return externalStorefrontReactionsControllerSignals(slug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReactionsControllerSignalsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>
  >;
export type ExternalStorefrontReactionsControllerSignalsMutationBody =
  BodyType<ItemSignalsRequestDto>;
export type ExternalStorefrontReactionsControllerSignalsMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 목록 신호 — 찜 여부 + 사회적 증거 (파트너 API 키)
 */
export const useExternalStorefrontReactionsControllerSignals = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>,
      TError,
      { slug: string; data: BodyType<ItemSignalsRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReactionsControllerSignals>>,
  TError,
  { slug: string; data: BodyType<ItemSignalsRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReactionsControllerSignalsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 사회적 증거가 있는 상품만, 재구매 > 구매 · 기관 수 많은 순.
 * @summary 🛒 세모네모 기관 재구매순 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerRanking = (
  slug: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReactionsControllerRanking200>({
    url: `/external/storefronts/${slug}/reactions/ranking`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontReactionsControllerRankingQueryKey = (
  slug?: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
) => {
  return [
    `/external/storefronts/${slug}/reactions/ranking`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontReactionsControllerRankingQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerRanking>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerRanking>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontReactionsControllerRankingQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRanking>>
  > = ({ signal }) =>
    externalStorefrontReactionsControllerRanking(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRanking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontReactionsControllerRankingQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerRanking>>
  >;
export type ExternalStorefrontReactionsControllerRankingQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontReactionsControllerRanking<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerRanking>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: undefined | ExternalStorefrontReactionsControllerRankingParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerRanking>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerRanking>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerRanking>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerRanking<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerRanking>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerRanking>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerRanking>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerRanking>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerRanking<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerRanking>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerRanking>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 세모네모 기관 재구매순 (파트너 API 키)
 */

export function useExternalStorefrontReactionsControllerRanking<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerRanking>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params?: ExternalStorefrontReactionsControllerRankingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof externalStorefrontReactionsControllerRanking>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontReactionsControllerRankingQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 찜 가격 내림·재입고·후기 도움돼요. 세모 계정이 없는 회원(직원 등)도 몰 화면에서 본다.
 * @summary 🛒 세모네모 내 반응 알림 (파트너 API 키)
 */
export const externalStorefrontReactionsControllerAlerts = (
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReactionsControllerAlerts200>({
    url: `/external/storefronts/${slug}/reactions/alerts`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontReactionsControllerAlertsQueryKey = (
  slug?: string,
  params?: ExternalStorefrontReactionsControllerAlertsParams,
) => {
  return [
    `/external/storefronts/${slug}/reactions/alerts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontReactionsControllerAlertsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerAlerts>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontReactionsControllerAlertsQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>
  > = ({ signal }) =>
    externalStorefrontReactionsControllerAlerts(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontReactionsControllerAlertsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>
  >;
export type ExternalStorefrontReactionsControllerAlertsQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontReactionsControllerAlerts<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerAlerts>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerAlerts>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerAlerts>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerAlerts<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerAlerts>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerAlerts>
          >,
          TError,
          Awaited<
            ReturnType<typeof externalStorefrontReactionsControllerAlerts>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReactionsControllerAlerts<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerAlerts>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 세모네모 내 반응 알림 (파트너 API 키)
 */

export function useExternalStorefrontReactionsControllerAlerts<
  TData = Awaited<
    ReturnType<typeof externalStorefrontReactionsControllerAlerts>
  >,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: ExternalStorefrontReactionsControllerAlertsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReactionsControllerAlerts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExternalStorefrontReactionsControllerAlertsQueryOptions(
      slug,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 보이는 후기만, 도움돼요 많은 순. ownerKey 를 주면 내가 쓸 수 있는 주문(reviewableOrders)도 싣는다.
 * @summary 🛒 세모네모 상품 후기 목록 (파트너 API 키)
 */
export const externalStorefrontReviewsControllerList = (
  slug: string,
  itemId: string,
  params?: ExternalStorefrontReviewsControllerListParams,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReviewsControllerList200>({
    url: `/external/storefronts/${slug}/reactions/items/${itemId}/reviews`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalStorefrontReviewsControllerListQueryKey = (
  slug?: string,
  itemId?: string,
  params?: ExternalStorefrontReviewsControllerListParams,
) => {
  return [
    `/external/storefronts/${slug}/reactions/items/${itemId}/reviews`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExternalStorefrontReviewsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  params?: ExternalStorefrontReviewsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalStorefrontReviewsControllerListQueryKey(slug, itemId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>
  > = ({ signal }) =>
    externalStorefrontReviewsControllerList(slug, itemId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalStorefrontReviewsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>
>;
export type ExternalStorefrontReviewsControllerListQueryError =
  ErrorType<unknown>;

export function useExternalStorefrontReviewsControllerList<
  TData = Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  params: undefined | ExternalStorefrontReviewsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReviewsControllerList<
  TData = Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  params?: ExternalStorefrontReviewsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalStorefrontReviewsControllerList<
  TData = Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  params?: ExternalStorefrontReviewsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 🛒 세모네모 상품 후기 목록 (파트너 API 키)
 */

export function useExternalStorefrontReviewsControllerList<
  TData = Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  itemId: string,
  params?: ExternalStorefrontReviewsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalStorefrontReviewsControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalStorefrontReviewsControllerListQueryOptions(
    slug,
    itemId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 구매확정(INSPECTED·SETTLED)한 내 주문에 그 상품이 있어야 한다 — 주문·상품당 하나. 작성자는 «유형 · 시도 담당자» 로만 보인다(기관명 없음).
 * @summary 🛒 세모네모 납품 사진 후기 쓰기 (파트너 API 키)
 */
export const externalStorefrontReviewsControllerCreate = (
  slug: string,
  itemId: string,
  createReviewDto: BodyType<CreateReviewDto>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`ownerKey`, createReviewDto.ownerKey);
  formData.append(`orderNo`, createReviewDto.orderNo);
  formData.append(`body`, createReviewDto.body);

  return api<ExternalStorefrontReviewsControllerCreate201>({
    url: `/external/storefronts/${slug}/reactions/items/${itemId}/reviews`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getExternalStorefrontReviewsControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>,
    TError,
    { slug: string; itemId: string; data: BodyType<CreateReviewDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>,
  TError,
  { slug: string; itemId: string; data: BodyType<CreateReviewDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReviewsControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>,
    { slug: string; itemId: string; data: BodyType<CreateReviewDto> }
  > = (props) => {
    const { slug, itemId, data } = props ?? {};

    return externalStorefrontReviewsControllerCreate(slug, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReviewsControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>
  >;
export type ExternalStorefrontReviewsControllerCreateMutationBody =
  BodyType<CreateReviewDto>;
export type ExternalStorefrontReviewsControllerCreateMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 납품 사진 후기 쓰기 (파트너 API 키)
 */
export const useExternalStorefrontReviewsControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>,
      TError,
      { slug: string; itemId: string; data: BodyType<CreateReviewDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerCreate>>,
  TError,
  { slug: string; itemId: string; data: BodyType<CreateReviewDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReviewsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 처음 누르면 후기 쓴 사람에게 알림(하루 1회 상한). 내 후기에는 못 누른다.
 * @summary 🛒 세모네모 후기 «도움돼요» (파트너 API 키)
 */
export const externalStorefrontReviewsControllerHelpful = (
  slug: string,
  reviewId: string,
  reviewHelpfulDto: BodyType<ReviewHelpfulDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReviewsControllerHelpful200>({
    url: `/external/storefronts/${slug}/reactions/reviews/${reviewId}/helpful`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reviewHelpfulDto,
    signal,
  });
};

export const getExternalStorefrontReviewsControllerHelpfulMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>,
    TError,
    { slug: string; reviewId: string; data: BodyType<ReviewHelpfulDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReviewHelpfulDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReviewsControllerHelpful"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>,
    { slug: string; reviewId: string; data: BodyType<ReviewHelpfulDto> }
  > = (props) => {
    const { slug, reviewId, data } = props ?? {};

    return externalStorefrontReviewsControllerHelpful(slug, reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReviewsControllerHelpfulMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>
  >;
export type ExternalStorefrontReviewsControllerHelpfulMutationBody =
  BodyType<ReviewHelpfulDto>;
export type ExternalStorefrontReviewsControllerHelpfulMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 후기 «도움돼요» (파트너 API 키)
 */
export const useExternalStorefrontReviewsControllerHelpful = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>,
      TError,
      { slug: string; reviewId: string; data: BodyType<ReviewHelpfulDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerHelpful>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReviewHelpfulDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReviewsControllerHelpfulMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 한 사람 한 번. 신고가 3건 쌓이면 후기를 자동으로 숨긴다(운영이 보고 되살리거나 지운다).
 * @summary 🛒 세모네모 후기 신고 (파트너 API 키)
 */
export const externalStorefrontReviewsControllerReport = (
  slug: string,
  reviewId: string,
  reviewReportDto: BodyType<ReviewReportDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReviewsControllerReport200>({
    url: `/external/storefronts/${slug}/reactions/reviews/${reviewId}/report`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reviewReportDto,
    signal,
  });
};

export const getExternalStorefrontReviewsControllerReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>,
    TError,
    { slug: string; reviewId: string; data: BodyType<ReviewReportDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReviewReportDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReviewsControllerReport"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>,
    { slug: string; reviewId: string; data: BodyType<ReviewReportDto> }
  > = (props) => {
    const { slug, reviewId, data } = props ?? {};

    return externalStorefrontReviewsControllerReport(slug, reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReviewsControllerReportMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>
  >;
export type ExternalStorefrontReviewsControllerReportMutationBody =
  BodyType<ReviewReportDto>;
export type ExternalStorefrontReviewsControllerReportMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 후기 신고 (파트너 API 키)
 */
export const useExternalStorefrontReviewsControllerReport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>,
      TError,
      { slug: string; reviewId: string; data: BodyType<ReviewReportDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerReport>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReviewReportDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReviewsControllerReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 🛒 세모네모 내 후기 지우기 (파트너 API 키)
 */
export const externalStorefrontReviewsControllerRemove = (
  slug: string,
  reviewId: string,
  reactionOwnerBodyDto: BodyType<ReactionOwnerBodyDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalStorefrontReviewsControllerRemove200>({
    url: `/external/storefronts/${slug}/reactions/reviews/${reviewId}/delete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reactionOwnerBodyDto,
    signal,
  });
};

export const getExternalStorefrontReviewsControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>,
    TError,
    { slug: string; reviewId: string; data: BodyType<ReactionOwnerBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReactionOwnerBodyDto> },
  TContext
> => {
  const mutationKey = ["externalStorefrontReviewsControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>,
    { slug: string; reviewId: string; data: BodyType<ReactionOwnerBodyDto> }
  > = (props) => {
    const { slug, reviewId, data } = props ?? {};

    return externalStorefrontReviewsControllerRemove(slug, reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalStorefrontReviewsControllerRemoveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>
  >;
export type ExternalStorefrontReviewsControllerRemoveMutationBody =
  BodyType<ReactionOwnerBodyDto>;
export type ExternalStorefrontReviewsControllerRemoveMutationError =
  ErrorType<unknown>;

/**
 * @summary 🛒 세모네모 내 후기 지우기 (파트너 API 키)
 */
export const useExternalStorefrontReviewsControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>,
      TError,
      { slug: string; reviewId: string; data: BodyType<ReactionOwnerBodyDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalStorefrontReviewsControllerRemove>>,
  TError,
  { slug: string; reviewId: string; data: BodyType<ReactionOwnerBodyDto> },
  TContext
> => {
  const mutationOptions =
    getExternalStorefrontReviewsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 내가 몰에 올린 상품(활성 오퍼)에 대한 최근 7일 찜 수(공급사 자기 찜 제외)와, 서로 다른 날 두 번 이상 본 기관 수. 기관명은 내보내지 않고 «유형 · 시도» 로만 접는다.
 * @summary 세모네모 반응 요약 — 이번 주 찜·다시 본 기관(공급사)
 */
export const supplierStorefrontReactionsControllerMine = (
  signal?: AbortSignal,
) => {
  return api<SupplierStorefrontReactionsControllerMine200>({
    url: `/external/storefront-reactions/mine/summary`,
    method: "GET",
    signal,
  });
};

export const getSupplierStorefrontReactionsControllerMineQueryKey = () => {
  return [`/external/storefront-reactions/mine/summary`] as const;
};

export const getSupplierStorefrontReactionsControllerMineQueryOptions = <
  TData = Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSupplierStorefrontReactionsControllerMineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>
  > = ({ signal }) => supplierStorefrontReactionsControllerMine(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SupplierStorefrontReactionsControllerMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>
>;
export type SupplierStorefrontReactionsControllerMineQueryError =
  ErrorType<unknown>;

export function useSupplierStorefrontReactionsControllerMine<
  TData = Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
          TError,
          Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierStorefrontReactionsControllerMine<
  TData = Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
          TError,
          Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierStorefrontReactionsControllerMine<
  TData = Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 세모네모 반응 요약 — 이번 주 찜·다시 본 기관(공급사)
 */

export function useSupplierStorefrontReactionsControllerMine<
  TData = Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierStorefrontReactionsControllerMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getSupplierStorefrontReactionsControllerMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 토큰 원문은 이 응답 한 번만 내려간다. 이 링크에서 만들어진 견적요청은 발급사 전용이 아니라 전체 공급사에게 공개된다.
 * @summary 즉시견적 링크 발급 (공급사)
 */
export const externalShareLinksControllerCreate = (
  createShareLinkDto: BodyType<CreateShareLinkDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalShareLinksControllerCreate201>({
    url: `/external/share-links`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createShareLinkDto,
    signal,
  });
};

export const getExternalShareLinksControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalShareLinksControllerCreate>>,
    TError,
    { data: BodyType<CreateShareLinkDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalShareLinksControllerCreate>>,
  TError,
  { data: BodyType<CreateShareLinkDto> },
  TContext
> => {
  const mutationKey = ["externalShareLinksControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalShareLinksControllerCreate>>,
    { data: BodyType<CreateShareLinkDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalShareLinksControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalShareLinksControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalShareLinksControllerCreate>>
>;
export type ExternalShareLinksControllerCreateMutationBody =
  BodyType<CreateShareLinkDto>;
export type ExternalShareLinksControllerCreateMutationError =
  ErrorType<unknown>;

/**
 * @summary 즉시견적 링크 발급 (공급사)
 */
export const useExternalShareLinksControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalShareLinksControllerCreate>>,
      TError,
      { data: BodyType<CreateShareLinkDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalShareLinksControllerCreate>>,
  TError,
  { data: BodyType<CreateShareLinkDto> },
  TContext
> => {
  const mutationOptions =
    getExternalShareLinksControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 링크 목록 (공급사)
 */
export const externalShareLinksControllerList = (
  params?: ExternalShareLinksControllerListParams,
  signal?: AbortSignal,
) => {
  return api<ExternalShareLinksControllerList200>({
    url: `/external/share-links`,
    method: "GET",
    params,
    signal,
  });
};

export const getExternalShareLinksControllerListQueryKey = (
  params?: ExternalShareLinksControllerListParams,
) => {
  return [`/external/share-links`, ...(params ? [params] : [])] as const;
};

export const getExternalShareLinksControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof externalShareLinksControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalShareLinksControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExternalShareLinksControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalShareLinksControllerList>>
  > = ({ signal }) => externalShareLinksControllerList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof externalShareLinksControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalShareLinksControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalShareLinksControllerList>>
>;
export type ExternalShareLinksControllerListQueryError = ErrorType<unknown>;

export function useExternalShareLinksControllerList<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ExternalShareLinksControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalShareLinksControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalShareLinksControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalShareLinksControllerList<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalShareLinksControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalShareLinksControllerList>>,
          TError,
          Awaited<ReturnType<typeof externalShareLinksControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalShareLinksControllerList<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalShareLinksControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 링크 목록 (공급사)
 */

export function useExternalShareLinksControllerList<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerList>>,
  TError = ErrorType<unknown>,
>(
  params?: ExternalShareLinksControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalShareLinksControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 링크 상세 (공급사)
 */
export const externalShareLinksControllerGet = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalShareLinksControllerGet200>({
    url: `/external/share-links/${id}`,
    method: "GET",
    signal,
  });
};

export const getExternalShareLinksControllerGetQueryKey = (id?: string) => {
  return [`/external/share-links/${id}`] as const;
};

export const getExternalShareLinksControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExternalShareLinksControllerGetQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof externalShareLinksControllerGet>>
  > = ({ signal }) => externalShareLinksControllerGet(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExternalShareLinksControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof externalShareLinksControllerGet>>
>;
export type ExternalShareLinksControllerGetQueryError = ErrorType<unknown>;

export function useExternalShareLinksControllerGet<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
          TError,
          Awaited<ReturnType<typeof externalShareLinksControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalShareLinksControllerGet<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
          TError,
          Awaited<ReturnType<typeof externalShareLinksControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExternalShareLinksControllerGet<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 링크 상세 (공급사)
 */

export function useExternalShareLinksControllerGet<
  TData = Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof externalShareLinksControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExternalShareLinksControllerGetQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 행 삭제가 아니라 revoked_at. 이후 그 토큰은 즉시 404.
 * @summary 링크 폐기 (공급사)
 */
export const externalShareLinksControllerRevoke = (id: string) => {
  return api<ExternalShareLinksControllerRevoke200>({
    url: `/external/share-links/${id}`,
    method: "DELETE",
  });
};

export const getExternalShareLinksControllerRevokeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalShareLinksControllerRevoke"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalShareLinksControllerRevoke(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalShareLinksControllerRevokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>
>;

export type ExternalShareLinksControllerRevokeMutationError =
  ErrorType<unknown>;

/**
 * @summary 링크 폐기 (공급사)
 */
export const useExternalShareLinksControllerRevoke = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalShareLinksControllerRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalShareLinksControllerRevokeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 새 토큰 + 옛 토큰 즉시 무효. 만료는 그대로(연장 없음).
 * @summary 링크 재발급 (공급사)
 */
export const externalShareLinksControllerReissue = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<ExternalShareLinksControllerReissue201>({
    url: `/external/share-links/${id}/reissue`,
    method: "POST",
    signal,
  });
};

export const getExternalShareLinksControllerReissueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalShareLinksControllerReissue>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalShareLinksControllerReissue>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["externalShareLinksControllerReissue"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalShareLinksControllerReissue>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return externalShareLinksControllerReissue(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalShareLinksControllerReissueMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalShareLinksControllerReissue>>
>;

export type ExternalShareLinksControllerReissueMutationError =
  ErrorType<unknown>;

/**
 * @summary 링크 재발급 (공급사)
 */
export const useExternalShareLinksControllerReissue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalShareLinksControllerReissue>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalShareLinksControllerReissue>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getExternalShareLinksControllerReissueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 보험사 순위의 첫 근거(«그 종목 응찰·낙찰 이력»). 종목은 세모가 공고명으로 정한다. 같은 (공고, 회원)은 덮어쓴다.
 * @summary 씨마켓 보험 가입 공고 응찰·낙찰 기록 받기(공고 × 회원)
 */
export const externalInsurerBidRecordsControllerIngest = (
  insurerBidRecordsBatchDto: BodyType<InsurerBidRecordsBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalInsurerBidRecordsControllerIngest200>({
    url: `/external/cmarket/insurance-bid-records`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: insurerBidRecordsBatchDto,
    signal,
  });
};

export const getExternalInsurerBidRecordsControllerIngestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>,
    TError,
    { data: BodyType<InsurerBidRecordsBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>,
  TError,
  { data: BodyType<InsurerBidRecordsBatchDto> },
  TContext
> => {
  const mutationKey = ["externalInsurerBidRecordsControllerIngest"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>,
    { data: BodyType<InsurerBidRecordsBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalInsurerBidRecordsControllerIngest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalInsurerBidRecordsControllerIngestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>
  >;
export type ExternalInsurerBidRecordsControllerIngestMutationBody =
  BodyType<InsurerBidRecordsBatchDto>;
export type ExternalInsurerBidRecordsControllerIngestMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 보험 가입 공고 응찰·낙찰 기록 받기(공고 × 회원)
 */
export const useExternalInsurerBidRecordsControllerIngest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>,
      TError,
      { data: BodyType<InsurerBidRecordsBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalInsurerBidRecordsControllerIngest>>,
  TError,
  { data: BodyType<InsurerBidRecordsBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalInsurerBidRecordsControllerIngestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 세모 동의 여부와 무관하게 활성 공급사 회사 정보를 회사 단위로 덮어쓴다. 담당자·연락처·계좌·사업자번호·대표자는 받지 않는다(칸이 없고 모르는 칸은 버린다). 계정을 만들지 않는다 — 동의하면 /external/suppliers/auth 가 만든다.
 * @summary 씨마켓 공급사 회사 명부 수신(회사 정보만 — 개인정보 없음)
 */
export const externalCmarketDirectoryControllerReceive = (
  cmarketDirectoryBatchDto: BodyType<CmarketDirectoryBatchDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketDirectoryControllerReceive200>({
    url: `/external/cmarket/supplier-directory`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketDirectoryBatchDto,
    signal,
  });
};

export const getExternalCmarketDirectoryControllerReceiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>,
    TError,
    { data: BodyType<CmarketDirectoryBatchDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>,
  TError,
  { data: BodyType<CmarketDirectoryBatchDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketDirectoryControllerReceive"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>,
    { data: BodyType<CmarketDirectoryBatchDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketDirectoryControllerReceive(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketDirectoryControllerReceiveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>
  >;
export type ExternalCmarketDirectoryControllerReceiveMutationBody =
  BodyType<CmarketDirectoryBatchDto>;
export type ExternalCmarketDirectoryControllerReceiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 공급사 회사 명부 수신(회사 정보만 — 개인정보 없음)
 */
export const useExternalCmarketDirectoryControllerReceive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>,
      TError,
      { data: BodyType<CmarketDirectoryBatchDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketDirectoryControllerReceive>>,
  TError,
  { data: BodyType<CmarketDirectoryBatchDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketDirectoryControllerReceiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * (cmarketBidNo, winnerSeq) 로 멱등 upsert 하고 줄은 통째로 바꾼다. 줄의 semoItemId 는 씨마켓 공고 줄의 세모 물품 연결 그대로 받는다. Idempotency-Key(`cmarket-award-{공고}-{순번}-r{판}`)를 주면 더 낮은 판이 늦게 와도 덮지 않는다. 씨마켓이 비워 보낼 수 있는 칸(기관 이름·사업자번호·상호·계약 시각·기관 그룹)이 비어도 400 을 주지 않는다. supplierMemberId 는 /external/suppliers/auth 의 id 와 같아야 한다(그 값으로 세모 공급사 계정이 정해진다). 검수 연락처(이름·전화)는 납품 검수 링크를 보내는 데만 쓰고 로그·PDF 에는 가린다.
 * @summary 씨마켓 낙찰 사본 받기(낙찰·계약 시작·취소)
 */
export const externalCmarketAwardsControllerReceive = (
  cmarketAwardRequestDto: BodyType<CmarketAwardRequestDto>,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketAwardsControllerReceive200>({
    url: `/external/cmarket/awards`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cmarketAwardRequestDto,
    signal,
  });
};

export const getExternalCmarketAwardsControllerReceiveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>,
    TError,
    { data: BodyType<CmarketAwardRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>,
  TError,
  { data: BodyType<CmarketAwardRequestDto> },
  TContext
> => {
  const mutationKey = ["externalCmarketAwardsControllerReceive"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>,
    { data: BodyType<CmarketAwardRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return externalCmarketAwardsControllerReceive(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketAwardsControllerReceiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>
>;
export type ExternalCmarketAwardsControllerReceiveMutationBody =
  BodyType<CmarketAwardRequestDto>;
export type ExternalCmarketAwardsControllerReceiveMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 낙찰 사본 받기(낙찰·계약 시작·취소)
 */
export const useExternalCmarketAwardsControllerReceive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>,
      TError,
      { data: BodyType<CmarketAwardRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketAwardsControllerReceive>>,
  TError,
  { data: BodyType<CmarketAwardRequestDto> },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketAwardsControllerReceiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 내 씨마켓 낙찰 건(보낼 것) — 남은 수량이 있는 것부터
 */
export const supplierCmarketAwardsControllerListMine = (
  signal?: AbortSignal,
) => {
  return api<SupplierCmarketAwardsControllerListMine200>({
    url: `/external/cmarket-awards/mine`,
    method: "GET",
    signal,
  });
};

export const getSupplierCmarketAwardsControllerListMineQueryKey = () => {
  return [`/external/cmarket-awards/mine`] as const;
};

export const getSupplierCmarketAwardsControllerListMineQueryOptions = <
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSupplierCmarketAwardsControllerListMineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>
  > = ({ signal }) => supplierCmarketAwardsControllerListMine(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SupplierCmarketAwardsControllerListMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>
>;
export type SupplierCmarketAwardsControllerListMineQueryError =
  ErrorType<unknown>;

export function useSupplierCmarketAwardsControllerListMine<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
          TError,
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierCmarketAwardsControllerListMine<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
          TError,
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierCmarketAwardsControllerListMine<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 내 씨마켓 낙찰 건(보낼 것) — 남은 수량이 있는 것부터
 */

export function useSupplierCmarketAwardsControllerListMine<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerListMine>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getSupplierCmarketAwardsControllerListMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 임베드 award=<공고 번호>:<낙찰 순번> 으로 연 낙찰 건 한 건
 */
export const supplierCmarketAwardsControllerByRef = (
  params: SupplierCmarketAwardsControllerByRefParams,
  signal?: AbortSignal,
) => {
  return api<SupplierCmarketAwardsControllerByRef200>({
    url: `/external/cmarket-awards/by-ref`,
    method: "GET",
    params,
    signal,
  });
};

export const getSupplierCmarketAwardsControllerByRefQueryKey = (
  params?: SupplierCmarketAwardsControllerByRefParams,
) => {
  return [
    `/external/cmarket-awards/by-ref`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSupplierCmarketAwardsControllerByRefQueryOptions = <
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
  TError = ErrorType<unknown>,
>(
  params: SupplierCmarketAwardsControllerByRefParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSupplierCmarketAwardsControllerByRefQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>
  > = ({ signal }) => supplierCmarketAwardsControllerByRef(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SupplierCmarketAwardsControllerByRefQueryResult = NonNullable<
  Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>
>;
export type SupplierCmarketAwardsControllerByRefQueryError = ErrorType<unknown>;

export function useSupplierCmarketAwardsControllerByRef<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
  TError = ErrorType<unknown>,
>(
  params: SupplierCmarketAwardsControllerByRefParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
          TError,
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierCmarketAwardsControllerByRef<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
  TError = ErrorType<unknown>,
>(
  params: SupplierCmarketAwardsControllerByRefParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
          TError,
          Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSupplierCmarketAwardsControllerByRef<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
  TError = ErrorType<unknown>,
>(
  params: SupplierCmarketAwardsControllerByRefParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 임베드 award=<공고 번호>:<낙찰 순번> 으로 연 낙찰 건 한 건
 */

export function useSupplierCmarketAwardsControllerByRef<
  TData = Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
  TError = ErrorType<unknown>,
>(
  params: SupplierCmarketAwardsControllerByRefParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supplierCmarketAwardsControllerByRef>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSupplierCmarketAwardsControllerByRefQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 낙찰 수량보다 많이 보낼 수 없다. items 를 비우면 남은 수량 전부를 한 송장으로 건다. 상자가 여러 개면 trackingNos 로 송장번호를 모두 넣는다(발송의 도착 = 모든 송장 도착). 직접 배송(DIRECT)은 등록한 뒤 «전달 완료 알리기»(POST /shipping/shipments/:id/claim-delivered)로 도착을 남긴다 — 택배 조회 완료나 전달 완료가 납품 검수 링크를 보내는 방아쇠다.
 * @summary 씨마켓 낙찰 건에 송장 등록(택배 송장 · 화물·퀵 · 직접 배송)
 */
export const supplierCmarketAwardsControllerRegister = (
  awardId: string,
  registerCmarketAwardShipmentDto: BodyType<RegisterCmarketAwardShipmentDto>,
  signal?: AbortSignal,
) => {
  return api<SupplierCmarketAwardsControllerRegister201>({
    url: `/external/cmarket-awards/${awardId}/shipments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerCmarketAwardShipmentDto,
    signal,
  });
};

export const getSupplierCmarketAwardsControllerRegisterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>,
    TError,
    { awardId: string; data: BodyType<RegisterCmarketAwardShipmentDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>,
  TError,
  { awardId: string; data: BodyType<RegisterCmarketAwardShipmentDto> },
  TContext
> => {
  const mutationKey = ["supplierCmarketAwardsControllerRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>,
    { awardId: string; data: BodyType<RegisterCmarketAwardShipmentDto> }
  > = (props) => {
    const { awardId, data } = props ?? {};

    return supplierCmarketAwardsControllerRegister(awardId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SupplierCmarketAwardsControllerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>
>;
export type SupplierCmarketAwardsControllerRegisterMutationBody =
  BodyType<RegisterCmarketAwardShipmentDto>;
export type SupplierCmarketAwardsControllerRegisterMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 낙찰 건에 송장 등록(택배 송장 · 화물·퀵 · 직접 배송)
 */
export const useSupplierCmarketAwardsControllerRegister = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>,
      TError,
      { awardId: string; data: BodyType<RegisterCmarketAwardShipmentDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof supplierCmarketAwardsControllerRegister>>,
  TError,
  { awardId: string; data: BodyType<RegisterCmarketAwardShipmentDto> },
  TContext
> => {
  const mutationOptions =
    getSupplierCmarketAwardsControllerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 검수 화면 열기(계약 줄·사진·판정)
 */
export const receiptInspectionPublicControllerView = (signal?: AbortSignal) => {
  return api<void>({ url: `/receipt-inspections/link`, method: "GET", signal });
};

export const getReceiptInspectionPublicControllerViewQueryKey = () => {
  return [`/receipt-inspections/link`] as const;
};

export const getReceiptInspectionPublicControllerViewQueryOptions = <
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReceiptInspectionPublicControllerViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>
  > = ({ signal }) => receiptInspectionPublicControllerView(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceiptInspectionPublicControllerViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>
>;
export type ReceiptInspectionPublicControllerViewQueryError =
  ErrorType<unknown>;

export function useReceiptInspectionPublicControllerView<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
          TError,
          Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReceiptInspectionPublicControllerView<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
          TError,
          Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReceiptInspectionPublicControllerView<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 검수 화면 열기(계약 줄·사진·판정)
 */

export function useReceiptInspectionPublicControllerView<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerView>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getReceiptInspectionPublicControllerViewQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 사진 올리기(전체 · 줄 라벨) — 라벨이면 글자를 읽고 자동 대조
 */
export const receiptInspectionPublicControllerUploadPhoto = (
  uploadInspectionPhotoDto: BodyType<UploadInspectionPhotoDto>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`kind`, uploadInspectionPhotoDto.kind);
  if (uploadInspectionPhotoDto.lineNo !== undefined) {
    formData.append(`lineNo`, uploadInspectionPhotoDto.lineNo.toString());
  }

  return api<void>({
    url: `/receipt-inspections/link/photos`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getReceiptInspectionPublicControllerUploadPhotoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>,
    TError,
    { data: BodyType<UploadInspectionPhotoDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>,
  TError,
  { data: BodyType<UploadInspectionPhotoDto> },
  TContext
> => {
  const mutationKey = ["receiptInspectionPublicControllerUploadPhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>,
    { data: BodyType<UploadInspectionPhotoDto> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptInspectionPublicControllerUploadPhoto(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptInspectionPublicControllerUploadPhotoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>
  >;
export type ReceiptInspectionPublicControllerUploadPhotoMutationBody =
  BodyType<UploadInspectionPhotoDto>;
export type ReceiptInspectionPublicControllerUploadPhotoMutationError =
  ErrorType<unknown>;

/**
 * @summary 사진 올리기(전체 · 줄 라벨) — 라벨이면 글자를 읽고 자동 대조
 */
export const useReceiptInspectionPublicControllerUploadPhoto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>,
      TError,
      { data: BodyType<UploadInspectionPhotoDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerUploadPhoto>>,
  TError,
  { data: BodyType<UploadInspectionPhotoDto> },
  TContext
> => {
  const mutationOptions =
    getReceiptInspectionPublicControllerUploadPhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사진 지우기
 */
export const receiptInspectionPublicControllerDeletePhoto = (
  photoId: string,
) => {
  return api<void>({
    url: `/receipt-inspections/link/photos/${photoId}`,
    method: "DELETE",
  });
};

export const getReceiptInspectionPublicControllerDeletePhotoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>,
    TError,
    { photoId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationKey = ["receiptInspectionPublicControllerDeletePhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>,
    { photoId: string }
  > = (props) => {
    const { photoId } = props ?? {};

    return receiptInspectionPublicControllerDeletePhoto(photoId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptInspectionPublicControllerDeletePhotoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>
  >;

export type ReceiptInspectionPublicControllerDeletePhotoMutationError =
  ErrorType<unknown>;

/**
 * @summary 사진 지우기
 */
export const useReceiptInspectionPublicControllerDeletePhoto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>,
      TError,
      { photoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerDeletePhoto>>,
  TError,
  { photoId: string },
  TContext
> => {
  const mutationOptions =
    getReceiptInspectionPublicControllerDeletePhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 줄 고치기(받은 수량 · 판정 · 다름 사유 · 바코드)
 */
export const receiptInspectionPublicControllerEditLine = (
  lineNo: number,
  editInspectionLineDto: BodyType<EditInspectionLineDto>,
) => {
  return api<void>({
    url: `/receipt-inspections/link/lines/${lineNo}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: editInspectionLineDto,
  });
};

export const getReceiptInspectionPublicControllerEditLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>,
    TError,
    { lineNo: number; data: BodyType<EditInspectionLineDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>,
  TError,
  { lineNo: number; data: BodyType<EditInspectionLineDto> },
  TContext
> => {
  const mutationKey = ["receiptInspectionPublicControllerEditLine"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>,
    { lineNo: number; data: BodyType<EditInspectionLineDto> }
  > = (props) => {
    const { lineNo, data } = props ?? {};

    return receiptInspectionPublicControllerEditLine(lineNo, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptInspectionPublicControllerEditLineMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>
  >;
export type ReceiptInspectionPublicControllerEditLineMutationBody =
  BodyType<EditInspectionLineDto>;
export type ReceiptInspectionPublicControllerEditLineMutationError =
  ErrorType<unknown>;

/**
 * @summary 줄 고치기(받은 수량 · 판정 · 다름 사유 · 바코드)
 */
export const useReceiptInspectionPublicControllerEditLine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>,
      TError,
      { lineNo: number; data: BodyType<EditInspectionLineDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerEditLine>>,
  TError,
  { lineNo: number; data: BodyType<EditInspectionLineDto> },
  TContext
> => {
  const mutationOptions =
    getReceiptInspectionPublicControllerEditLineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary «ERP 로 보내기» 확인번호 받기(받는 번호로 6자리, 10분)
 */
export const receiptInspectionPublicControllerSendCode = (
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/receipt-inspections/link/verify/send`,
    method: "POST",
    signal,
  });
};

export const getReceiptInspectionPublicControllerSendCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["receiptInspectionPublicControllerSendCode"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>,
    void
  > = () => {
    return receiptInspectionPublicControllerSendCode();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptInspectionPublicControllerSendCodeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>
  >;

export type ReceiptInspectionPublicControllerSendCodeMutationError =
  ErrorType<unknown>;

/**
 * @summary «ERP 로 보내기» 확인번호 받기(받는 번호로 6자리, 10분)
 */
export const useReceiptInspectionPublicControllerSendCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerSendCode>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getReceiptInspectionPublicControllerSendCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary «ERP 로 보내기» — 확인번호로 제출, 검수조서를 만들어 씨마켓 계약서류에 붙인다
 */
export const receiptInspectionPublicControllerSubmit = (
  submitInspectionDto: BodyType<SubmitInspectionDto>,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/receipt-inspections/link/submit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitInspectionDto,
    signal,
  });
};

export const getReceiptInspectionPublicControllerSubmitMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>,
    TError,
    { data: BodyType<SubmitInspectionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>,
  TError,
  { data: BodyType<SubmitInspectionDto> },
  TContext
> => {
  const mutationKey = ["receiptInspectionPublicControllerSubmit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>,
    { data: BodyType<SubmitInspectionDto> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptInspectionPublicControllerSubmit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptInspectionPublicControllerSubmitMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>
>;
export type ReceiptInspectionPublicControllerSubmitMutationBody =
  BodyType<SubmitInspectionDto>;
export type ReceiptInspectionPublicControllerSubmitMutationError =
  ErrorType<unknown>;

/**
 * @summary «ERP 로 보내기» — 확인번호로 제출, 검수조서를 만들어 씨마켓 계약서류에 붙인다
 */
export const useReceiptInspectionPublicControllerSubmit = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>,
      TError,
      { data: BodyType<SubmitInspectionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerSubmit>>,
  TError,
  { data: BodyType<SubmitInspectionDto> },
  TContext
> => {
  const mutationOptions =
    getReceiptInspectionPublicControllerSubmitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 제출한 검수조서 PDF(짧은 서명 주소)
 */
export const receiptInspectionPublicControllerReport = (
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/receipt-inspections/link/report`,
    method: "GET",
    signal,
  });
};

export const getReceiptInspectionPublicControllerReportQueryKey = () => {
  return [`/receipt-inspections/link/report`] as const;
};

export const getReceiptInspectionPublicControllerReportQueryOptions = <
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReceiptInspectionPublicControllerReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>
  > = ({ signal }) => receiptInspectionPublicControllerReport(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceiptInspectionPublicControllerReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>
>;
export type ReceiptInspectionPublicControllerReportQueryError =
  ErrorType<unknown>;

export function useReceiptInspectionPublicControllerReport<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
          TError,
          Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReceiptInspectionPublicControllerReport<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
          TError,
          Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReceiptInspectionPublicControllerReport<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 제출한 검수조서 PDF(짧은 서명 주소)
 */

export function useReceiptInspectionPublicControllerReport<
  TData = Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof receiptInspectionPublicControllerReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getReceiptInspectionPublicControllerReportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 씨마켓 «검수하기» — 그 낙찰 건의 살아 있는 검수 링크 { url, expiresAt }
 */
export const externalCmarketInspectionLinkControllerLink = (
  cmarketBidNo: string,
  winnerSeq: number,
  signal?: AbortSignal,
) => {
  return api<ExternalCmarketInspectionLinkControllerLink200>({
    url: `/external/cmarket/awards/${cmarketBidNo}/${winnerSeq}/inspection-link`,
    method: "POST",
    signal,
  });
};

export const getExternalCmarketInspectionLinkControllerLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>,
    TError,
    { cmarketBidNo: string; winnerSeq: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>,
  TError,
  { cmarketBidNo: string; winnerSeq: number },
  TContext
> => {
  const mutationKey = ["externalCmarketInspectionLinkControllerLink"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>,
    { cmarketBidNo: string; winnerSeq: number }
  > = (props) => {
    const { cmarketBidNo, winnerSeq } = props ?? {};

    return externalCmarketInspectionLinkControllerLink(cmarketBidNo, winnerSeq);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExternalCmarketInspectionLinkControllerLinkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>
  >;

export type ExternalCmarketInspectionLinkControllerLinkMutationError =
  ErrorType<unknown>;

/**
 * @summary 씨마켓 «검수하기» — 그 낙찰 건의 살아 있는 검수 링크 { url, expiresAt }
 */
export const useExternalCmarketInspectionLinkControllerLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>,
      TError,
      { cmarketBidNo: string; winnerSeq: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof externalCmarketInspectionLinkControllerLink>>,
  TError,
  { cmarketBidNo: string; winnerSeq: number },
  TContext
> => {
  const mutationOptions =
    getExternalCmarketInspectionLinkControllerLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
